(function () {
  "use strict";
  function wt(e) {
    return e &&
      e.__esModule &&
      Object.prototype.hasOwnProperty.call(e, "default")
      ? e.default
      : e;
  }
  var Sr = { exports: {} };
  /*! algoliasearch-lite.umd.js | 4.24.0 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */ var uu =
      Sr.exports,
    Ci;
  function cu() {
    return (
      Ci ||
        ((Ci = 1),
        (function (e, t) {
          (function (n, r) {
            e.exports = r();
          })(uu, function () {
            function n(x, F, E) {
              return (
                F in x
                  ? Object.defineProperty(x, F, {
                      value: E,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (x[F] = E),
                x
              );
            }
            function r(x, F) {
              var E = Object.keys(x);
              if (Object.getOwnPropertySymbols) {
                var I = Object.getOwnPropertySymbols(x);
                (F &&
                  (I = I.filter(function (D) {
                    return Object.getOwnPropertyDescriptor(x, D).enumerable;
                  })),
                  E.push.apply(E, I));
              }
              return E;
            }
            function i(x) {
              for (var F = 1; F < arguments.length; F++) {
                var E = arguments[F] != null ? arguments[F] : {};
                F % 2
                  ? r(Object(E), !0).forEach(function (I) {
                      n(x, I, E[I]);
                    })
                  : Object.getOwnPropertyDescriptors
                    ? Object.defineProperties(
                        x,
                        Object.getOwnPropertyDescriptors(E),
                      )
                    : r(Object(E)).forEach(function (I) {
                        Object.defineProperty(
                          x,
                          I,
                          Object.getOwnPropertyDescriptor(E, I),
                        );
                      });
              }
              return x;
            }
            function a(x, F) {
              if (x == null) return {};
              var E,
                I,
                D = (function (J, U) {
                  if (J == null) return {};
                  var ie,
                    fe,
                    oe = {},
                    ge = Object.keys(J);
                  for (fe = 0; fe < ge.length; fe++)
                    ((ie = ge[fe]), U.indexOf(ie) >= 0 || (oe[ie] = J[ie]));
                  return oe;
                })(x, F);
              if (Object.getOwnPropertySymbols) {
                var V = Object.getOwnPropertySymbols(x);
                for (I = 0; I < V.length; I++)
                  ((E = V[I]),
                    F.indexOf(E) >= 0 ||
                      (Object.prototype.propertyIsEnumerable.call(x, E) &&
                        (D[E] = x[E])));
              }
              return D;
            }
            function o(x, F) {
              return (
                (function (E) {
                  if (Array.isArray(E)) return E;
                })(x) ||
                (function (E, I) {
                  if (
                    Symbol.iterator in Object(E) ||
                    Object.prototype.toString.call(E) === "[object Arguments]"
                  ) {
                    var D = [],
                      V = !0,
                      J = !1,
                      U = void 0;
                    try {
                      for (
                        var ie, fe = E[Symbol.iterator]();
                        !(V = (ie = fe.next()).done) &&
                        (D.push(ie.value), !I || D.length !== I);
                        V = !0
                      );
                    } catch (oe) {
                      ((J = !0), (U = oe));
                    } finally {
                      try {
                        V || fe.return == null || fe.return();
                      } finally {
                        if (J) throw U;
                      }
                    }
                    return D;
                  }
                })(x, F) ||
                (function () {
                  throw new TypeError(
                    "Invalid attempt to destructure non-iterable instance",
                  );
                })()
              );
            }
            function s(x) {
              return (
                (function (F) {
                  if (Array.isArray(F)) {
                    for (var E = 0, I = new Array(F.length); E < F.length; E++)
                      I[E] = F[E];
                    return I;
                  }
                })(x) ||
                (function (F) {
                  if (
                    Symbol.iterator in Object(F) ||
                    Object.prototype.toString.call(F) === "[object Arguments]"
                  )
                    return Array.from(F);
                })(x) ||
                (function () {
                  throw new TypeError(
                    "Invalid attempt to spread non-iterable instance",
                  );
                })()
              );
            }
            function l(x) {
              var F,
                E = "algoliasearch-client-js-".concat(x.key),
                I = function () {
                  return (
                    F === void 0 && (F = x.localStorage || window.localStorage),
                    F
                  );
                },
                D = function () {
                  return JSON.parse(I().getItem(E) || "{}");
                },
                V = function (U) {
                  I().setItem(E, JSON.stringify(U));
                },
                J = function () {
                  var U = x.timeToLive ? 1e3 * x.timeToLive : null,
                    ie = D(),
                    fe = Object.fromEntries(
                      Object.entries(ie).filter(function (ge) {
                        return o(ge, 2)[1].timestamp !== void 0;
                      }),
                    );
                  if ((V(fe), U)) {
                    var oe = Object.fromEntries(
                      Object.entries(fe).filter(function (ge) {
                        var de = o(ge, 2)[1],
                          _e = new Date().getTime();
                        return !(de.timestamp + U < _e);
                      }),
                    );
                    V(oe);
                  }
                };
              return {
                get: function (U, ie) {
                  var fe =
                    arguments.length > 2 && arguments[2] !== void 0
                      ? arguments[2]
                      : {
                          miss: function () {
                            return Promise.resolve();
                          },
                        };
                  return Promise.resolve()
                    .then(function () {
                      J();
                      var oe = JSON.stringify(U);
                      return D()[oe];
                    })
                    .then(function (oe) {
                      return Promise.all([oe ? oe.value : ie(), oe !== void 0]);
                    })
                    .then(function (oe) {
                      var ge = o(oe, 2),
                        de = ge[0],
                        _e = ge[1];
                      return Promise.all([de, _e || fe.miss(de)]);
                    })
                    .then(function (oe) {
                      return o(oe, 1)[0];
                    });
                },
                set: function (U, ie) {
                  return Promise.resolve().then(function () {
                    var fe = D();
                    return (
                      (fe[JSON.stringify(U)] = {
                        timestamp: new Date().getTime(),
                        value: ie,
                      }),
                      I().setItem(E, JSON.stringify(fe)),
                      ie
                    );
                  });
                },
                delete: function (U) {
                  return Promise.resolve().then(function () {
                    var ie = D();
                    (delete ie[JSON.stringify(U)],
                      I().setItem(E, JSON.stringify(ie)));
                  });
                },
                clear: function () {
                  return Promise.resolve().then(function () {
                    I().removeItem(E);
                  });
                },
              };
            }
            function f(x) {
              var F = s(x.caches),
                E = F.shift();
              return E === void 0
                ? {
                    get: function (I, D) {
                      var V =
                          arguments.length > 2 && arguments[2] !== void 0
                            ? arguments[2]
                            : {
                                miss: function () {
                                  return Promise.resolve();
                                },
                              },
                        J = D();
                      return J.then(function (U) {
                        return Promise.all([U, V.miss(U)]);
                      }).then(function (U) {
                        return o(U, 1)[0];
                      });
                    },
                    set: function (I, D) {
                      return Promise.resolve(D);
                    },
                    delete: function (I) {
                      return Promise.resolve();
                    },
                    clear: function () {
                      return Promise.resolve();
                    },
                  }
                : {
                    get: function (I, D) {
                      var V =
                        arguments.length > 2 && arguments[2] !== void 0
                          ? arguments[2]
                          : {
                              miss: function () {
                                return Promise.resolve();
                              },
                            };
                      return E.get(I, D, V).catch(function () {
                        return f({ caches: F }).get(I, D, V);
                      });
                    },
                    set: function (I, D) {
                      return E.set(I, D).catch(function () {
                        return f({ caches: F }).set(I, D);
                      });
                    },
                    delete: function (I) {
                      return E.delete(I).catch(function () {
                        return f({ caches: F }).delete(I);
                      });
                    },
                    clear: function () {
                      return E.clear().catch(function () {
                        return f({ caches: F }).clear();
                      });
                    },
                  };
            }
            function m() {
              var x =
                  arguments.length > 0 && arguments[0] !== void 0
                    ? arguments[0]
                    : { serializable: !0 },
                F = {};
              return {
                get: function (E, I) {
                  var D =
                      arguments.length > 2 && arguments[2] !== void 0
                        ? arguments[2]
                        : {
                            miss: function () {
                              return Promise.resolve();
                            },
                          },
                    V = JSON.stringify(E);
                  if (V in F)
                    return Promise.resolve(
                      x.serializable ? JSON.parse(F[V]) : F[V],
                    );
                  var J = I(),
                    U =
                      (D && D.miss) ||
                      function () {
                        return Promise.resolve();
                      };
                  return J.then(function (ie) {
                    return U(ie);
                  }).then(function () {
                    return J;
                  });
                },
                set: function (E, I) {
                  return (
                    (F[JSON.stringify(E)] = x.serializable
                      ? JSON.stringify(I)
                      : I),
                    Promise.resolve(I)
                  );
                },
                delete: function (E) {
                  return (delete F[JSON.stringify(E)], Promise.resolve());
                },
                clear: function () {
                  return ((F = {}), Promise.resolve());
                },
              };
            }
            function d(x) {
              for (var F = x.length - 1; F > 0; F--) {
                var E = Math.floor(Math.random() * (F + 1)),
                  I = x[F];
                ((x[F] = x[E]), (x[E] = I));
              }
              return x;
            }
            function p(x, F) {
              return (
                F &&
                  Object.keys(F).forEach(function (E) {
                    x[E] = F[E](x);
                  }),
                x
              );
            }
            function u(x) {
              for (
                var F = arguments.length,
                  E = new Array(F > 1 ? F - 1 : 0),
                  I = 1;
                I < F;
                I++
              )
                E[I - 1] = arguments[I];
              var D = 0;
              return x.replace(/%s/g, function () {
                return encodeURIComponent(E[D++]);
              });
            }
            var c = { WithinQueryParameters: 0, WithinHeaders: 1 };
            function g(x, F) {
              var E = x || {},
                I = E.data || {};
              return (
                Object.keys(E).forEach(function (D) {
                  [
                    "timeout",
                    "headers",
                    "queryParameters",
                    "data",
                    "cacheable",
                  ].indexOf(D) === -1 && (I[D] = E[D]);
                }),
                {
                  data: Object.entries(I).length > 0 ? I : void 0,
                  timeout: E.timeout || F,
                  headers: E.headers || {},
                  queryParameters: E.queryParameters || {},
                  cacheable: E.cacheable,
                }
              );
            }
            var v = { Read: 1, Write: 2, Any: 3 },
              h = 1,
              b = 2,
              S = 3;
            function O(x) {
              var F =
                arguments.length > 1 && arguments[1] !== void 0
                  ? arguments[1]
                  : h;
              return i(i({}, x), {}, { status: F, lastUpdate: Date.now() });
            }
            function _(x) {
              return typeof x == "string"
                ? { protocol: "https", url: x, accept: v.Any }
                : {
                    protocol: x.protocol || "https",
                    url: x.url,
                    accept: x.accept || v.Any,
                  };
            }
            var R = "GET",
              $ = "POST";
            function y(x, F) {
              return Promise.all(
                F.map(function (E) {
                  return x.get(E, function () {
                    return Promise.resolve(O(E));
                  });
                }),
              ).then(function (E) {
                var I = E.filter(function (J) {
                    return (function (U) {
                      return U.status === h || Date.now() - U.lastUpdate > 12e4;
                    })(J);
                  }),
                  D = E.filter(function (J) {
                    return (function (U) {
                      return (
                        U.status === S && Date.now() - U.lastUpdate <= 12e4
                      );
                    })(J);
                  }),
                  V = [].concat(s(I), s(D));
                return {
                  getTimeout: function (J, U) {
                    return (
                      (D.length === 0 && J === 0 ? 1 : D.length + 3 + J) * U
                    );
                  },
                  statelessHosts:
                    V.length > 0
                      ? V.map(function (J) {
                          return _(J);
                        })
                      : F,
                };
              });
            }
            function P(x, F, E, I) {
              var D = [],
                V = (function (de, _e) {
                  if (
                    !(
                      de.method === R ||
                      (de.data === void 0 && _e.data === void 0)
                    )
                  ) {
                    var le = Array.isArray(de.data)
                      ? de.data
                      : i(i({}, de.data), _e.data);
                    return JSON.stringify(le);
                  }
                })(E, I),
                J = (function (de, _e) {
                  var le = i(i({}, de.headers), _e.headers),
                    be = {};
                  return (
                    Object.keys(le).forEach(function (ke) {
                      var Ee = le[ke];
                      be[ke.toLowerCase()] = Ee;
                    }),
                    be
                  );
                })(x, I),
                U = E.method,
                ie = E.method !== R ? {} : i(i({}, E.data), I.data),
                fe = i(
                  i(
                    i(
                      { "x-algolia-agent": x.userAgent.value },
                      x.queryParameters,
                    ),
                    ie,
                  ),
                  I.queryParameters,
                ),
                oe = 0,
                ge = function de(_e, le) {
                  var be = _e.pop();
                  if (be === void 0)
                    throw {
                      name: "RetryError",
                      message:
                        "Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support .",
                      transporterStackTrace: N(D),
                    };
                  var ke = {
                      data: V,
                      headers: J,
                      method: U,
                      url: j(be, E.path, fe),
                      connectTimeout: le(oe, x.timeouts.connect),
                      responseTimeout: le(oe, I.timeout),
                    },
                    Ee = function (pe) {
                      var ue = {
                        request: ke,
                        response: pe,
                        host: be,
                        triesLeft: _e.length,
                      };
                      return (D.push(ue), ue);
                    },
                    Kr = {
                      onSuccess: function (pe) {
                        return (function (ue) {
                          try {
                            return JSON.parse(ue.content);
                          } catch (De) {
                            throw (function (Ye, Ot) {
                              return {
                                name: "DeserializationError",
                                message: Ye,
                                response: Ot,
                              };
                            })(De.message, ue);
                          }
                        })(pe);
                      },
                      onRetry: function (pe) {
                        var ue = Ee(pe);
                        return (
                          pe.isTimedOut && oe++,
                          Promise.all([
                            x.logger.info("Retryable failure", Q(ue)),
                            x.hostsCache.set(be, O(be, pe.isTimedOut ? S : b)),
                          ]).then(function () {
                            return de(_e, le);
                          })
                        );
                      },
                      onFail: function (pe) {
                        throw (
                          Ee(pe),
                          (function (ue, De) {
                            var Ye = ue.content,
                              Ot = ue.status,
                              br = Ye;
                            try {
                              br = JSON.parse(Ye).message;
                            } catch {}
                            return (function (zr, Ni, Bm) {
                              return {
                                name: "ApiError",
                                message: zr,
                                status: Ni,
                                transporterStackTrace: Bm,
                              };
                            })(br, Ot, De);
                          })(pe, N(D))
                        );
                      },
                    };
                  return x.requester.send(ke).then(function (pe) {
                    return (function (ue, De) {
                      return (function (Ye) {
                        var Ot = Ye.status;
                        return (
                          Ye.isTimedOut ||
                          (function (br) {
                            var zr = br.isTimedOut,
                              Ni = br.status;
                            return !zr && ~~Ni == 0;
                          })(Ye) ||
                          (~~(Ot / 100) != 2 && ~~(Ot / 100) != 4)
                        );
                      })(ue)
                        ? De.onRetry(ue)
                        : ~~(ue.status / 100) == 2
                          ? De.onSuccess(ue)
                          : De.onFail(ue);
                    })(pe, Kr);
                  });
                };
              return y(x.hostsCache, F).then(function (de) {
                return ge(s(de.statelessHosts).reverse(), de.getTimeout);
              });
            }
            function w(x) {
              var F = {
                value: "Algolia for JavaScript (".concat(x, ")"),
                add: function (E) {
                  var I = "; "
                    .concat(E.segment)
                    .concat(
                      E.version !== void 0 ? " (".concat(E.version, ")") : "",
                    );
                  return (
                    F.value.indexOf(I) === -1 &&
                      (F.value = "".concat(F.value).concat(I)),
                    F
                  );
                },
              };
              return F;
            }
            function j(x, F, E) {
              var I = T(E),
                D = ""
                  .concat(x.protocol, "://")
                  .concat(x.url, "/")
                  .concat(F.charAt(0) === "/" ? F.substr(1) : F);
              return (I.length && (D += "?".concat(I)), D);
            }
            function T(x) {
              return Object.keys(x)
                .map(function (F) {
                  return u(
                    "%s=%s",
                    F,
                    ((E = x[F]),
                    Object.prototype.toString.call(E) === "[object Object]" ||
                    Object.prototype.toString.call(E) === "[object Array]"
                      ? JSON.stringify(x[F])
                      : x[F]),
                  );
                  var E;
                })
                .join("&");
            }
            function N(x) {
              return x.map(function (F) {
                return Q(F);
              });
            }
            function Q(x) {
              var F = x.request.headers["x-algolia-api-key"]
                ? { "x-algolia-api-key": "*****" }
                : {};
              return i(
                i({}, x),
                {},
                {
                  request: i(
                    i({}, x.request),
                    {},
                    { headers: i(i({}, x.request.headers), F) },
                  ),
                },
              );
            }
            var W = function (x) {
                var F = x.appId,
                  E = (function (D, V, J) {
                    var U = {
                      "x-algolia-api-key": J,
                      "x-algolia-application-id": V,
                    };
                    return {
                      headers: function () {
                        return D === c.WithinHeaders ? U : {};
                      },
                      queryParameters: function () {
                        return D === c.WithinQueryParameters ? U : {};
                      },
                    };
                  })(
                    x.authMode !== void 0 ? x.authMode : c.WithinHeaders,
                    F,
                    x.apiKey,
                  ),
                  I = (function (D) {
                    var V = D.hostsCache,
                      J = D.logger,
                      U = D.requester,
                      ie = D.requestsCache,
                      fe = D.responsesCache,
                      oe = D.timeouts,
                      ge = D.userAgent,
                      de = D.hosts,
                      _e = D.queryParameters,
                      le = {
                        hostsCache: V,
                        logger: J,
                        requester: U,
                        requestsCache: ie,
                        responsesCache: fe,
                        timeouts: oe,
                        userAgent: ge,
                        headers: D.headers,
                        queryParameters: _e,
                        hosts: de.map(function (be) {
                          return _(be);
                        }),
                        read: function (be, ke) {
                          var Ee = g(ke, le.timeouts.read),
                            Kr = function () {
                              return P(
                                le,
                                le.hosts.filter(function (ue) {
                                  return (ue.accept & v.Read) != 0;
                                }),
                                be,
                                Ee,
                              );
                            };
                          if (
                            (Ee.cacheable !== void 0
                              ? Ee.cacheable
                              : be.cacheable) !== !0
                          )
                            return Kr();
                          var pe = {
                            request: be,
                            mappedRequestOptions: Ee,
                            transporter: {
                              queryParameters: le.queryParameters,
                              headers: le.headers,
                            },
                          };
                          return le.responsesCache.get(
                            pe,
                            function () {
                              return le.requestsCache.get(pe, function () {
                                return le.requestsCache
                                  .set(pe, Kr())
                                  .then(
                                    function (ue) {
                                      return Promise.all([
                                        le.requestsCache.delete(pe),
                                        ue,
                                      ]);
                                    },
                                    function (ue) {
                                      return Promise.all([
                                        le.requestsCache.delete(pe),
                                        Promise.reject(ue),
                                      ]);
                                    },
                                  )
                                  .then(function (ue) {
                                    var De = o(ue, 2);
                                    return (De[0], De[1]);
                                  });
                              });
                            },
                            {
                              miss: function (ue) {
                                return le.responsesCache.set(pe, ue);
                              },
                            },
                          );
                        },
                        write: function (be, ke) {
                          return P(
                            le,
                            le.hosts.filter(function (Ee) {
                              return (Ee.accept & v.Write) != 0;
                            }),
                            be,
                            g(ke, le.timeouts.write),
                          );
                        },
                      };
                    return le;
                  })(
                    i(
                      i(
                        {
                          hosts: [
                            {
                              url: "".concat(F, "-dsn.algolia.net"),
                              accept: v.Read,
                            },
                            {
                              url: "".concat(F, ".algolia.net"),
                              accept: v.Write,
                            },
                          ].concat(
                            d([
                              { url: "".concat(F, "-1.algolianet.com") },
                              { url: "".concat(F, "-2.algolianet.com") },
                              { url: "".concat(F, "-3.algolianet.com") },
                            ]),
                          ),
                        },
                        x,
                      ),
                      {},
                      {
                        headers: i(
                          i(i({}, E.headers()), {
                            "content-type": "application/x-www-form-urlencoded",
                          }),
                          x.headers,
                        ),
                        queryParameters: i(
                          i({}, E.queryParameters()),
                          x.queryParameters,
                        ),
                      },
                    ),
                  );
                return p(
                  {
                    transporter: I,
                    appId: F,
                    addAlgoliaAgent: function (D, V) {
                      I.userAgent.add({ segment: D, version: V });
                    },
                    clearCache: function () {
                      return Promise.all([
                        I.requestsCache.clear(),
                        I.responsesCache.clear(),
                      ]).then(function () {});
                    },
                  },
                  x.methods,
                );
              },
              G = function (x) {
                return function (F, E) {
                  return F.method === R
                    ? x.transporter.read(F, E)
                    : x.transporter.write(F, E);
                };
              },
              B = function (x) {
                return function (F) {
                  var E =
                      arguments.length > 1 && arguments[1] !== void 0
                        ? arguments[1]
                        : {},
                    I = {
                      transporter: x.transporter,
                      appId: x.appId,
                      indexName: F,
                    };
                  return p(I, E.methods);
                };
              },
              A = function (x) {
                return function (F, E) {
                  var I = F.map(function (D) {
                    return i(i({}, D), {}, { params: T(D.params || {}) });
                  });
                  return x.transporter.read(
                    {
                      method: $,
                      path: "1/indexes/*/queries",
                      data: { requests: I },
                      cacheable: !0,
                    },
                    E,
                  );
                };
              },
              C = function (x) {
                return function (F, E) {
                  return Promise.all(
                    F.map(function (I) {
                      var D = I.params,
                        V = D.facetName,
                        J = D.facetQuery,
                        U = a(D, ["facetName", "facetQuery"]);
                      return B(x)(I.indexName, {
                        methods: { searchForFacetValues: K },
                      }).searchForFacetValues(V, J, i(i({}, E), U));
                    }),
                  );
                };
              },
              q = function (x) {
                return function (F, E, I) {
                  return x.transporter.read(
                    {
                      method: $,
                      path: u("1/answers/%s/prediction", x.indexName),
                      data: { query: F, queryLanguages: E },
                      cacheable: !0,
                    },
                    I,
                  );
                };
              },
              M = function (x) {
                return function (F, E) {
                  return x.transporter.read(
                    {
                      method: $,
                      path: u("1/indexes/%s/query", x.indexName),
                      data: { query: F },
                      cacheable: !0,
                    },
                    E,
                  );
                };
              },
              K = function (x) {
                return function (F, E, I) {
                  return x.transporter.read(
                    {
                      method: $,
                      path: u("1/indexes/%s/facets/%s/query", x.indexName, F),
                      data: { facetQuery: E },
                      cacheable: !0,
                    },
                    I,
                  );
                };
              },
              Y = 1,
              Z = 2,
              k = 3,
              z = function (x) {
                return function (F, E) {
                  var I = F.map(function (D) {
                    return i(i({}, D), {}, { threshold: D.threshold || 0 });
                  });
                  return x.transporter.read(
                    {
                      method: $,
                      path: "1/indexes/*/recommendations",
                      data: { requests: I },
                      cacheable: !0,
                    },
                    E,
                  );
                };
              };
            function ee(x, F, E) {
              var I,
                D = {
                  appId: x,
                  apiKey: F,
                  timeouts: { connect: 1, read: 2, write: 30 },
                  requester: {
                    send: function (V) {
                      return new Promise(function (J) {
                        var U = new XMLHttpRequest();
                        (U.open(V.method, V.url, !0),
                          Object.keys(V.headers).forEach(function (ge) {
                            return U.setRequestHeader(ge, V.headers[ge]);
                          }));
                        var ie,
                          fe = function (ge, de) {
                            return setTimeout(function () {
                              (U.abort(),
                                J({ status: 0, content: de, isTimedOut: !0 }));
                            }, 1e3 * ge);
                          },
                          oe = fe(V.connectTimeout, "Connection timeout");
                        ((U.onreadystatechange = function () {
                          U.readyState > U.OPENED &&
                            ie === void 0 &&
                            (clearTimeout(oe),
                            (ie = fe(V.responseTimeout, "Socket timeout")));
                        }),
                          (U.onerror = function () {
                            U.status === 0 &&
                              (clearTimeout(oe),
                              clearTimeout(ie),
                              J({
                                content:
                                  U.responseText || "Network request failed",
                                status: U.status,
                                isTimedOut: !1,
                              }));
                          }),
                          (U.onload = function () {
                            (clearTimeout(oe),
                              clearTimeout(ie),
                              J({
                                content: U.responseText,
                                status: U.status,
                                isTimedOut: !1,
                              }));
                          }),
                          U.send(V.data));
                      });
                    },
                  },
                  logger:
                    ((I = k),
                    {
                      debug: function (V, J) {
                        return (
                          Y >= I && console.debug(V, J),
                          Promise.resolve()
                        );
                      },
                      info: function (V, J) {
                        return (
                          Z >= I && console.info(V, J),
                          Promise.resolve()
                        );
                      },
                      error: function (V, J) {
                        return (console.error(V, J), Promise.resolve());
                      },
                    }),
                  responsesCache: m(),
                  requestsCache: m({ serializable: !1 }),
                  hostsCache: f({
                    caches: [
                      l({ key: "".concat("4.24.0", "-").concat(x) }),
                      m(),
                    ],
                  }),
                  userAgent: w("4.24.0").add({
                    segment: "Browser",
                    version: "lite",
                  }),
                  authMode: c.WithinQueryParameters,
                };
              return W(
                i(
                  i(i({}, D), E),
                  {},
                  {
                    methods: {
                      search: A,
                      searchForFacetValues: C,
                      multipleQueries: A,
                      multipleSearchForFacetValues: C,
                      customRequest: G,
                      initIndex: function (V) {
                        return function (J) {
                          return B(V)(J, {
                            methods: {
                              search: M,
                              searchForFacetValues: K,
                              findAnswers: q,
                            },
                          });
                        };
                      },
                      getRecommendations: z,
                    },
                  },
                ),
              );
            }
            return ((ee.version = "4.24.0"), ee);
          });
        })(Sr)),
      Sr.exports
    );
  }
  var lu = cu();
  const fu = wt(lu);
  var hu = "ais",
    Qe = function (t) {
      return function () {
        var n =
            arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          r = n.descendantName,
          i = n.modifierName,
          a = r ? "-".concat(r) : "",
          o = i ? "--".concat(i) : "";
        return "".concat(hu, "-").concat(t).concat(a).concat(o);
      };
    },
    du = 0;
  function pu(e) {
    e.dependsOn === "recommend" && (e.$$id = du++);
  }
  function he() {}
  var Rt = function (t, n) {
    return t;
  };
  function mu(e) {
    return Object.prototype.toString.call(e).slice(8, -1);
  }
  function jt(e, t) {
    if (e === void 0 || typeof e != "function")
      throw new Error(
        "The render function is not valid (received type "
          .concat(
            mu(e),
            `).

`,
          )
          .concat(t),
      );
  }
  var gu = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    },
    Ai = /[&<>"']/g,
    vu = RegExp(Ai.source);
  function yu(e) {
    return e && vu.test(e)
      ? e.replace(Ai, function (t) {
          return gu[t];
        })
      : e;
  }
  var bu = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'",
    },
    Di = /&(amp|quot|lt|gt|#39);/g,
    Su = RegExp(Di.source);
  function $t(e) {
    return e && Su.test(e)
      ? e.replace(Di, function (t) {
          return bu[t];
        })
      : e;
  }
  function Jr(e) {
    "@babel/helpers - typeof";
    return (
      (Jr =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Jr(e)
    );
  }
  function Pu(e) {
    return e === null
      ? e === void 0
        ? "[object Undefined]"
        : "[object Null]"
      : Object.prototype.toString.call(e);
  }
  function _u(e) {
    return Jr(e) === "object" && e !== null;
  }
  function Hi(e) {
    if (!_u(e) || Pu(e) !== "[object Object]") return !1;
    if (Object.getPrototypeOf(e) === null) return !0;
    for (var t = e; Object.getPrototypeOf(t) !== null; )
      t = Object.getPrototypeOf(t);
    return Object.getPrototypeOf(e) === t;
  }
  function xt(e) {
    "@babel/helpers - typeof";
    return (
      (xt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      xt(e)
    );
  }
  function Ou(e) {
    if (e == null) throw new TypeError("Cannot destructure " + e);
  }
  function Gr() {
    return (
      (Gr = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      Gr.apply(this, arguments)
    );
  }
  function Li(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function it(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Li(Object(n), !0).forEach(function (r) {
            Mi(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Li(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Mi(e, t, n) {
    return (
      (t = wu(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function wu(e) {
    var t = Ru(e, "string");
    return xt(t) == "symbol" ? t : String(t);
  }
  function Ru(e, t) {
    if (xt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (xt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var at = {
      highlightPreTag: "__ais-highlight__",
      highlightPostTag: "__/ais-highlight__",
    },
    ve = { highlightPreTag: "<mark>", highlightPostTag: "</mark>" };
  function Wi(e) {
    return yu(e)
      .replace(new RegExp(at.highlightPreTag, "g"), ve.highlightPreTag)
      .replace(new RegExp(at.highlightPostTag, "g"), ve.highlightPostTag);
  }
  function Pr(e) {
    return Hi(e) && typeof e.value != "string"
      ? Object.keys(e).reduce(function (t, n) {
          return it(it({}, t), {}, Mi({}, n, Pr(e[n])));
        }, {})
      : Array.isArray(e)
        ? e.map(Pr)
        : it(it({}, e), {}, { value: Wi(e.value) });
  }
  function ju(e) {
    return (
      e.__escaped === void 0 &&
        ((e = e.map(function (t) {
          var n = Gr({}, (Ou(t), t));
          return (
            n._highlightResult && (n._highlightResult = Pr(n._highlightResult)),
            n._snippetResult && (n._snippetResult = Pr(n._snippetResult)),
            n
          );
        })),
        (e.__escaped = !0)),
      e
    );
  }
  function $u(e) {
    return e.map(function (t) {
      return it(it({}, t), {}, { highlighted: Wi(t.highlighted) });
    });
  }
  function qi(e) {
    var t = ve.highlightPreTag,
      n = ve.highlightPostTag;
    return e
      .map(function (r) {
        return r.isHighlighted ? t + r.value + n : r.value;
      })
      .join("");
  }
  function xu(e, t, n) {
    return e.state.isHierarchicalFacet(t)
      ? e.state.isHierarchicalFacetRefined(t, n)
      : e.state.isConjunctiveFacet(t)
        ? e.state.isFacetRefined(t, n)
        : e.state.isDisjunctiveFacetRefined(t, n);
  }
  function Ui(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Fu(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Ui(Object(n), !0).forEach(function (r) {
            Eu(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Ui(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Eu(e, t, n) {
    return (
      (t = Tu(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Tu(e) {
    var t = Iu(e, "string");
    return st(t) == "symbol" ? t : String(t);
  }
  function Iu(e, t) {
    if (st(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (st(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function st(e) {
    "@babel/helpers - typeof";
    return (
      (st =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      st(e)
    );
  }
  function Nu(e, t) {
    return Hu(e) || Du(e, t) || Au(e, t) || Cu();
  }
  function Cu() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Au(e, t) {
    if (e) {
      if (typeof e == "string") return ki(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return ki(e, t);
    }
  }
  function ki(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Du(e, t) {
    var n =
      e == null
        ? null
        : (typeof Symbol < "u" && e[Symbol.iterator]) || e["@@iterator"];
    if (n != null) {
      var r,
        i,
        a,
        o,
        s = [],
        l = !0,
        f = !1;
      try {
        if (((a = (n = n.call(e)).next), t !== 0))
          for (
            ;
            !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== t);
            l = !0
          );
      } catch (m) {
        ((f = !0), (i = m));
      } finally {
        try {
          if (!l && n.return != null && ((o = n.return()), Object(o) !== o))
            return;
        } finally {
          if (f) throw i;
        }
      }
      return s;
    }
  }
  function Hu(e) {
    if (Array.isArray(e)) return e;
  }
  function Lu(e) {
    var t = e.instantSearchInstance,
      n = e.helper,
      r = e.attribute,
      i = e.widgetType,
      a = function () {
        for (var s = arguments.length, l = new Array(s), f = 0; f < s; f++)
          l[f] = arguments[f];
        var m = l[1],
          d = l[2],
          p = d === void 0 ? "Filter Applied" : d,
          u = l[3],
          c = u === void 0 ? {} : u,
          g = l[0].split(":"),
          v = Nu(g, 2),
          h = v[0],
          b = v[1],
          S = typeof r == "string" ? r : r(m);
        if (l.length === 1 && st(l[0]) === "object")
          t.sendEventToInsights(l[0]);
        else if (
          h === "click" &&
          l.length >= 2 &&
          l.length <= 4 &&
          !xu(n, S, m)
        ) {
          var O;
          t.sendEventToInsights({
            insightsMethod: "clickedFilters",
            widgetType: i,
            eventType: h,
            eventModifier: b,
            payload: Fu(
              {
                eventName: p,
                index:
                  ((O = n.lastResults) === null || O === void 0
                    ? void 0
                    : O.index) || n.state.index,
                filters: ["".concat(S, ":").concat(m)],
              },
              c,
            ),
            attribute: S,
          });
        }
      };
    return a;
  }
  function Qi(e) {
    return btoa(encodeURIComponent(JSON.stringify(e)));
  }
  function Bi(e) {
    return JSON.parse(decodeURIComponent(atob(e)));
  }
  function Vi(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Yr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Vi(Object(n), !0).forEach(function (r) {
            Mu(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Vi(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Mu(e, t, n) {
    return (
      (t = Wu(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Wu(e) {
    var t = qu(e, "string");
    return ot(t) == "symbol" ? t : String(t);
  }
  function qu(e, t) {
    if (ot(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (ot(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Uu(e, t) {
    return Vu(e) || Bu(e, t) || Qu(e, t) || ku();
  }
  function ku() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Qu(e, t) {
    if (e) {
      if (typeof e == "string") return Ki(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return Ki(e, t);
    }
  }
  function Ki(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Bu(e, t) {
    var n =
      e == null
        ? null
        : (typeof Symbol < "u" && e[Symbol.iterator]) || e["@@iterator"];
    if (n != null) {
      var r,
        i,
        a,
        o,
        s = [],
        l = !0,
        f = !1;
      try {
        if (((a = (n = n.call(e)).next), t !== 0))
          for (
            ;
            !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== t);
            l = !0
          );
      } catch (m) {
        ((f = !0), (i = m));
      } finally {
        try {
          if (!l && n.return != null && ((o = n.return()), Object(o) !== o))
            return;
        } finally {
          if (f) throw i;
        }
      }
      return s;
    }
  }
  function Vu(e) {
    if (Array.isArray(e)) return e;
  }
  function ot(e) {
    "@babel/helpers - typeof";
    return (
      (ot =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      ot(e)
    );
  }
  function Ku(e) {
    for (
      var t =
          arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20,
        n = [],
        r = 0;
      r < Math.ceil(e.length / t);
      r++
    )
      n.push(e.slice(r * t, (r + 1) * t));
    return n;
  }
  function zi(e) {
    var t = e.helper,
      n = e.widgetType;
    e.methodName;
    var r = e.args,
      i = e.instantSearchInstance;
    if (r.length === 1 && ot(r[0]) === "object") return [r[0]];
    var a = r[0].split(":"),
      o = Uu(a, 2),
      s = o[0],
      l = o[1],
      f = r[1],
      m = r[2],
      d = r[3] || {};
    if (!f) return [];
    if ((s === "click" || s === "conversion") && !m) return [];
    var p = Array.isArray(f) ? f : [f];
    if (p.length === 0) return [];
    var u = p[0].__queryID,
      c = Ku(p),
      g = c.map(function (h) {
        return h.map(function (b) {
          return b.objectID;
        });
      }),
      v = c.map(function (h) {
        return h.map(function (b) {
          return b.__position;
        });
      });
    return s === "view"
      ? i.status !== "idle"
        ? []
        : c.map(function (h, b) {
            var S;
            return {
              insightsMethod: "viewedObjectIDs",
              widgetType: n,
              eventType: s,
              payload: Yr(
                {
                  eventName: m || "Hits Viewed",
                  index:
                    ((S = t.lastResults) === null || S === void 0
                      ? void 0
                      : S.index) || t.state.index,
                  objectIDs: g[b],
                },
                d,
              ),
              hits: h,
              eventModifier: l,
            };
          })
      : s === "click"
        ? c.map(function (h, b) {
            var S;
            return {
              insightsMethod: "clickedObjectIDsAfterSearch",
              widgetType: n,
              eventType: s,
              payload: Yr(
                {
                  eventName: m || "Hit Clicked",
                  index:
                    ((S = t.lastResults) === null || S === void 0
                      ? void 0
                      : S.index) || t.state.index,
                  queryID: u,
                  objectIDs: g[b],
                  positions: v[b],
                },
                d,
              ),
              hits: h,
              eventModifier: l,
            };
          })
        : s === "conversion"
          ? c.map(function (h, b) {
              var S;
              return {
                insightsMethod: "convertedObjectIDsAfterSearch",
                widgetType: n,
                eventType: s,
                payload: Yr(
                  {
                    eventName: m || "Hit Converted",
                    index:
                      ((S = t.lastResults) === null || S === void 0
                        ? void 0
                        : S.index) || t.state.index,
                    queryID: u,
                    objectIDs: g[b],
                  },
                  d,
                ),
                hits: h,
                eventModifier: l,
              };
            })
          : [];
  }
  function zu(e) {
    var t = e.instantSearchInstance,
      n = e.helper,
      r = e.widgetType,
      i = {},
      a = void 0,
      o = function () {
        for (var l = arguments.length, f = new Array(l), m = 0; m < l; m++)
          f[m] = arguments[m];
        var d = zi({
          widgetType: r,
          helper: n,
          methodName: "sendEvent",
          args: f,
          instantSearchInstance: t,
        });
        (d.forEach(function (p) {
          (p.eventType === "click" &&
            p.eventModifier === "internal" &&
            i[p.eventType]) ||
            ((i[p.eventType] = !0), t.sendEventToInsights(p));
        }),
          clearTimeout(a),
          (a = setTimeout(function () {
            i = {};
          }, 0)));
      };
    return o;
  }
  function Ju(e) {
    var t = e.helper,
      n = e.widgetType,
      r = e.instantSearchInstance,
      i = function () {
        for (var o = arguments.length, s = new Array(o), l = 0; l < o; l++)
          s[l] = arguments[l];
        var f = zi({
          widgetType: n,
          helper: t,
          methodName: "bindEvent",
          args: s,
          instantSearchInstance: r,
        });
        return f.length ? "data-insights-event=".concat(Qi(f)) : "";
      };
    return i;
  }
  function Re(e) {
    return e.$$type === "ais.index";
  }
  function Xr(e, t) {
    var n = e[t.getIndexId()] || {};
    (t
      .getHelper()
      .setState(
        t.getWidgetSearchParameters(t.getHelper().state, { uiState: n }),
      ),
      t
        .getWidgets()
        .filter(Re)
        .forEach(function (r) {
          return Xr(e, r);
        }));
  }
  var Gu = Promise.resolve();
  function Ft(e) {
    var t = null,
      n = !1,
      r = function () {
        for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++)
          o[s] = arguments[s];
        t === null &&
          (t = Gu.then(function () {
            if (((t = null), n)) {
              n = !1;
              return;
            }
            e.apply(void 0, o);
          }));
      };
    return (
      (r.wait = function () {
        if (t === null)
          throw new Error(
            "The deferred function should be called before calling `wait()`",
          );
        return t;
      }),
      (r.cancel = function () {
        t !== null && (n = !0);
      }),
      r
    );
  }
  function Yu(e) {
    var t = e.name,
      n = e.connector,
      r = n === void 0 ? !1 : n;
    return [
      "https://www.algolia.com/doc/api-reference/widgets/",
      t,
      "/js/",
      r ? "#connector" : "",
    ].join("");
  }
  function Oe() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    var r = t
      .map(function (i) {
        return Yu(i);
      })
      .join(", ");
    return function (i) {
      return [i, "See documentation: ".concat(r)].filter(Boolean).join(`

`);
    };
  }
  function _r(e, t) {
    for (var n, r = 0; r < e.length; r++)
      if (((n = e[r]), t(n, r, e))) return n;
  }
  function Xu(e, t) {
    if (!Array.isArray(e)) return -1;
    for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
    return -1;
  }
  function Ji(e) {
    if (e.appId && e.apiKey) return [e.appId, e.apiKey];
    if (e.transporter) {
      var t = e.transporter,
        n = t.headers || t.baseHeaders,
        r = t.queryParameters || t.baseQueryParameters,
        i = "x-algolia-application-id",
        a = "x-algolia-api-key",
        o = n[i] || r[i],
        s = n[a] || r[a];
      return [o, s];
    } else return [e.applicationID, e.apiKey];
  }
  function Zu(e) {
    return e instanceof HTMLElement || (!!e && e.nodeType > 0);
  }
  function Et(e) {
    var t = typeof e == "string",
      n = t ? document.querySelector(e) : e;
    if (!Zu(n)) {
      var r = "Container must be `string` or `HTMLElement`.";
      throw (t && (r += " Unable to find ".concat(e)), new Error(r));
    }
    return n;
  }
  function ut(e) {
    var t = ve.highlightPostTag,
      n = ve.highlightPreTag,
      r = e.split(n),
      i = r.shift(),
      a = i ? [{ value: i, isHighlighted: !1 }] : [];
    return (
      r.forEach(function (o) {
        var s = o.split(t);
        (a.push({ value: s[0], isHighlighted: !0 }),
          s[1] !== "" && a.push({ value: s[1], isHighlighted: !1 }));
      }),
      a
    );
  }
  var ec = new RegExp(/\w/i);
  function tc(e, t) {
    var n,
      r,
      i = e[t],
      a =
        ((n = e[t + 1]) === null || n === void 0 ? void 0 : n.isHighlighted) ||
        !0,
      o =
        ((r = e[t - 1]) === null || r === void 0 ? void 0 : r.isHighlighted) ||
        !0;
    return !ec.test($t(i.value)) && o === a ? o : i.isHighlighted;
  }
  function Be(e, t) {
    var n = Array.isArray(t) ? t : t.split(".");
    return n.reduce(function (r, i) {
      return r && r[i];
    }, e);
  }
  function Tt(e) {
    "@babel/helpers - typeof";
    return (
      (Tt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Tt(e)
    );
  }
  function Gi(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Yi(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Gi(Object(n), !0).forEach(function (r) {
            rc(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Gi(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function rc(e, t, n) {
    return (
      (t = nc(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function nc(e) {
    var t = ic(e, "string");
    return Tt(t) == "symbol" ? t : String(t);
  }
  function ic(e, t) {
    if (Tt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Tt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function ac(e, t, n) {
    return e.map(function (r, i) {
      return Yi(Yi({}, r), {}, { __position: n * t + i + 1 });
    });
  }
  function It(e) {
    "@babel/helpers - typeof";
    return (
      (It =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      It(e)
    );
  }
  function Xi(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Zi(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Xi(Object(n), !0).forEach(function (r) {
            sc(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Xi(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function sc(e, t, n) {
    return (
      (t = oc(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function oc(e) {
    var t = uc(e, "string");
    return It(t) == "symbol" ? t : String(t);
  }
  function uc(e, t) {
    if (It(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (It(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function cc(e, t) {
    return t
      ? e.map(function (n) {
          return Zi(Zi({}, n), {}, { __queryID: t });
        })
      : e;
  }
  function Nt(e) {
    "@babel/helpers - typeof";
    return (
      (Nt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Nt(e)
    );
  }
  function ea(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function ta(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? ea(Object(n), !0).forEach(function (r) {
            lc(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : ea(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function lc(e, t, n) {
    return (
      (t = fc(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function fc(e) {
    var t = hc(e, "string");
    return Nt(t) == "symbol" ? t : String(t);
  }
  function hc(e, t) {
    if (Nt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Nt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function dc(e, t) {
    var n = Object.keys(t).reduce(function (r, i) {
      var a = t[i];
      return a.recommendResults ? ta(ta({}, r), a.recommendResults.results) : r;
    }, {});
    e._recommendCache = n;
  }
  function Ct(e) {
    "@babel/helpers - typeof";
    return (
      (Ct =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Ct(e)
    );
  }
  function pc(e, t) {
    return yc(e) || vc(e, t) || gc(e, t) || mc();
  }
  function mc() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function gc(e, t) {
    if (e) {
      if (typeof e == "string") return ra(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return ra(e, t);
    }
  }
  function ra(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function vc(e, t) {
    var n =
      e == null
        ? null
        : (typeof Symbol < "u" && e[Symbol.iterator]) || e["@@iterator"];
    if (n != null) {
      var r,
        i,
        a,
        o,
        s = [],
        l = !0,
        f = !1;
      try {
        if (((a = (n = n.call(e)).next), t !== 0))
          for (
            ;
            !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== t);
            l = !0
          );
      } catch (m) {
        ((f = !0), (i = m));
      } finally {
        try {
          if (!l && n.return != null && ((o = n.return()), Object(o) !== o))
            return;
        } finally {
          if (f) throw i;
        }
      }
      return s;
    }
  }
  function yc(e) {
    if (Array.isArray(e)) return e;
  }
  function na(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function At(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? na(Object(n), !0).forEach(function (r) {
            ia(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : na(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function ia(e, t, n) {
    return (
      (t = bc(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function bc(e) {
    var t = Sc(e, "string");
    return Ct(t) == "symbol" ? t : String(t);
  }
  function Sc(e, t) {
    if (Ct(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Ct(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Pc(e, t) {
    if (
      t &&
      !(
        (!("transporter" in e) || e._cacheHydrated) &&
        (!e._useCache || typeof e.addAlgoliaAgent != "function")
      )
    ) {
      var n = [
          Object.keys(t).reduce(function (o, s) {
            var l = t[s],
              f = l.state,
              m = l.requestParams,
              d = l.results,
              p =
                d && f
                  ? d.map(function (u, c) {
                      return At(
                        { indexName: f.index || u.index },
                        (m != null && m[c]) || u.params
                          ? {
                              params: Zr(
                                (m == null ? void 0 : m[c]) || _c(u.params),
                              ),
                            }
                          : {},
                      );
                    })
                  : [];
            return o.concat(p);
          }, []),
        ],
        r = Object.keys(t).reduce(function (o, s) {
          var l = t[s].results;
          return l ? o.concat(l) : o;
        }, []);
      if ("transporter" in e && !e._cacheHydrated) {
        e._cacheHydrated = !0;
        var i = e.search.bind(e);
        ((e.search = function (o) {
          for (
            var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), f = 1;
            f < s;
            f++
          )
            l[f - 1] = arguments[f];
          var m = Array.isArray(o)
            ? o.map(function (d) {
                return At(At({}, d), {}, { params: Zr(d.params) });
              })
            : Zr(o.requestBody.params);
          return e.transporter.responsesCache.get(
            { method: "search", args: [m].concat(l) },
            function () {
              return i.apply(void 0, [o].concat(l));
            },
          );
        }),
          e.transporter.responsesCache.set(
            { method: "search", args: n },
            { results: r },
          ));
      }
      if (!("transporter" in e)) {
        var a = "/1/indexes/*/queries_body_".concat(
          JSON.stringify({ requests: n }),
        );
        e.cache = At(
          At({}, e.cache),
          {},
          ia(
            {},
            a,
            JSON.stringify({
              results: Object.keys(t).map(function (o) {
                return t[o].results;
              }),
            }),
          ),
        );
      }
    }
  }
  function _c(e) {
    return e.split("&").reduce(function (t, n) {
      var r = n.split("="),
        i = pc(r, 2),
        a = i[0],
        o = i[1];
      return ((t[a] = o ? decodeURIComponent(o) : ""), t);
    }, {});
  }
  function Zr(e) {
    var t = function (i) {
        return (
          Object.prototype.toString.call(i) === "[object Object]" ||
          Object.prototype.toString.call(i) === "[object Array]"
        );
      },
      n = function (i) {
        for (
          var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), s = 1;
          s < a;
          s++
        )
          o[s - 1] = arguments[s];
        var l = 0;
        return i.replace(/%s/g, function () {
          return encodeURIComponent(o[l++]);
        });
      };
    return Object.keys(e)
      .map(function (r) {
        return n("%s=%s", r, t(e[r]) ? JSON.stringify(e[r]) : e[r]);
      })
      .join("&");
  }
  function aa(e) {
    return e !== Object(e);
  }
  function ct(e, t) {
    if (e === t) return !0;
    if (aa(e) || aa(t) || typeof e == "function" || typeof t == "function")
      return e === t;
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for (var n = 0, r = Object.keys(e); n < r.length; n++) {
      var i = r[n];
      if (!(i in t) || !ct(e[i], t[i])) return !1;
    }
    return !0;
  }
  function ae(e) {
    return typeof e == "number" && isFinite(e);
  }
  function sa(e) {
    var t = e.button === 1;
    return t || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
  }
  function en(e) {
    return e.filter(function (t, n, r) {
      return r.indexOf(t) === n;
    });
  }
  function Dt(e) {
    "@babel/helpers - typeof";
    return (
      (Dt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Dt(e)
    );
  }
  var Oc = [
    "facets",
    "disjunctiveFacets",
    "facetsRefinements",
    "facetsExcludes",
    "disjunctiveFacetsRefinements",
    "numericRefinements",
    "tagRefinements",
    "hierarchicalFacets",
    "hierarchicalFacetsRefinements",
    "ruleContexts",
  ];
  function oa(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Te(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? oa(Object(n), !0).forEach(function (r) {
            wc(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : oa(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function wc(e, t, n) {
    return (
      (t = Rc(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Rc(e) {
    var t = jc(e, "string");
    return Dt(t) == "symbol" ? t : String(t);
  }
  function jc(e, t) {
    if (Dt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Dt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function $c(e, t) {
    if (e == null) return {};
    var n = xc(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function xc(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  var Fc = function (t, n) {
      (n.facets,
        n.disjunctiveFacets,
        n.facetsRefinements,
        n.facetsExcludes,
        n.disjunctiveFacetsRefinements,
        n.numericRefinements,
        n.tagRefinements,
        n.hierarchicalFacets,
        n.hierarchicalFacetsRefinements,
        n.ruleContexts);
      var r = $c(n, Oc);
      return t.setQueryParameters(r);
    },
    Ec = function (t, n) {
      return n.facets.reduce(function (r, i) {
        return r.addFacet(i);
      }, t);
    },
    Tc = function (t, n) {
      return n.disjunctiveFacets.reduce(function (r, i) {
        return r.addDisjunctiveFacet(i);
      }, t);
    },
    Ic = function (t, n) {
      return t.setQueryParameters({
        hierarchicalFacets: n.hierarchicalFacets.reduce(function (r, i) {
          var a = Xu(r, function (s) {
            return s.name === i.name;
          });
          if (a === -1) return r.concat(i);
          var o = r.slice();
          return (o.splice(a, 1, i), o);
        }, t.hierarchicalFacets),
      });
    },
    Nc = function (t, n) {
      return n.tagRefinements.reduce(function (r, i) {
        return r.addTagRefinement(i);
      }, t);
    },
    Cc = function (t, n) {
      return t.setQueryParameters({
        facetsRefinements: Te(Te({}, t.facetsRefinements), n.facetsRefinements),
      });
    },
    Ac = function (t, n) {
      return t.setQueryParameters({
        facetsExcludes: Te(Te({}, t.facetsExcludes), n.facetsExcludes),
      });
    },
    Dc = function (t, n) {
      return t.setQueryParameters({
        disjunctiveFacetsRefinements: Te(
          Te({}, t.disjunctiveFacetsRefinements),
          n.disjunctiveFacetsRefinements,
        ),
      });
    },
    Hc = function (t, n) {
      return t.setQueryParameters({
        numericRefinements: Te(
          Te({}, t.numericRefinements),
          n.numericRefinements,
        ),
      });
    },
    Lc = function (t, n) {
      return t.setQueryParameters({
        hierarchicalFacetsRefinements: Te(
          Te({}, t.hierarchicalFacetsRefinements),
          n.hierarchicalFacetsRefinements,
        ),
      });
    },
    Mc = function (t, n) {
      var r = en(
        [].concat(t.ruleContexts).concat(n.ruleContexts).filter(Boolean),
      );
      return r.length > 0 ? t.setQueryParameters({ ruleContexts: r }) : t;
    },
    Or = function () {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return n.reduce(function (i, a) {
        var o = Lc(i, a),
          s = Ic(o, a),
          l = Nc(s, a),
          f = Hc(l, a),
          m = Dc(f, a),
          d = Ac(m, a),
          p = Cc(d, a),
          u = Tc(p, a),
          c = Mc(u, a),
          g = Ec(c, a);
        return Fc(g, a);
      });
    };
  function Wc(e, t) {
    return e == null
      ? e
      : Object.keys(e).reduce(function (n, r) {
          if (t.indexOf(r) >= 0) return n;
          var i = r;
          return ((n[i] = e[i]), n);
        }, {});
  }
  function qc(e) {
    return Bc(e) || Qc(e) || kc(e) || Uc();
  }
  function Uc() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function kc(e, t) {
    if (e) {
      if (typeof e == "string") return tn(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return tn(e, t);
    }
  }
  function Qc(e) {
    if (
      (typeof Symbol < "u" && e[Symbol.iterator] != null) ||
      e["@@iterator"] != null
    )
      return Array.from(e);
  }
  function Bc(e) {
    if (Array.isArray(e)) return tn(e);
  }
  function tn(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function wr(e) {
    var t = e.start,
      n = t === void 0 ? 0 : t,
      r = e.end,
      i = e.step,
      a = i === void 0 ? 1 : i,
      o = a === 0 ? 1 : a,
      s = Math.round((r - n) / o);
    return qc(Array(s)).map(function (l, f) {
      return n + f * o;
    });
  }
  function Ht(e, t, n) {
    var r = t.getHelper();
    return {
      uiState: n,
      helper: r,
      parent: t,
      instantSearchInstance: e,
      state: r.state,
      renderState: e.renderState,
      templatesConfig: e.templatesConfig,
      createURL: t.createURL,
      scopedResults: [],
      searchMetadata: { isSearchStalled: e.status === "stalled" },
      status: e.status,
      error: e.error,
    };
  }
  function ua(e, t, n) {
    var r = t.getResultsForWidget(n),
      i = t.getHelper();
    return {
      helper: i,
      parent: t,
      instantSearchInstance: e,
      results: r,
      scopedResults: t.getScopedResults(),
      state: r && "_state" in r ? r._state : i.state,
      renderState: e.renderState,
      templatesConfig: e.templatesConfig,
      createURL: t.createURL,
      searchMetadata: { isSearchStalled: e.status === "stalled" },
      status: e.status,
      error: e.error,
    };
  }
  function Vc(e) {
    for (var t = e.getParent(), n = [e.getHelper().state]; t !== null; )
      ((n = [t.getHelper().state].concat(n)), (t = t.getParent()));
    return n;
  }
  function Lt(e) {
    "@babel/helpers - typeof";
    return (
      (Lt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Lt(e)
    );
  }
  function ca(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Rr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? ca(Object(n), !0).forEach(function (r) {
            Kc(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : ca(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Kc(e, t, n) {
    return (
      (t = zc(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function zc(e) {
    var t = Jc(e, "string");
    return Lt(t) == "symbol" ? t : String(t);
  }
  function Jc(e, t) {
    if (Lt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Lt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function la(e) {
    return e.some(function (t) {
      return t.isHighlighted;
    })
      ? e.map(function (t, n) {
          return Rr(Rr({}, t), {}, { isHighlighted: !tc(e, n) });
        })
      : e.map(function (t) {
          return Rr(Rr({}, t), {}, { isHighlighted: !1 });
        });
  }
  function Ie(e) {
    var t =
        arguments.length > 1 && arguments[1] !== void 0
          ? arguments[1]
          : { fallback: function () {} },
      n = t.fallback;
    return typeof window > "u" ? n() : e({ window });
  }
  function jr(e) {
    return Array.isArray(e) ? e : [e];
  }
  var Gc = Qe("Highlight");
  function fa(e) {
    var t = e.attribute,
      n = e.highlightedTagName,
      r = n === void 0 ? "mark" : n,
      i = e.hit,
      a = e.cssClasses,
      o = a === void 0 ? {} : a,
      s = Be(i._highlightResult, t),
      l = s || {},
      f = l.value,
      m = f === void 0 ? "" : f,
      d =
        Gc({ descendantName: "highlighted" }) +
        (o.highlighted ? " ".concat(o.highlighted) : "");
    return m
      .replace(
        new RegExp(ve.highlightPreTag, "g"),
        "<".concat(r, ' class="').concat(d, '">'),
      )
      .replace(new RegExp(ve.highlightPostTag, "g"), "</".concat(r, ">"));
  }
  var Yc = Qe("ReverseHighlight");
  function ha(e) {
    var t = e.attribute,
      n = e.highlightedTagName,
      r = n === void 0 ? "mark" : n,
      i = e.hit,
      a = e.cssClasses,
      o = a === void 0 ? {} : a,
      s = Be(i._highlightResult, t),
      l = s || {},
      f = l.value,
      m = f === void 0 ? "" : f,
      d =
        Yc({ descendantName: "highlighted" }) +
        (o.highlighted ? " ".concat(o.highlighted) : ""),
      p = qi(la(ut(m)));
    return p
      .replace(
        new RegExp(ve.highlightPreTag, "g"),
        "<".concat(r, ' class="').concat(d, '">'),
      )
      .replace(new RegExp(ve.highlightPostTag, "g"), "</".concat(r, ">"));
  }
  var Xc = Qe("Snippet");
  function da(e) {
    var t = e.attribute,
      n = e.highlightedTagName,
      r = n === void 0 ? "mark" : n,
      i = e.hit,
      a = e.cssClasses,
      o = a === void 0 ? {} : a,
      s = Be(i._snippetResult, t),
      l = s || {},
      f = l.value,
      m = f === void 0 ? "" : f,
      d =
        Xc({ descendantName: "highlighted" }) +
        (o.highlighted ? " ".concat(o.highlighted) : "");
    return m
      .replace(
        new RegExp(ve.highlightPreTag, "g"),
        "<".concat(r, ' class="').concat(d, '">'),
      )
      .replace(new RegExp(ve.highlightPostTag, "g"), "</".concat(r, ">"));
  }
  var Zc = Qe("ReverseSnippet");
  function pa(e) {
    var t = e.attribute,
      n = e.highlightedTagName,
      r = n === void 0 ? "mark" : n,
      i = e.hit,
      a = e.cssClasses,
      o = a === void 0 ? {} : a,
      s = Be(i._snippetResult, t),
      l = s || {},
      f = l.value,
      m = f === void 0 ? "" : f,
      d =
        Zc({ descendantName: "highlighted" }) +
        (o.highlighted ? " ".concat(o.highlighted) : ""),
      p = qi(la(ut(m)));
    return p
      .replace(
        new RegExp(ve.highlightPreTag, "g"),
        "<".concat(r, ' class="').concat(d, '">'),
      )
      .replace(new RegExp(ve.highlightPostTag, "g"), "</".concat(r, ">"));
  }
  function rn(e) {
    "@babel/helpers - typeof";
    return (
      (rn =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      rn(e)
    );
  }
  function el(e) {
    var t = e.getAttribute("data-insights-method"),
      n = e.getAttribute("data-insights-payload");
    if (typeof n != "string")
      throw new Error(
        "The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.",
      );
    try {
      var r = Bi(n);
      return { method: t, payload: r };
    } catch {
      throw new Error(
        "The insights helper was unable to parse `data-insights-payload`.",
      );
    }
  }
  function tl(e) {
    var t = e.method,
      n = e.payload;
    if (rn(n) !== "object")
      throw new Error(
        "The insights helper expects the payload to be an object.",
      );
    var r;
    try {
      r = Qi(n);
    } catch {
      throw new Error("Could not JSON serialize the payload object.");
    }
    return 'data-insights-method="'
      .concat(t, '" data-insights-payload="')
      .concat(r, '"');
  }
  function ma(e, t) {
    return tl({ method: e, payload: t });
  }
  function nn(e) {
    "@babel/helpers - typeof";
    return (
      (nn =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      nn(e)
    );
  }
  var rl = "_ALGOLIA";
  function nl(e) {
    if (
      !(
        (typeof document > "u" ? "undefined" : nn(document)) !== "object" ||
        typeof document.cookie != "string"
      )
    )
      for (
        var t = "".concat(e, "="), n = document.cookie.split(";"), r = 0;
        r < n.length;
        r++
      ) {
        for (var i = n[r]; i.charAt(0) === " "; ) i = i.substring(1);
        if (i.indexOf(t) === 0) return i.substring(t.length, i.length);
      }
  }
  function ga() {
    return nl(rl);
  }
  function il() {
    return ga();
  }
  var al = ["page"];
  function sl(e, t) {
    if (e == null) return {};
    var n = ol(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function ol(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function va(e) {
    var t = e || {};
    t.page;
    var n = sl(t, al);
    return n;
  }
  function ul() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      t = e.key,
      n = ["ais.infiniteHits", t].filter(Boolean).join(":");
    return {
      read: function (i) {
        var a = i.state,
          o = Ie(function (l) {
            var f = l.window;
            return f.sessionStorage;
          });
        if (!o) return null;
        try {
          var s = JSON.parse(o.getItem(n));
          return s && ct(s.state, va(a)) ? s.hits : null;
        } catch (l) {
          if (l instanceof SyntaxError)
            try {
              o.removeItem(n);
            } catch {}
          return null;
        }
      },
      write: function (i) {
        var a = i.state,
          o = i.hits,
          s = Ie(function (l) {
            var f = l.window;
            return f.sessionStorage;
          });
        if (s)
          try {
            s.setItem(n, JSON.stringify({ state: va(a), hits: o }));
          } catch {}
      },
    };
  }
  var an, ya;
  function sn() {
    if (ya) return an;
    ya = 1;
    function e() {
      ((this._events = this._events || {}),
        (this._maxListeners = this._maxListeners || void 0));
    }
    ((an = e),
      (e.prototype._events = void 0),
      (e.prototype._maxListeners = void 0),
      (e.defaultMaxListeners = 10),
      (e.prototype.setMaxListeners = function (a) {
        if (!n(a) || a < 0 || isNaN(a))
          throw TypeError("n must be a positive number");
        return ((this._maxListeners = a), this);
      }),
      (e.prototype.emit = function (a) {
        var o, s, l, f, m, d;
        if (
          (this._events || (this._events = {}),
          a === "error" &&
            (!this._events.error ||
              (r(this._events.error) && !this._events.error.length)))
        ) {
          if (((o = arguments[1]), o instanceof Error)) throw o;
          var p = new Error('Uncaught, unspecified "error" event. (' + o + ")");
          throw ((p.context = o), p);
        }
        if (((s = this._events[a]), i(s))) return !1;
        if (t(s))
          switch (arguments.length) {
            case 1:
              s.call(this);
              break;
            case 2:
              s.call(this, arguments[1]);
              break;
            case 3:
              s.call(this, arguments[1], arguments[2]);
              break;
            default:
              ((f = Array.prototype.slice.call(arguments, 1)),
                s.apply(this, f));
          }
        else if (r(s))
          for (
            f = Array.prototype.slice.call(arguments, 1),
              d = s.slice(),
              l = d.length,
              m = 0;
            m < l;
            m++
          )
            d[m].apply(this, f);
        return !0;
      }),
      (e.prototype.addListener = function (a, o) {
        var s;
        if (!t(o)) throw TypeError("listener must be a function");
        return (
          this._events || (this._events = {}),
          this._events.newListener &&
            this.emit("newListener", a, t(o.listener) ? o.listener : o),
          this._events[a]
            ? r(this._events[a])
              ? this._events[a].push(o)
              : (this._events[a] = [this._events[a], o])
            : (this._events[a] = o),
          r(this._events[a]) &&
            !this._events[a].warned &&
            (i(this._maxListeners)
              ? (s = e.defaultMaxListeners)
              : (s = this._maxListeners),
            s &&
              s > 0 &&
              this._events[a].length > s &&
              ((this._events[a].warned = !0),
              console.error(
                "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
                this._events[a].length,
              ),
              typeof console.trace == "function" && console.trace())),
          this
        );
      }),
      (e.prototype.on = e.prototype.addListener),
      (e.prototype.once = function (a, o) {
        if (!t(o)) throw TypeError("listener must be a function");
        var s = !1;
        function l() {
          (this.removeListener(a, l),
            s || ((s = !0), o.apply(this, arguments)));
        }
        return ((l.listener = o), this.on(a, l), this);
      }),
      (e.prototype.removeListener = function (a, o) {
        var s, l, f, m;
        if (!t(o)) throw TypeError("listener must be a function");
        if (!this._events || !this._events[a]) return this;
        if (
          ((s = this._events[a]),
          (f = s.length),
          (l = -1),
          s === o || (t(s.listener) && s.listener === o))
        )
          (delete this._events[a],
            this._events.removeListener && this.emit("removeListener", a, o));
        else if (r(s)) {
          for (m = f; m-- > 0; )
            if (s[m] === o || (s[m].listener && s[m].listener === o)) {
              l = m;
              break;
            }
          if (l < 0) return this;
          (s.length === 1
            ? ((s.length = 0), delete this._events[a])
            : s.splice(l, 1),
            this._events.removeListener && this.emit("removeListener", a, o));
        }
        return this;
      }),
      (e.prototype.removeAllListeners = function (a) {
        var o, s;
        if (!this._events) return this;
        if (!this._events.removeListener)
          return (
            arguments.length === 0
              ? (this._events = {})
              : this._events[a] && delete this._events[a],
            this
          );
        if (arguments.length === 0) {
          for (o in this._events)
            o !== "removeListener" && this.removeAllListeners(o);
          return (
            this.removeAllListeners("removeListener"),
            (this._events = {}),
            this
          );
        }
        if (((s = this._events[a]), t(s))) this.removeListener(a, s);
        else if (s) for (; s.length; ) this.removeListener(a, s[s.length - 1]);
        return (delete this._events[a], this);
      }),
      (e.prototype.listeners = function (a) {
        var o;
        return (
          !this._events || !this._events[a]
            ? (o = [])
            : t(this._events[a])
              ? (o = [this._events[a]])
              : (o = this._events[a].slice()),
          o
        );
      }),
      (e.prototype.listenerCount = function (a) {
        if (this._events) {
          var o = this._events[a];
          if (t(o)) return 1;
          if (o) return o.length;
        }
        return 0;
      }),
      (e.listenerCount = function (a, o) {
        return a.listenerCount(o);
      }));
    function t(a) {
      return typeof a == "function";
    }
    function n(a) {
      return typeof a == "number";
    }
    function r(a) {
      return typeof a == "object" && a !== null;
    }
    function i(a) {
      return a === void 0;
    }
    return an;
  }
  var cl = sn();
  const ll = wt(cl);
  var on, ba;
  function Sa() {
    if (ba) return on;
    ba = 1;
    function e(t, n) {
      t.prototype = Object.create(n.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      });
    }
    return ((on = e), on);
  }
  var un, Pa;
  function fl() {
    if (Pa) return un;
    Pa = 1;
    var e = sn(),
      t = Sa();
    function n(r, i, a) {
      ((this.main = r),
        (this.fn = i),
        (this.recommendFn = a),
        (this.lastResults = null),
        (this.lastRecommendResults = null));
    }
    return (
      t(n, e),
      (n.prototype.detach = function () {
        (this.removeAllListeners(), this.main.detachDerivedHelper(this));
      }),
      (n.prototype.getModifiedState = function (r) {
        return this.fn(r);
      }),
      (n.prototype.getModifiedRecommendState = function (r) {
        return this.recommendFn(r);
      }),
      (un = n),
      un
    );
  }
  var cn, _a;
  function ln() {
    if (_a) return cn;
    _a = 1;
    function e(n) {
      return typeof n != "string" ? n : String(n).replace(/^-/, "\\-");
    }
    function t(n) {
      return typeof n != "string" ? n : n.replace(/^\\-/, "-");
    }
    return ((cn = { escapeFacetValue: e, unescapeFacetValue: t }), cn);
  }
  var fn, Oa;
  function hn() {
    if (Oa) return fn;
    Oa = 1;
    function e(i) {
      return typeof i == "object" && i !== null
        ? n(Array.isArray(i) ? [] : {}, i)
        : i;
    }
    function t(i) {
      return (
        typeof i == "function" ||
        Array.isArray(i) ||
        Object.prototype.toString.call(i) === "[object Object]"
      );
    }
    function n(i, a) {
      if (i === a) return i;
      for (var o in a)
        if (
          !(
            !Object.prototype.hasOwnProperty.call(a, o) ||
            o === "__proto__" ||
            o === "constructor"
          )
        ) {
          var s = a[o],
            l = i[o];
          (typeof l < "u" && typeof s > "u") ||
            (t(l) && t(s) ? (i[o] = n(l, s)) : (i[o] = e(s)));
        }
      return i;
    }
    function r(i) {
      t(i) || (i = {});
      for (var a = 1, o = arguments.length; a < o; a++) {
        var s = arguments[a];
        t(s) && n(i, s);
      }
      return i;
    }
    return ((fn = r), fn);
  }
  var dn, wa;
  function pn() {
    if (wa) return dn;
    wa = 1;
    function e(t) {
      return t && Object.keys(t).length > 0;
    }
    return ((dn = e), dn);
  }
  var mn, Ra;
  function gn() {
    if (Ra) return mn;
    Ra = 1;
    function e(t, n) {
      if (t === null) return {};
      var r = {},
        i = Object.keys(t),
        a,
        o;
      for (o = 0; o < i.length; o++)
        ((a = i[o]), !(n.indexOf(a) >= 0) && (r[a] = t[a]));
      return r;
    }
    return ((mn = e), mn);
  }
  var vn, ja;
  function $a() {
    if (ja) return vn;
    ja = 1;
    function e(t) {
      ((t = t || {}), (this.params = t.params || []));
    }
    return (
      (e.prototype = {
        constructor: e,
        addParams: function (t) {
          var n = this.params.slice();
          return (n.push(t), new e({ params: n }));
        },
        removeParams: function (t) {
          return new e({
            params: this.params.filter(function (n) {
              return n.$$id !== t;
            }),
          });
        },
        addFrequentlyBoughtTogether: function (t) {
          return this.addParams(
            Object.assign({}, t, { model: "bought-together" }),
          );
        },
        addRelatedProducts: function (t) {
          return this.addParams(
            Object.assign({}, t, { model: "related-products" }),
          );
        },
        addTrendingItems: function (t) {
          return this.addParams(
            Object.assign({}, t, { model: "trending-items" }),
          );
        },
        addTrendingFacets: function (t) {
          return this.addParams(
            Object.assign({}, t, { model: "trending-facets" }),
          );
        },
        addLookingSimilar: function (t) {
          return this.addParams(
            Object.assign({}, t, { model: "looking-similar" }),
          );
        },
        _buildQueries: function (t, n) {
          return this.params
            .filter(function (r) {
              return n[r.$$id] === void 0;
            })
            .map(function (r) {
              var i = Object.assign({}, r, {
                indexName: t,
                threshold: r.threshold || 0,
              });
              return (delete i.$$id, i);
            });
        },
      }),
      (vn = e),
      vn
    );
  }
  var yn, xa;
  function Fa() {
    if (xa) return yn;
    xa = 1;
    function e(t, n) {
      ((this._state = t), (this._rawResults = {}));
      var r = this;
      t.params.forEach(function (i) {
        var a = i.$$id;
        ((r[a] = n[a]), (r._rawResults[a] = n[a]));
      });
    }
    return ((e.prototype = { constructor: e }), (yn = e), yn);
  }
  var bn, Ea;
  function hl() {
    if (Ea) return bn;
    Ea = 1;
    var e = hn();
    function t(r) {
      return Object.keys(r)
        .sort()
        .reduce(function (i, a) {
          return ((i[a] = r[a]), i);
        }, {});
    }
    var n = {
      _getQueries: function (i, a) {
        var o = [];
        return (
          o.push({ indexName: i, params: n._getHitsSearchParams(a) }),
          a.getRefinedDisjunctiveFacets().forEach(function (s) {
            o.push({
              indexName: i,
              params: n._getDisjunctiveFacetSearchParams(a, s),
            });
          }),
          a.getRefinedHierarchicalFacets().forEach(function (s) {
            var l = a.getHierarchicalFacetByName(s),
              f = a.getHierarchicalRefinement(s),
              m = a._getHierarchicalFacetSeparator(l);
            if (f.length > 0 && f[0].split(m).length > 1) {
              var d = f[0]
                .split(m)
                .slice(0, -1)
                .reduce(function (u, c, g) {
                  return u.concat({
                    attribute: l.attributes[g],
                    value: g === 0 ? c : [u[u.length - 1].value, c].join(m),
                  });
                }, []);
              d.forEach(function (p, u) {
                var c = n._getDisjunctiveFacetSearchParams(
                  a,
                  p.attribute,
                  u === 0,
                );
                function g(b) {
                  return l.attributes.some(function (S) {
                    return S === b.split(":")[0];
                  });
                }
                var v = (c.facetFilters || []).reduce(function (b, S) {
                    if (Array.isArray(S)) {
                      var O = S.filter(function (_) {
                        return !g(_);
                      });
                      O.length > 0 && b.push(O);
                    }
                    return (typeof S == "string" && !g(S) && b.push(S), b);
                  }, []),
                  h = d[u - 1];
                (u > 0
                  ? (c.facetFilters = v.concat(h.attribute + ":" + h.value))
                  : v.length > 0
                    ? (c.facetFilters = v)
                    : delete c.facetFilters,
                  o.push({ indexName: i, params: c }));
              });
            }
          }),
          o
        );
      },
      _getCompositionQueries: function (i) {
        return [
          {
            compositionID: i.index,
            requestBody: { params: n._getCompositionHitsSearchParams(i) },
          },
        ];
      },
      _getHitsSearchParams: function (r) {
        var i = r.facets
            .concat(r.disjunctiveFacets)
            .concat(n._getHitsHierarchicalFacetsAttributes(r))
            .sort(),
          a = n._getFacetFilters(r),
          o = n._getNumericFilters(r),
          s = n._getTagFilters(r),
          l = {};
        return (
          i.length > 0 && (l.facets = i.indexOf("*") > -1 ? ["*"] : i),
          s.length > 0 && (l.tagFilters = s),
          a.length > 0 && (l.facetFilters = a),
          o.length > 0 && (l.numericFilters = o),
          t(e({}, r.getQueryParams(), l))
        );
      },
      _getCompositionHitsSearchParams: function (r) {
        var i = r.facets
            .concat(
              r.disjunctiveFacets.map(function (m) {
                return r.disjunctiveFacetsRefinements &&
                  r.disjunctiveFacetsRefinements[m] &&
                  r.disjunctiveFacetsRefinements[m].length > 0
                  ? "disjunctive(" + m + ")"
                  : m;
              }),
            )
            .concat(n._getHitsHierarchicalFacetsAttributes(r))
            .sort(),
          a = n._getFacetFilters(r),
          o = n._getNumericFilters(r),
          s = n._getTagFilters(r),
          l = {};
        (i.length > 0 && (l.facets = i.indexOf("*") > -1 ? ["*"] : i),
          s.length > 0 && (l.tagFilters = s),
          a.length > 0 && (l.facetFilters = a),
          o.length > 0 && (l.numericFilters = o));
        var f = r.getQueryParams();
        return (
          delete f.highlightPreTag,
          delete f.highlightPostTag,
          delete f.index,
          t(e({}, f, l))
        );
      },
      _getDisjunctiveFacetSearchParams: function (r, i, a) {
        var o = n._getFacetFilters(r, i, a),
          s = n._getNumericFilters(r, i),
          l = n._getTagFilters(r),
          f = { hitsPerPage: 0, page: 0, analytics: !1, clickAnalytics: !1 };
        l.length > 0 && (f.tagFilters = l);
        var m = r.getHierarchicalFacetByName(i);
        return (
          m
            ? (f.facets = n._getDisjunctiveHierarchicalFacetAttribute(r, m, a))
            : (f.facets = i),
          s.length > 0 && (f.numericFilters = s),
          o.length > 0 && (f.facetFilters = o),
          t(e({}, r.getQueryParams(), f))
        );
      },
      _getNumericFilters: function (r, i) {
        if (r.numericFilters) return r.numericFilters;
        var a = [];
        return (
          Object.keys(r.numericRefinements).forEach(function (o) {
            var s = r.numericRefinements[o] || {};
            Object.keys(s).forEach(function (l) {
              var f = s[l] || [];
              i !== o &&
                f.forEach(function (m) {
                  if (Array.isArray(m)) {
                    var d = m.map(function (p) {
                      return o + l + p;
                    });
                    a.push(d);
                  } else a.push(o + l + m);
                });
            });
          }),
          a
        );
      },
      _getTagFilters: function (r) {
        return r.tagFilters ? r.tagFilters : r.tagRefinements.join(",");
      },
      _getFacetFilters: function (r, i, a) {
        var o = [],
          s = r.facetsRefinements || {};
        Object.keys(s)
          .sort()
          .forEach(function (d) {
            var p = s[d] || [];
            p.slice()
              .sort()
              .forEach(function (u) {
                o.push(d + ":" + u);
              });
          });
        var l = r.facetsExcludes || {};
        Object.keys(l)
          .sort()
          .forEach(function (d) {
            var p = l[d] || [];
            p.sort().forEach(function (u) {
              o.push(d + ":-" + u);
            });
          });
        var f = r.disjunctiveFacetsRefinements || {};
        Object.keys(f)
          .sort()
          .forEach(function (d) {
            var p = f[d] || [];
            if (!(d === i || !p || p.length === 0)) {
              var u = [];
              (p
                .slice()
                .sort()
                .forEach(function (c) {
                  u.push(d + ":" + c);
                }),
                o.push(u));
            }
          });
        var m = r.hierarchicalFacetsRefinements || {};
        return (
          Object.keys(m)
            .sort()
            .forEach(function (d) {
              var p = m[d] || [],
                u = p[0];
              if (u !== void 0) {
                var c = r.getHierarchicalFacetByName(d),
                  g = r._getHierarchicalFacetSeparator(c),
                  v = r._getHierarchicalRootPath(c),
                  h,
                  b;
                if (i === d) {
                  if (
                    u.indexOf(g) === -1 ||
                    (!v && a === !0) ||
                    (v && v.split(g).length === u.split(g).length)
                  )
                    return;
                  (v
                    ? ((b = v.split(g).length - 1), (u = v))
                    : ((b = u.split(g).length - 2),
                      (u = u.slice(0, u.lastIndexOf(g)))),
                    (h = c.attributes[b]));
                } else ((b = u.split(g).length - 1), (h = c.attributes[b]));
                h && o.push([h + ":" + u]);
              }
            }),
          o
        );
      },
      _getHitsHierarchicalFacetsAttributes: function (r) {
        var i = [];
        return r.hierarchicalFacets.reduce(function (o, s) {
          var l = r.getHierarchicalRefinement(s.name)[0];
          if (!l) return (o.push(s.attributes[0]), o);
          var f = r._getHierarchicalFacetSeparator(s),
            m = l.split(f).length,
            d = s.attributes.slice(0, m + 1);
          return o.concat(d);
        }, i);
      },
      _getDisjunctiveHierarchicalFacetAttribute: function (r, i, a) {
        var o = r._getHierarchicalFacetSeparator(i);
        if (a === !0) {
          var s = r._getHierarchicalRootPath(i),
            l = 0;
          return (s && (l = s.split(o).length), [i.attributes[l]]);
        }
        var f = r.getHierarchicalRefinement(i.name)[0] || "",
          m = f.split(o).length - 1;
        return i.attributes.slice(0, m + 1);
      },
      getSearchForFacetQuery: function (r, i, a, o) {
        var s = o.isDisjunctiveFacet(r) ? o.clearRefinements(r) : o,
          l = { facetQuery: i, facetName: r };
        return (
          typeof a == "number" && (l.maxFacetHits = a),
          t(e({}, n._getHitsSearchParams(s), l))
        );
      },
    };
    return ((bn = n), bn);
  }
  var Sn, Ta;
  function Pn() {
    return (
      Ta ||
        ((Ta = 1),
        (Sn = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.reduceRight(function (n, r) {
            return (
              Object.keys(Object(r)).forEach(function (i) {
                r[i] !== void 0 &&
                  (n[i] !== void 0 && delete n[i], (n[i] = r[i]));
              }),
              n
            );
          }, {});
        })),
      Sn
    );
  }
  var _n, Ia;
  function Mt() {
    return (
      Ia ||
        ((Ia = 1),
        (_n = function (t, n) {
          if (Array.isArray(t)) {
            for (var r = 0; r < t.length; r++) if (n(t[r])) return t[r];
          }
        })),
      _n
    );
  }
  var On, Na;
  function dl() {
    if (Na) return On;
    Na = 1;
    function e(t, n) {
      return t.filter(function (r, i) {
        return n.indexOf(r) > -1 && t.indexOf(r) === i;
      });
    }
    return ((On = e), On);
  }
  var wn, Ca;
  function pl() {
    if (Ca) return wn;
    Ca = 1;
    function e(t) {
      if (typeof t == "number") return t;
      if (typeof t == "string") return parseFloat(t);
      if (Array.isArray(t)) return t.map(e);
      throw new Error(
        "The value should be a number, a parsable string or an array of those.",
      );
    }
    return ((wn = e), wn);
  }
  var Rn, Aa;
  function ml() {
    return (
      Aa ||
        ((Aa = 1),
        (Rn = function (t) {
          return t === null ? !1 : /^[a-zA-Z0-9_-]{1,64}$/.test(t);
        })),
      Rn
    );
  }
  var jn, Da;
  function gl() {
    if (Da) return jn;
    Da = 1;
    var e = Pn(),
      t = pn(),
      n = gn(),
      r = {
        addRefinement: function (a, o, s) {
          if (r.isRefined(a, o, s)) return a;
          var l = "" + s,
            f = a[o] ? a[o].concat(l) : [l],
            m = {};
          return ((m[o] = f), e(m, a));
        },
        removeRefinement: function (a, o, s) {
          if (s === void 0)
            return r.clearRefinement(a, function (f, m) {
              return o === m;
            });
          var l = "" + s;
          return r.clearRefinement(a, function (f, m) {
            return o === m && l === f;
          });
        },
        toggleRefinement: function (a, o, s) {
          if (s === void 0)
            throw new Error("toggleRefinement should be used with a value");
          return r.isRefined(a, o, s)
            ? r.removeRefinement(a, o, s)
            : r.addRefinement(a, o, s);
        },
        clearRefinement: function (a, o, s) {
          if (o === void 0) return t(a) ? {} : a;
          if (typeof o == "string") return n(a, [o]);
          if (typeof o == "function") {
            var l = !1,
              f = Object.keys(a).reduce(function (m, d) {
                var p = a[d] || [],
                  u = p.filter(function (c) {
                    return !o(c, d, s);
                  });
                return (u.length !== p.length && (l = !0), (m[d] = u), m);
              }, {});
            return l ? f : a;
          }
        },
        isRefined: function (a, o, s) {
          var l = !!a[o] && a[o].length > 0;
          if (s === void 0 || !l) return l;
          var f = "" + s;
          return a[o].indexOf(f) !== -1;
        },
      };
    return ((jn = r), jn);
  }
  var $n, Ha;
  function La() {
    if (Ha) return $n;
    Ha = 1;
    var e = Pn(),
      t = Mt(),
      n = dl(),
      r = hn(),
      i = pn(),
      a = gn(),
      o = pl(),
      s = ml(),
      l = gl();
    function f(p, u) {
      return Array.isArray(p) && Array.isArray(u)
        ? p.length === u.length &&
            p.every(function (c, g) {
              return f(u[g], c);
            })
        : p === u;
    }
    function m(p, u) {
      return t(p, function (c) {
        return f(c, u);
      });
    }
    function d(p) {
      var u = p ? d._parseNumbers(p) : {};
      (u.userToken !== void 0 &&
        !s(u.userToken) &&
        console.warn(
          "[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}",
        ),
        (this.facets = u.facets || []),
        (this.disjunctiveFacets = u.disjunctiveFacets || []),
        (this.hierarchicalFacets = u.hierarchicalFacets || []),
        (this.facetsRefinements = u.facetsRefinements || {}),
        (this.facetsExcludes = u.facetsExcludes || {}),
        (this.disjunctiveFacetsRefinements =
          u.disjunctiveFacetsRefinements || {}),
        (this.numericRefinements = u.numericRefinements || {}),
        (this.tagRefinements = u.tagRefinements || []),
        (this.hierarchicalFacetsRefinements =
          u.hierarchicalFacetsRefinements || {}));
      var c = this;
      Object.keys(u).forEach(function (g) {
        var v = d.PARAMETERS.indexOf(g) !== -1,
          h = u[g] !== void 0;
        !v && h && (c[g] = u[g]);
      });
    }
    return (
      (d.PARAMETERS = Object.keys(new d())),
      (d._parseNumbers = function (p) {
        if (p instanceof d) return p;
        var u = {},
          c = [
            "aroundPrecision",
            "aroundRadius",
            "getRankingInfo",
            "minWordSizefor2Typos",
            "minWordSizefor1Typo",
            "page",
            "maxValuesPerFacet",
            "distinct",
            "minimumAroundRadius",
            "hitsPerPage",
            "minProximity",
          ];
        if (
          (c.forEach(function (v) {
            var h = p[v];
            if (typeof h == "string") {
              var b = parseFloat(h);
              u[v] = isNaN(b) ? h : b;
            }
          }),
          Array.isArray(p.insideBoundingBox) &&
            (u.insideBoundingBox = p.insideBoundingBox.map(function (v) {
              return Array.isArray(v)
                ? v.map(function (h) {
                    return parseFloat(h);
                  })
                : v;
            })),
          p.numericRefinements)
        ) {
          var g = {};
          (Object.keys(p.numericRefinements).forEach(function (v) {
            var h = p.numericRefinements[v] || {};
            ((g[v] = {}),
              Object.keys(h).forEach(function (b) {
                var S = h[b],
                  O = S.map(function (_) {
                    return Array.isArray(_)
                      ? _.map(function (R) {
                          return typeof R == "string" ? parseFloat(R) : R;
                        })
                      : typeof _ == "string"
                        ? parseFloat(_)
                        : _;
                  });
                g[v][b] = O;
              }));
          }),
            (u.numericRefinements = g));
        }
        return r(p, u);
      }),
      (d.make = function (u) {
        var c = new d(u),
          g = u.hierarchicalFacets || [];
        return (
          g.forEach(function (v) {
            if (v.rootPath) {
              var h = c.getHierarchicalRefinement(v.name);
              (h.length > 0 &&
                h[0].indexOf(v.rootPath) !== 0 &&
                (c = c.clearRefinements(v.name)),
                (h = c.getHierarchicalRefinement(v.name)),
                h.length === 0 &&
                  (c = c.toggleHierarchicalFacetRefinement(
                    v.name,
                    v.rootPath,
                  )));
            }
          }),
          c
        );
      }),
      (d.validate = function (p, u) {
        var c = u || {};
        return p.tagFilters && c.tagRefinements && c.tagRefinements.length > 0
          ? new Error(
              "[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.",
            )
          : p.tagRefinements.length > 0 && c.tagFilters
            ? new Error(
                "[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.",
              )
            : p.numericFilters &&
                c.numericRefinements &&
                i(c.numericRefinements)
              ? new Error(
                  "[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.",
                )
              : i(p.numericRefinements) && c.numericFilters
                ? new Error(
                    "[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.",
                  )
                : null;
      }),
      (d.prototype = {
        constructor: d,
        clearRefinements: function (u) {
          var c = {
            numericRefinements: this._clearNumericRefinements(u),
            facetsRefinements: l.clearRefinement(
              this.facetsRefinements,
              u,
              "conjunctiveFacet",
            ),
            facetsExcludes: l.clearRefinement(
              this.facetsExcludes,
              u,
              "exclude",
            ),
            disjunctiveFacetsRefinements: l.clearRefinement(
              this.disjunctiveFacetsRefinements,
              u,
              "disjunctiveFacet",
            ),
            hierarchicalFacetsRefinements: l.clearRefinement(
              this.hierarchicalFacetsRefinements,
              u,
              "hierarchicalFacet",
            ),
          };
          return c.numericRefinements === this.numericRefinements &&
            c.facetsRefinements === this.facetsRefinements &&
            c.facetsExcludes === this.facetsExcludes &&
            c.disjunctiveFacetsRefinements ===
              this.disjunctiveFacetsRefinements &&
            c.hierarchicalFacetsRefinements ===
              this.hierarchicalFacetsRefinements
            ? this
            : this.setQueryParameters(c);
        },
        clearTags: function () {
          return this.tagFilters === void 0 && this.tagRefinements.length === 0
            ? this
            : this.setQueryParameters({
                tagFilters: void 0,
                tagRefinements: [],
              });
        },
        setIndex: function (u) {
          return u === this.index
            ? this
            : this.setQueryParameters({ index: u });
        },
        setQuery: function (u) {
          return u === this.query
            ? this
            : this.setQueryParameters({ query: u });
        },
        setPage: function (u) {
          return u === this.page ? this : this.setQueryParameters({ page: u });
        },
        setFacets: function (u) {
          return this.setQueryParameters({ facets: u });
        },
        setDisjunctiveFacets: function (u) {
          return this.setQueryParameters({ disjunctiveFacets: u });
        },
        setHitsPerPage: function (u) {
          return this.hitsPerPage === u
            ? this
            : this.setQueryParameters({ hitsPerPage: u });
        },
        setTypoTolerance: function (u) {
          return this.typoTolerance === u
            ? this
            : this.setQueryParameters({ typoTolerance: u });
        },
        addNumericRefinement: function (p, u, c) {
          var g = o(c);
          if (this.isNumericRefined(p, u, g)) return this;
          var v = r({}, this.numericRefinements);
          return (
            (v[p] = r({}, v[p])),
            v[p][u]
              ? ((v[p][u] = v[p][u].slice()), v[p][u].push(g))
              : (v[p][u] = [g]),
            this.setQueryParameters({ numericRefinements: v })
          );
        },
        getConjunctiveRefinements: function (p) {
          return this.isConjunctiveFacet(p)
            ? this.facetsRefinements[p] || []
            : [];
        },
        getDisjunctiveRefinements: function (p) {
          return this.isDisjunctiveFacet(p)
            ? this.disjunctiveFacetsRefinements[p] || []
            : [];
        },
        getHierarchicalRefinement: function (p) {
          return this.hierarchicalFacetsRefinements[p] || [];
        },
        getExcludeRefinements: function (p) {
          return this.isConjunctiveFacet(p) ? this.facetsExcludes[p] || [] : [];
        },
        removeNumericRefinement: function (p, u, c) {
          var g = c;
          return g !== void 0
            ? this.isNumericRefined(p, u, g)
              ? this.setQueryParameters({
                  numericRefinements: this._clearNumericRefinements(
                    function (v, h) {
                      return h === p && v.op === u && f(v.val, o(g));
                    },
                  ),
                })
              : this
            : u !== void 0
              ? this.isNumericRefined(p, u)
                ? this.setQueryParameters({
                    numericRefinements: this._clearNumericRefinements(
                      function (v, h) {
                        return h === p && v.op === u;
                      },
                    ),
                  })
                : this
              : this.isNumericRefined(p)
                ? this.setQueryParameters({
                    numericRefinements: this._clearNumericRefinements(
                      function (v, h) {
                        return h === p;
                      },
                    ),
                  })
                : this;
        },
        getNumericRefinements: function (p) {
          return this.numericRefinements[p] || {};
        },
        getNumericRefinement: function (p, u) {
          return this.numericRefinements[p] && this.numericRefinements[p][u];
        },
        _clearNumericRefinements: function (u) {
          if (u === void 0)
            return i(this.numericRefinements) ? {} : this.numericRefinements;
          if (typeof u == "string") return a(this.numericRefinements, [u]);
          if (typeof u == "function") {
            var c = !1,
              g = this.numericRefinements,
              v = Object.keys(g).reduce(function (h, b) {
                var S = g[b],
                  O = {};
                return (
                  (S = S || {}),
                  Object.keys(S).forEach(function (_) {
                    var R = S[_] || [],
                      $ = [];
                    (R.forEach(function (y) {
                      var P = u({ val: y, op: _ }, b, "numeric");
                      P || $.push(y);
                    }),
                      $.length !== R.length && (c = !0),
                      (O[_] = $));
                  }),
                  (h[b] = O),
                  h
                );
              }, {});
            return c ? v : this.numericRefinements;
          }
        },
        addFacet: function (u) {
          return this.isConjunctiveFacet(u)
            ? this
            : this.setQueryParameters({ facets: this.facets.concat([u]) });
        },
        addDisjunctiveFacet: function (u) {
          return this.isDisjunctiveFacet(u)
            ? this
            : this.setQueryParameters({
                disjunctiveFacets: this.disjunctiveFacets.concat([u]),
              });
        },
        addHierarchicalFacet: function (u) {
          if (this.isHierarchicalFacet(u.name))
            throw new Error(
              "Cannot declare two hierarchical facets with the same name: `" +
                u.name +
                "`",
            );
          return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([u]),
          });
        },
        addFacetRefinement: function (u, c) {
          if (!this.isConjunctiveFacet(u))
            throw new Error(
              u +
                " is not defined in the facets attribute of the helper configuration",
            );
          return l.isRefined(this.facetsRefinements, u, c)
            ? this
            : this.setQueryParameters({
                facetsRefinements: l.addRefinement(
                  this.facetsRefinements,
                  u,
                  c,
                ),
              });
        },
        addExcludeRefinement: function (u, c) {
          if (!this.isConjunctiveFacet(u))
            throw new Error(
              u +
                " is not defined in the facets attribute of the helper configuration",
            );
          return l.isRefined(this.facetsExcludes, u, c)
            ? this
            : this.setQueryParameters({
                facetsExcludes: l.addRefinement(this.facetsExcludes, u, c),
              });
        },
        addDisjunctiveFacetRefinement: function (u, c) {
          if (!this.isDisjunctiveFacet(u))
            throw new Error(
              u +
                " is not defined in the disjunctiveFacets attribute of the helper configuration",
            );
          return l.isRefined(this.disjunctiveFacetsRefinements, u, c)
            ? this
            : this.setQueryParameters({
                disjunctiveFacetsRefinements: l.addRefinement(
                  this.disjunctiveFacetsRefinements,
                  u,
                  c,
                ),
              });
        },
        addTagRefinement: function (u) {
          if (this.isTagRefined(u)) return this;
          var c = { tagRefinements: this.tagRefinements.concat(u) };
          return this.setQueryParameters(c);
        },
        removeFacet: function (u) {
          return this.isConjunctiveFacet(u)
            ? this.clearRefinements(u).setQueryParameters({
                facets: this.facets.filter(function (c) {
                  return c !== u;
                }),
              })
            : this;
        },
        removeDisjunctiveFacet: function (u) {
          return this.isDisjunctiveFacet(u)
            ? this.clearRefinements(u).setQueryParameters({
                disjunctiveFacets: this.disjunctiveFacets.filter(function (c) {
                  return c !== u;
                }),
              })
            : this;
        },
        removeHierarchicalFacet: function (u) {
          return this.isHierarchicalFacet(u)
            ? this.clearRefinements(u).setQueryParameters({
                hierarchicalFacets: this.hierarchicalFacets.filter(
                  function (c) {
                    return c.name !== u;
                  },
                ),
              })
            : this;
        },
        removeFacetRefinement: function (u, c) {
          if (!this.isConjunctiveFacet(u))
            throw new Error(
              u +
                " is not defined in the facets attribute of the helper configuration",
            );
          return l.isRefined(this.facetsRefinements, u, c)
            ? this.setQueryParameters({
                facetsRefinements: l.removeRefinement(
                  this.facetsRefinements,
                  u,
                  c,
                ),
              })
            : this;
        },
        removeExcludeRefinement: function (u, c) {
          if (!this.isConjunctiveFacet(u))
            throw new Error(
              u +
                " is not defined in the facets attribute of the helper configuration",
            );
          return l.isRefined(this.facetsExcludes, u, c)
            ? this.setQueryParameters({
                facetsExcludes: l.removeRefinement(this.facetsExcludes, u, c),
              })
            : this;
        },
        removeDisjunctiveFacetRefinement: function (u, c) {
          if (!this.isDisjunctiveFacet(u))
            throw new Error(
              u +
                " is not defined in the disjunctiveFacets attribute of the helper configuration",
            );
          return l.isRefined(this.disjunctiveFacetsRefinements, u, c)
            ? this.setQueryParameters({
                disjunctiveFacetsRefinements: l.removeRefinement(
                  this.disjunctiveFacetsRefinements,
                  u,
                  c,
                ),
              })
            : this;
        },
        removeTagRefinement: function (u) {
          if (!this.isTagRefined(u)) return this;
          var c = {
            tagRefinements: this.tagRefinements.filter(function (g) {
              return g !== u;
            }),
          };
          return this.setQueryParameters(c);
        },
        toggleRefinement: function (u, c) {
          return this.toggleFacetRefinement(u, c);
        },
        toggleFacetRefinement: function (u, c) {
          if (this.isHierarchicalFacet(u))
            return this.toggleHierarchicalFacetRefinement(u, c);
          if (this.isConjunctiveFacet(u))
            return this.toggleConjunctiveFacetRefinement(u, c);
          if (this.isDisjunctiveFacet(u))
            return this.toggleDisjunctiveFacetRefinement(u, c);
          throw new Error(
            "Cannot refine the undeclared facet " +
              u +
              "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets",
          );
        },
        toggleConjunctiveFacetRefinement: function (u, c) {
          if (!this.isConjunctiveFacet(u))
            throw new Error(
              u +
                " is not defined in the facets attribute of the helper configuration",
            );
          return this.setQueryParameters({
            facetsRefinements: l.toggleRefinement(this.facetsRefinements, u, c),
          });
        },
        toggleExcludeFacetRefinement: function (u, c) {
          if (!this.isConjunctiveFacet(u))
            throw new Error(
              u +
                " is not defined in the facets attribute of the helper configuration",
            );
          return this.setQueryParameters({
            facetsExcludes: l.toggleRefinement(this.facetsExcludes, u, c),
          });
        },
        toggleDisjunctiveFacetRefinement: function (u, c) {
          if (!this.isDisjunctiveFacet(u))
            throw new Error(
              u +
                " is not defined in the disjunctiveFacets attribute of the helper configuration",
            );
          return this.setQueryParameters({
            disjunctiveFacetsRefinements: l.toggleRefinement(
              this.disjunctiveFacetsRefinements,
              u,
              c,
            ),
          });
        },
        toggleHierarchicalFacetRefinement: function (u, c) {
          if (!this.isHierarchicalFacet(u))
            throw new Error(
              u +
                " is not defined in the hierarchicalFacets attribute of the helper configuration",
            );
          var g = this._getHierarchicalFacetSeparator(
              this.getHierarchicalFacetByName(u),
            ),
            v = {},
            h =
              this.hierarchicalFacetsRefinements[u] !== void 0 &&
              this.hierarchicalFacetsRefinements[u].length > 0 &&
              (this.hierarchicalFacetsRefinements[u][0] === c ||
                this.hierarchicalFacetsRefinements[u][0].indexOf(c + g) === 0);
          return (
            h
              ? c.indexOf(g) === -1
                ? (v[u] = [])
                : (v[u] = [c.slice(0, c.lastIndexOf(g))])
              : (v[u] = [c]),
            this.setQueryParameters({
              hierarchicalFacetsRefinements: e(
                v,
                this.hierarchicalFacetsRefinements,
              ),
            })
          );
        },
        addHierarchicalFacetRefinement: function (p, u) {
          if (this.isHierarchicalFacetRefined(p))
            throw new Error(p + " is already refined.");
          if (!this.isHierarchicalFacet(p))
            throw new Error(
              p +
                " is not defined in the hierarchicalFacets attribute of the helper configuration.",
            );
          var c = {};
          return (
            (c[p] = [u]),
            this.setQueryParameters({
              hierarchicalFacetsRefinements: e(
                c,
                this.hierarchicalFacetsRefinements,
              ),
            })
          );
        },
        removeHierarchicalFacetRefinement: function (p) {
          if (!this.isHierarchicalFacetRefined(p)) return this;
          var u = {};
          return (
            (u[p] = []),
            this.setQueryParameters({
              hierarchicalFacetsRefinements: e(
                u,
                this.hierarchicalFacetsRefinements,
              ),
            })
          );
        },
        toggleTagRefinement: function (u) {
          return this.isTagRefined(u)
            ? this.removeTagRefinement(u)
            : this.addTagRefinement(u);
        },
        isDisjunctiveFacet: function (p) {
          return this.disjunctiveFacets.indexOf(p) > -1;
        },
        isHierarchicalFacet: function (p) {
          return this.getHierarchicalFacetByName(p) !== void 0;
        },
        isConjunctiveFacet: function (p) {
          return this.facets.indexOf(p) > -1;
        },
        isFacetRefined: function (u, c) {
          return this.isConjunctiveFacet(u)
            ? l.isRefined(this.facetsRefinements, u, c)
            : !1;
        },
        isExcludeRefined: function (u, c) {
          return this.isConjunctiveFacet(u)
            ? l.isRefined(this.facetsExcludes, u, c)
            : !1;
        },
        isDisjunctiveFacetRefined: function (u, c) {
          return this.isDisjunctiveFacet(u)
            ? l.isRefined(this.disjunctiveFacetsRefinements, u, c)
            : !1;
        },
        isHierarchicalFacetRefined: function (u, c) {
          if (!this.isHierarchicalFacet(u)) return !1;
          var g = this.getHierarchicalRefinement(u);
          return c ? g.indexOf(c) !== -1 : g.length > 0;
        },
        isNumericRefined: function (u, c, g) {
          if (g === void 0 && c === void 0) return !!this.numericRefinements[u];
          var v =
            this.numericRefinements[u] &&
            this.numericRefinements[u][c] !== void 0;
          if (g === void 0 || !v) return v;
          var h = o(g),
            b = m(this.numericRefinements[u][c], h) !== void 0;
          return v && b;
        },
        isTagRefined: function (u) {
          return this.tagRefinements.indexOf(u) !== -1;
        },
        getRefinedDisjunctiveFacets: function () {
          var u = this,
            c = n(
              Object.keys(this.numericRefinements).filter(function (g) {
                return Object.keys(u.numericRefinements[g]).length > 0;
              }),
              this.disjunctiveFacets,
            );
          return Object.keys(this.disjunctiveFacetsRefinements)
            .filter(function (g) {
              return u.disjunctiveFacetsRefinements[g].length > 0;
            })
            .concat(c)
            .concat(this.getRefinedHierarchicalFacets())
            .sort();
        },
        getRefinedHierarchicalFacets: function () {
          var u = this;
          return n(
            this.hierarchicalFacets.map(function (c) {
              return c.name;
            }),
            Object.keys(this.hierarchicalFacetsRefinements).filter(
              function (c) {
                return u.hierarchicalFacetsRefinements[c].length > 0;
              },
            ),
          ).sort();
        },
        getUnrefinedDisjunctiveFacets: function () {
          var p = this.getRefinedDisjunctiveFacets();
          return this.disjunctiveFacets.filter(function (u) {
            return p.indexOf(u) === -1;
          });
        },
        managedParameters: [
          "index",
          "facets",
          "disjunctiveFacets",
          "facetsRefinements",
          "hierarchicalFacets",
          "facetsExcludes",
          "disjunctiveFacetsRefinements",
          "numericRefinements",
          "tagRefinements",
          "hierarchicalFacetsRefinements",
        ],
        getQueryParams: function () {
          var u = this.managedParameters,
            c = {},
            g = this;
          return (
            Object.keys(this).forEach(function (v) {
              var h = g[v];
              u.indexOf(v) === -1 && h !== void 0 && (c[v] = h);
            }),
            c
          );
        },
        setQueryParameter: function (u, c) {
          if (this[u] === c) return this;
          var g = {};
          return ((g[u] = c), this.setQueryParameters(g));
        },
        setQueryParameters: function (u) {
          if (!u) return this;
          var c = d.validate(this, u);
          if (c) throw c;
          var g = this,
            v = d._parseNumbers(u),
            h = Object.keys(this).reduce(function (S, O) {
              return ((S[O] = g[O]), S);
            }, {}),
            b = Object.keys(v).reduce(function (S, O) {
              var _ = S[O] !== void 0,
                R = v[O] !== void 0;
              return _ && !R ? a(S, [O]) : (R && (S[O] = v[O]), S);
            }, h);
          return new this.constructor(b);
        },
        resetPage: function () {
          return this.page === void 0 ? this : this.setPage(0);
        },
        _getHierarchicalFacetSortBy: function (p) {
          return p.sortBy || ["isRefined:desc", "name:asc"];
        },
        _getHierarchicalFacetSeparator: function (p) {
          return p.separator || " > ";
        },
        _getHierarchicalRootPath: function (p) {
          return p.rootPath || null;
        },
        _getHierarchicalShowParentLevel: function (p) {
          return typeof p.showParentLevel == "boolean" ? p.showParentLevel : !0;
        },
        getHierarchicalFacetByName: function (p) {
          return t(this.hierarchicalFacets, function (u) {
            return u.name === p;
          });
        },
        getHierarchicalFacetBreadcrumb: function (p) {
          if (!this.isHierarchicalFacet(p)) return [];
          var u = this.getHierarchicalRefinement(p)[0];
          if (!u) return [];
          var c = this._getHierarchicalFacetSeparator(
              this.getHierarchicalFacetByName(p),
            ),
            g = u.split(c);
          return g.map(function (v) {
            return v.trim();
          });
        },
        toString: function () {
          return JSON.stringify(this, null, 2);
        },
      }),
      ($n = d),
      $n
    );
  }
  var xn, Ma;
  function vl() {
    return (
      Ma ||
        ((Ma = 1),
        (xn = function (t) {
          return Array.isArray(t) ? t.filter(Boolean) : [];
        })),
      xn
    );
  }
  var Fn, Wa;
  function yl() {
    return (
      Wa ||
        ((Wa = 1),
        (Fn = function (t, n) {
          if (!Array.isArray(t)) return -1;
          for (var r = 0; r < t.length; r++) if (n(t[r])) return r;
          return -1;
        })),
      Fn
    );
  }
  var En, qa;
  function Ua() {
    if (qa) return En;
    qa = 1;
    var e = Mt();
    return (
      (En = function (n, r) {
        var i = (r || []).map(function (a) {
          return a.split(":");
        });
        return n.reduce(
          function (o, s) {
            var l = s.split(":"),
              f = e(i, function (m) {
                return m[0] === l[0];
              });
            return l.length > 1 || !f
              ? (o[0].push(l[0]), o[1].push(l[1]), o)
              : (o[0].push(f[0]), o[1].push(f[1]), o);
          },
          [[], []],
        );
      }),
      En
    );
  }
  var Tn, ka;
  function bl() {
    if (ka) return Tn;
    ka = 1;
    function e() {
      var t = Array.prototype.slice.call(arguments);
      return t.reduceRight(function (n, r) {
        return (
          Object.keys(Object(r)).forEach(function (i) {
            var a = typeof n[i] == "number" ? n[i] : 0,
              o = r[i];
            o !== void 0 &&
              o >= a &&
              (n[i] !== void 0 && delete n[i], (n[i] = o));
          }),
          n
        );
      }, {});
    }
    return ((Tn = e), Tn);
  }
  var In, Qa;
  function Ba() {
    if (Qa) return In;
    Qa = 1;
    function e(n, r) {
      if (n !== r) {
        var i = n !== void 0,
          a = n === null,
          o = r !== void 0,
          s = r === null;
        if ((!s && n > r) || (a && o) || !i) return 1;
        if ((!a && n < r) || (s && i) || !o) return -1;
      }
      return 0;
    }
    function t(n, r, i) {
      if (!Array.isArray(n)) return [];
      Array.isArray(i) || (i = []);
      var a = n.map(function (o, s) {
        return {
          criteria: r.map(function (l) {
            return o[l];
          }),
          index: s,
          value: o,
        };
      });
      return (
        a.sort(function (s, l) {
          for (var f = -1; ++f < s.criteria.length; ) {
            var m = e(s.criteria[f], l.criteria[f]);
            if (m) return f >= i.length ? m : i[f] === "desc" ? -m : m;
          }
          return s.index - l.index;
        }),
        a.map(function (o) {
          return o.value;
        })
      );
    }
    return ((In = t), In);
  }
  var Nn, Va;
  function Sl() {
    if (Va) return Nn;
    ((Va = 1), (Nn = o));
    var e = ln(),
      t = Mt(),
      n = Ua(),
      r = Ba(),
      i = e.escapeFacetValue,
      a = e.unescapeFacetValue;
    function o(m) {
      return function (p, u) {
        var c = m.hierarchicalFacets[u],
          g =
            (m.hierarchicalFacetsRefinements[c.name] &&
              m.hierarchicalFacetsRefinements[c.name][0]) ||
            "",
          v = m._getHierarchicalFacetSeparator(c),
          h = m._getHierarchicalRootPath(c),
          b = m._getHierarchicalShowParentLevel(c),
          S = n(m._getHierarchicalFacetSortBy(c)),
          O = p.every(function ($) {
            return $.exhaustive;
          }),
          _ = s(S, v, h, b, g),
          R = p;
        return (
          h && (R = p.slice(h.split(v).length)),
          R.reduce(_, {
            name: m.hierarchicalFacets[u].name,
            count: null,
            isRefined: !0,
            path: null,
            escapedValue: null,
            exhaustive: O,
            data: null,
          })
        );
      };
    }
    function s(m, d, p, u, c) {
      return function (v, h, b) {
        var S = v;
        if (b > 0) {
          var O = 0;
          for (S = v; O < b; ) {
            var _ = S && Array.isArray(S.data) ? S.data : [];
            ((S = t(_, function ($) {
              return $.isRefined;
            })),
              O++);
          }
        }
        if (S) {
          var R = Object.keys(h.data)
            .map(function ($) {
              return [$, h.data[$]];
            })
            .filter(function ($) {
              var y = $[0];
              return l(y, S.path || p, c, d, p, u);
            });
          S.data = r(
            R.map(function ($) {
              var y = $[0],
                P = $[1];
              return f(P, y, d, a(c), h.exhaustive);
            }),
            m[0],
            m[1],
          );
        }
        return v;
      };
    }
    function l(m, d, p, u, c, g) {
      return c && (m.indexOf(c) !== 0 || c === m)
        ? !1
        : (!c && m.indexOf(u) === -1) ||
            (c && m.split(u).length - c.split(u).length === 1) ||
            (m.indexOf(u) === -1 && p.indexOf(u) === -1) ||
            p.indexOf(m) === 0 ||
            (m.indexOf(d + u) === 0 && (g || m.indexOf(p) === 0));
    }
    function f(m, d, p, u, c) {
      var g = d.split(p);
      return {
        name: g[g.length - 1].trim(),
        path: d,
        escapedValue: i(d),
        count: m,
        isRefined: u === d || u.indexOf(d + p) === 0,
        exhaustive: c,
        data: null,
      };
    }
    return Nn;
  }
  var Cn, Ka;
  function za() {
    if (Ka) return Cn;
    Ka = 1;
    var e = vl(),
      t = Pn(),
      n = ln(),
      r = Mt(),
      i = yl(),
      a = Ua(),
      o = bl(),
      s = Ba(),
      l = n.escapeFacetValue,
      f = n.unescapeFacetValue,
      m = Sl();
    function d(y) {
      var P = {};
      return (
        y.forEach(function (w, j) {
          P[w] = j;
        }),
        P
      );
    }
    function p(y, P, w) {
      P && P[w] && (y.stats = P[w]);
    }
    function u(y, P) {
      return r(y, function (j) {
        var T = j.attributes || [];
        return T.indexOf(P) > -1;
      });
    }
    function c(y, P, w) {
      var j = P[0] || {};
      this._rawResults = P;
      var T = this;
      Object.keys(j).forEach(function (C) {
        T[C] = j[C];
      });
      var N = t(w, { persistHierarchicalRootCount: !1 });
      (Object.keys(N).forEach(function (C) {
        T[C] = N[C];
      }),
        (this.processingTimeMS = P.reduce(function (C, q) {
          return q.processingTimeMS === void 0 ? C : C + q.processingTimeMS;
        }, 0)),
        (this.disjunctiveFacets = []),
        (this.hierarchicalFacets = y.hierarchicalFacets.map(function () {
          return [];
        })),
        (this.facets = []));
      var Q = y.getRefinedDisjunctiveFacets(),
        W = d(y.facets),
        G = d(y.disjunctiveFacets),
        B = 1,
        A = j.facets || {};
      (Object.keys(A).forEach(function (C) {
        var q = A[C],
          M = u(y.hierarchicalFacets, C);
        if (M) {
          var K = M.attributes.indexOf(C),
            Y = i(y.hierarchicalFacets, function (ee) {
              return ee.name === M.name;
            });
          T.hierarchicalFacets[Y][K] = {
            attribute: C,
            data: q,
            exhaustive: j.exhaustiveFacetsCount,
          };
        } else {
          var Z = y.disjunctiveFacets.indexOf(C) !== -1,
            k = y.facets.indexOf(C) !== -1,
            z;
          (Z &&
            ((z = G[C]),
            (T.disjunctiveFacets[z] = {
              name: C,
              data: q,
              exhaustive: j.exhaustiveFacetsCount,
            }),
            p(T.disjunctiveFacets[z], j.facets_stats, C)),
            k &&
              ((z = W[C]),
              (T.facets[z] = {
                name: C,
                data: q,
                exhaustive: j.exhaustiveFacetsCount,
              }),
              p(T.facets[z], j.facets_stats, C)));
        }
      }),
        (this.hierarchicalFacets = e(this.hierarchicalFacets)),
        Q.forEach(function (C) {
          var q = P[B],
            M = q && q.facets ? q.facets : {},
            K = y.getHierarchicalFacetByName(C);
          (Object.keys(M).forEach(function (Y) {
            var Z = M[Y],
              k;
            if (K) {
              k = i(y.hierarchicalFacets, function (x) {
                return x.name === K.name;
              });
              var z = i(T.hierarchicalFacets[k], function (x) {
                return x.attribute === Y;
              });
              if (z === -1) return;
              T.hierarchicalFacets[k][z].data = T.persistHierarchicalRootCount
                ? o(T.hierarchicalFacets[k][z].data, Z)
                : t(Z, T.hierarchicalFacets[k][z].data);
            } else {
              k = G[Y];
              var ee = (j.facets && j.facets[Y]) || {};
              ((T.disjunctiveFacets[k] = {
                name: Y,
                data: o(ee, Z),
                exhaustive: q.exhaustiveFacetsCount,
              }),
                p(T.disjunctiveFacets[k], q.facets_stats, Y),
                y.disjunctiveFacetsRefinements[Y] &&
                  y.disjunctiveFacetsRefinements[Y].forEach(function (x) {
                    !T.disjunctiveFacets[k].data[x] &&
                      y.disjunctiveFacetsRefinements[Y].indexOf(f(x)) > -1 &&
                      (T.disjunctiveFacets[k].data[x] = 0);
                  }));
            }
          }),
            B++);
        }),
        y.getRefinedHierarchicalFacets().forEach(function (C) {
          var q = y.getHierarchicalFacetByName(C),
            M = y._getHierarchicalFacetSeparator(q),
            K = y.getHierarchicalRefinement(C);
          K.length === 0 ||
            K[0].split(M).length < 2 ||
            P.slice(B).forEach(function (Y) {
              var Z = Y && Y.facets ? Y.facets : {};
              (Object.keys(Z).forEach(function (k) {
                var z = Z[k],
                  ee = i(y.hierarchicalFacets, function (I) {
                    return I.name === q.name;
                  }),
                  x = i(T.hierarchicalFacets[ee], function (I) {
                    return I.attribute === k;
                  });
                if (x !== -1) {
                  var F = {};
                  if (K.length > 0 && !T.persistHierarchicalRootCount) {
                    var E = K[0].split(M)[0];
                    F[E] = T.hierarchicalFacets[ee][x].data[E];
                  }
                  T.hierarchicalFacets[ee][x].data = t(
                    F,
                    z,
                    T.hierarchicalFacets[ee][x].data,
                  );
                }
              }),
                B++);
            });
        }),
        Object.keys(y.facetsExcludes).forEach(function (C) {
          var q = y.facetsExcludes[C],
            M = W[C];
          ((T.facets[M] = {
            name: C,
            data: A[C],
            exhaustive: j.exhaustiveFacetsCount,
          }),
            q.forEach(function (K) {
              ((T.facets[M] = T.facets[M] || { name: C }),
                (T.facets[M].data = T.facets[M].data || {}),
                (T.facets[M].data[K] = 0));
            }));
        }),
        (this.hierarchicalFacets = this.hierarchicalFacets.map(m(y))),
        (this.facets = e(this.facets)),
        (this.disjunctiveFacets = e(this.disjunctiveFacets)),
        (this._state = y));
    }
    c.prototype.getFacetByName = function (y) {
      function P(w) {
        return w.name === y;
      }
      return (
        r(this.facets, P) ||
        r(this.disjunctiveFacets, P) ||
        r(this.hierarchicalFacets, P)
      );
    };
    function g(y, P) {
      function w(A) {
        return A.name === P;
      }
      if (y._state.isConjunctiveFacet(P)) {
        var j = r(y.facets, w);
        return j
          ? Object.keys(j.data).map(function (A) {
              var C = l(A);
              return {
                name: A,
                escapedValue: C,
                count: j.data[A],
                isRefined: y._state.isFacetRefined(P, C),
                isExcluded: y._state.isExcludeRefined(P, A),
              };
            })
          : [];
      } else if (y._state.isDisjunctiveFacet(P)) {
        var T = r(y.disjunctiveFacets, w);
        return T
          ? Object.keys(T.data).map(function (A) {
              var C = l(A);
              return {
                name: A,
                escapedValue: C,
                count: T.data[A],
                isRefined: y._state.isDisjunctiveFacetRefined(P, C),
              };
            })
          : [];
      } else if (y._state.isHierarchicalFacet(P)) {
        var N = r(y.hierarchicalFacets, w);
        if (!N) return N;
        var Q = y._state.getHierarchicalFacetByName(P),
          W = y._state._getHierarchicalFacetSeparator(Q),
          G = f(y._state.getHierarchicalRefinement(P)[0] || "");
        G.indexOf(Q.rootPath) === 0 && (G = G.replace(Q.rootPath + W, ""));
        var B = G.split(W);
        return (B.unshift(P), v(N, B, 0), N);
      }
    }
    function v(y, P, w) {
      ((y.isRefined = y.name === (P[w] && P[w].trim())),
        y.data &&
          y.data.forEach(function (j) {
            v(j, P, w + 1);
          }));
    }
    function h(y, P, w, j) {
      if (((j = j || 0), Array.isArray(P))) return y(P, w[j]);
      if (!P.data || P.data.length === 0) return P;
      var T = P.data.map(function (W) {
          return h(y, W, w, j + 1);
        }),
        N = y(T, w[j]),
        Q = t({ data: N }, P);
      return Q;
    }
    c.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"];
    function b(y, P) {
      return P.sort(y);
    }
    function S(y, P) {
      var w = [],
        j = [],
        T = P.hide || [],
        N = P.order || [],
        Q = N.reduce(function (B, A, C) {
          return ((B[A] = C), B);
        }, {});
      (y.forEach(function (B) {
        var A = B.path || B.name,
          C = T.indexOf(A) > -1;
        !C && Q[A] !== void 0 ? (w[Q[A]] = B) : C || j.push(B);
      }),
        (w = w.filter(function (B) {
          return B;
        })));
      var W = P.sortRemainingBy,
        G;
      return W === "hidden"
        ? w
        : (W === "alpha"
            ? (G = [
                ["path", "name"],
                ["asc", "asc"],
              ])
            : (G = [["count"], ["desc"]]),
          w.concat(s(j, G[0], G[1])));
    }
    function O(y, P) {
      return (
        y.renderingContent &&
        y.renderingContent.facetOrdering &&
        y.renderingContent.facetOrdering.values &&
        y.renderingContent.facetOrdering.values[P]
      );
    }
    ((c.prototype.getFacetValues = function (y, P) {
      var w = g(this, y);
      if (w) {
        var j = t(P, {
            sortBy: c.DEFAULT_SORT,
            facetOrdering: !(P && P.sortBy),
          }),
          T = this,
          N;
        if (Array.isArray(w)) N = [y];
        else {
          var Q = T._state.getHierarchicalFacetByName(w.name);
          N = Q.attributes;
        }
        return h(
          function (W, G) {
            if (j.facetOrdering) {
              var B = O(T, G);
              if (B) return S(W, B);
            }
            if (Array.isArray(j.sortBy)) {
              var A = a(j.sortBy, c.DEFAULT_SORT);
              return s(W, A[0], A[1]);
            } else if (typeof j.sortBy == "function") return b(j.sortBy, W);
            throw new Error(
              "options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function",
            );
          },
          w,
          N,
        );
      }
    }),
      (c.prototype.getFacetStats = function (y) {
        if (this._state.isConjunctiveFacet(y)) return _(this.facets, y);
        if (this._state.isDisjunctiveFacet(y))
          return _(this.disjunctiveFacets, y);
      }));
    function _(y, P) {
      var w = r(y, function (j) {
        return j.name === P;
      });
      return w && w.stats;
    }
    c.prototype.getRefinements = function () {
      var y = this._state,
        P = this,
        w = [];
      return (
        Object.keys(y.facetsRefinements).forEach(function (j) {
          y.facetsRefinements[j].forEach(function (T) {
            w.push(R(y, "facet", j, T, P.facets));
          });
        }),
        Object.keys(y.facetsExcludes).forEach(function (j) {
          y.facetsExcludes[j].forEach(function (T) {
            w.push(R(y, "exclude", j, T, P.facets));
          });
        }),
        Object.keys(y.disjunctiveFacetsRefinements).forEach(function (j) {
          y.disjunctiveFacetsRefinements[j].forEach(function (T) {
            w.push(R(y, "disjunctive", j, T, P.disjunctiveFacets));
          });
        }),
        Object.keys(y.hierarchicalFacetsRefinements).forEach(function (j) {
          y.hierarchicalFacetsRefinements[j].forEach(function (T) {
            w.push($(y, j, T, P.hierarchicalFacets));
          });
        }),
        Object.keys(y.numericRefinements).forEach(function (j) {
          var T = y.numericRefinements[j];
          Object.keys(T).forEach(function (N) {
            T[N].forEach(function (Q) {
              w.push({
                type: "numeric",
                attributeName: j,
                name: Q,
                numericValue: Q,
                operator: N,
              });
            });
          });
        }),
        y.tagRefinements.forEach(function (j) {
          w.push({ type: "tag", attributeName: "_tags", name: j });
        }),
        w
      );
    };
    function R(y, P, w, j, T) {
      var N = r(T, function (G) {
          return G.name === w;
        }),
        Q = N && N.data && N.data[j] ? N.data[j] : 0,
        W = (N && N.exhaustive) || !1;
      return { type: P, attributeName: w, name: j, count: Q, exhaustive: W };
    }
    function $(y, P, w, j) {
      var T = y.getHierarchicalFacetByName(P),
        N = y._getHierarchicalFacetSeparator(T),
        Q = w.split(N),
        W = r(j, function (q) {
          return q.name === P;
        }),
        G = Q.reduce(function (q, M) {
          var K =
            q &&
            r(q.data, function (Y) {
              return Y.name === M;
            });
          return K !== void 0 ? K : q;
        }, W),
        B = (G && G.count) || 0,
        A = (G && G.exhaustive) || !1,
        C = (G && G.path) || "";
      return {
        type: "hierarchical",
        attributeName: P,
        name: C,
        count: B,
        exhaustive: A,
      };
    }
    return ((Cn = c), Cn);
  }
  var An, Ja;
  function Pl() {
    return (
      Ja ||
        ((Ja = 1),
        (An = function (t) {
          return t.reduce(function (n, r) {
            return n.concat(r);
          }, []);
        })),
      An
    );
  }
  var Dn, Ga;
  function _l() {
    if (Ga) return Dn;
    Ga = 1;
    var e = Mt(),
      t = Pl();
    function n(i, a) {
      var o = [];
      return (
        Object.keys(i).forEach(function (s) {
          (i[s].count < 2 && (i[s].indexSum += 100),
            o.push({ objectID: s, avgOfIndices: i[s].indexSum / a }));
        }),
        o.sort(function (s, l) {
          return s.avgOfIndices > l.avgOfIndices ? 1 : -1;
        })
      );
    }
    function r(i, a) {
      var o = {};
      a.forEach(function (f) {
        f.forEach(function (m, d) {
          i.includes(m.objectID) ||
            (o[m.objectID]
              ? (o[m.objectID] = {
                  indexSum: o[m.objectID].indexSum + d,
                  count: o[m.objectID].count + 1,
                })
              : (o[m.objectID] = { indexSum: d, count: 1 }));
        });
      });
      var s = n(o, a.length),
        l = s.reduce(function (f, m) {
          var d = e(t(a), function (p) {
            return p.objectID === m.objectID;
          });
          return d ? f.concat(d) : f;
        }, []);
      return l;
    }
    return ((Dn = r), Dn);
  }
  var Hn, Ya;
  function Xa() {
    return (Ya || ((Ya = 1), (Hn = "3.25.0")), Hn);
  }
  var Ln, Za;
  function Ol() {
    if (Za) return Ln;
    Za = 1;
    var e = sn(),
      t = fl(),
      n = ln().escapeFacetValue,
      r = Sa(),
      i = hn(),
      a = pn(),
      o = gn(),
      s = $a(),
      l = Fa(),
      f = hl(),
      m = La(),
      d = za(),
      p = _l(),
      u = Xa();
    function c(h, b, S, O) {
      (typeof h.addAlgoliaAgent == "function" &&
        h.addAlgoliaAgent("JS Helper (" + u + ")"),
        this.setClient(h));
      var _ = S || {};
      ((_.index = b),
        (this.state = m.make(_)),
        (this.recommendState = new s({ params: _.recommendState })),
        (this.lastResults = null),
        (this.lastRecommendResults = null),
        (this._queryId = 0),
        (this._recommendQueryId = 0),
        (this._lastQueryIdReceived = -1),
        (this._lastRecommendQueryIdReceived = -1),
        (this.derivedHelpers = []),
        (this._currentNbQueries = 0),
        (this._currentNbRecommendQueries = 0),
        (this._searchResultsOptions = O),
        (this._recommendCache = {}));
    }
    (r(c, e),
      (c.prototype.search = function () {
        return (this._search({ onlyWithDerivedHelpers: !1 }), this);
      }),
      (c.prototype.searchOnlyWithDerivedHelpers = function () {
        return (this._search({ onlyWithDerivedHelpers: !0 }), this);
      }),
      (c.prototype.searchWithComposition = function () {
        return (this._runComposition({ onlyWithDerivedHelpers: !0 }), this);
      }),
      (c.prototype.recommend = function () {
        return (this._recommend(), this);
      }),
      (c.prototype.getQuery = function () {
        var h = this.state;
        return f._getHitsSearchParams(h);
      }),
      (c.prototype.searchOnce = function (h, b) {
        var S = h ? this.state.setQueryParameters(h) : this.state,
          O = f._getQueries(S.index, S),
          _ = this;
        if (
          (this._currentNbQueries++, this.emit("searchOnce", { state: S }), b)
        ) {
          this.client
            .search(O)
            .then(function (R) {
              (_._currentNbQueries--,
                _._currentNbQueries === 0 && _.emit("searchQueueEmpty"),
                b(null, new d(S, R.results), S));
            })
            .catch(function (R) {
              (_._currentNbQueries--,
                _._currentNbQueries === 0 && _.emit("searchQueueEmpty"),
                b(R, null, S));
            });
          return;
        }
        return this.client.search(O).then(
          function (R) {
            return (
              _._currentNbQueries--,
              _._currentNbQueries === 0 && _.emit("searchQueueEmpty"),
              { content: new d(S, R.results), state: S, _originalResponse: R }
            );
          },
          function (R) {
            throw (
              _._currentNbQueries--,
              _._currentNbQueries === 0 && _.emit("searchQueueEmpty"),
              R
            );
          },
        );
      }),
      (c.prototype.findAnswers = function (h) {
        console.warn("[algoliasearch-helper] answers is no longer supported");
        var b = this.state,
          S = this.derivedHelpers[0];
        if (!S) return Promise.resolve([]);
        var O = S.getModifiedState(b),
          _ = i(
            {
              attributesForPrediction: h.attributesForPrediction,
              nbHits: h.nbHits,
            },
            {
              params: o(f._getHitsSearchParams(O), [
                "attributesToSnippet",
                "hitsPerPage",
                "restrictSearchableAttributes",
                "snippetEllipsisText",
              ]),
            },
          ),
          R =
            "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
        if (typeof this.client.initIndex != "function") throw new Error(R);
        var $ = this.client.initIndex(O.index);
        if (typeof $.findAnswers != "function") throw new Error(R);
        return $.findAnswers(O.query, h.queryLanguages, _);
      }),
      (c.prototype.searchForFacetValues = function (h, b, S, O) {
        var _ =
            typeof this.client.searchForFacetValues == "function" &&
            typeof this.client.searchForFacets != "function",
          R = typeof this.client.initIndex == "function";
        if (!_ && !R && typeof this.client.search != "function")
          throw new Error(
            "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues",
          );
        var $ = this.state.setQueryParameters(O || {}),
          y = $.isDisjunctiveFacet(h),
          P = f.getSearchForFacetQuery(h, b, S, $);
        this._currentNbQueries++;
        var w = this,
          j;
        return (
          _
            ? (j = this.client.searchForFacetValues([
                { indexName: $.index, params: P },
              ]))
            : R
              ? (j = this.client.initIndex($.index).searchForFacetValues(P))
              : (delete P.facetName,
                (j = this.client
                  .search([
                    { type: "facet", facet: h, indexName: $.index, params: P },
                  ])
                  .then(function (N) {
                    return N.results[0];
                  }))),
          this.emit("searchForFacetValues", { state: $, facet: h, query: b }),
          j.then(
            function (N) {
              return (
                w._currentNbQueries--,
                w._currentNbQueries === 0 && w.emit("searchQueueEmpty"),
                (N = Array.isArray(N) ? N[0] : N),
                N.facetHits.forEach(function (Q) {
                  ((Q.escapedValue = n(Q.value)),
                    (Q.isRefined = y
                      ? $.isDisjunctiveFacetRefined(h, Q.escapedValue)
                      : $.isFacetRefined(h, Q.escapedValue)));
                }),
                N
              );
            },
            function (T) {
              throw (
                w._currentNbQueries--,
                w._currentNbQueries === 0 && w.emit("searchQueueEmpty"),
                T
              );
            },
          )
        );
      }),
      (c.prototype.searchForCompositionFacetValues = function (h, b, S, O) {
        if (typeof this.client.searchForFacetValues != "function")
          throw new Error(
            "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues",
          );
        var _ = this.state.setQueryParameters(O || {}),
          R = _.isDisjunctiveFacet(h);
        this._currentNbQueries++;
        var $ = this,
          y;
        return (
          (y = this.client.searchForFacetValues({
            compositionID: _.index,
            facetName: h,
            searchForFacetValuesRequest: {
              params: {
                query: b,
                maxFacetHits: S,
                searchQuery: f._getCompositionHitsSearchParams(_),
              },
            },
          })),
          this.emit("searchForFacetValues", { state: _, facet: h, query: b }),
          y.then(
            function (w) {
              return (
                $._currentNbQueries--,
                $._currentNbQueries === 0 && $.emit("searchQueueEmpty"),
                (w = w.results[0]),
                w.facetHits.forEach(function (j) {
                  ((j.escapedValue = n(j.value)),
                    (j.isRefined = R
                      ? _.isDisjunctiveFacetRefined(h, j.escapedValue)
                      : _.isFacetRefined(h, j.escapedValue)));
                }),
                w
              );
            },
            function (P) {
              throw (
                $._currentNbQueries--,
                $._currentNbQueries === 0 && $.emit("searchQueueEmpty"),
                P
              );
            },
          )
        );
      }),
      (c.prototype.setQuery = function (h) {
        return (
          this._change({
            state: this.state.resetPage().setQuery(h),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.clearRefinements = function (h) {
        return (
          this._change({
            state: this.state.resetPage().clearRefinements(h),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.clearTags = function () {
        return (
          this._change({
            state: this.state.resetPage().clearTags(),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.addDisjunctiveFacetRefinement = function (h, b) {
        return (
          this._change({
            state: this.state.resetPage().addDisjunctiveFacetRefinement(h, b),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.addDisjunctiveRefine = function () {
        return this.addDisjunctiveFacetRefinement.apply(this, arguments);
      }),
      (c.prototype.addHierarchicalFacetRefinement = function (h, b) {
        return (
          this._change({
            state: this.state.resetPage().addHierarchicalFacetRefinement(h, b),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.addNumericRefinement = function (h, b, S) {
        return (
          this._change({
            state: this.state.resetPage().addNumericRefinement(h, b, S),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.addFacetRefinement = function (h, b) {
        return (
          this._change({
            state: this.state.resetPage().addFacetRefinement(h, b),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.addRefine = function () {
        return this.addFacetRefinement.apply(this, arguments);
      }),
      (c.prototype.addFacetExclusion = function (h, b) {
        return (
          this._change({
            state: this.state.resetPage().addExcludeRefinement(h, b),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.addExclude = function () {
        return this.addFacetExclusion.apply(this, arguments);
      }),
      (c.prototype.addTag = function (h) {
        return (
          this._change({
            state: this.state.resetPage().addTagRefinement(h),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.addFrequentlyBoughtTogether = function (h) {
        return (
          this._recommendChange({
            state: this.recommendState.addFrequentlyBoughtTogether(h),
          }),
          this
        );
      }),
      (c.prototype.addRelatedProducts = function (h) {
        return (
          this._recommendChange({
            state: this.recommendState.addRelatedProducts(h),
          }),
          this
        );
      }),
      (c.prototype.addTrendingItems = function (h) {
        return (
          this._recommendChange({
            state: this.recommendState.addTrendingItems(h),
          }),
          this
        );
      }),
      (c.prototype.addTrendingFacets = function (h) {
        return (
          this._recommendChange({
            state: this.recommendState.addTrendingFacets(h),
          }),
          this
        );
      }),
      (c.prototype.addLookingSimilar = function (h) {
        return (
          this._recommendChange({
            state: this.recommendState.addLookingSimilar(h),
          }),
          this
        );
      }),
      (c.prototype.removeNumericRefinement = function (h, b, S) {
        return (
          this._change({
            state: this.state.resetPage().removeNumericRefinement(h, b, S),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.removeDisjunctiveFacetRefinement = function (h, b) {
        return (
          this._change({
            state: this.state
              .resetPage()
              .removeDisjunctiveFacetRefinement(h, b),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.removeDisjunctiveRefine = function () {
        return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
      }),
      (c.prototype.removeHierarchicalFacetRefinement = function (h) {
        return (
          this._change({
            state: this.state.resetPage().removeHierarchicalFacetRefinement(h),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.removeFacetRefinement = function (h, b) {
        return (
          this._change({
            state: this.state.resetPage().removeFacetRefinement(h, b),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.removeRefine = function () {
        return this.removeFacetRefinement.apply(this, arguments);
      }),
      (c.prototype.removeFacetExclusion = function (h, b) {
        return (
          this._change({
            state: this.state.resetPage().removeExcludeRefinement(h, b),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.removeExclude = function () {
        return this.removeFacetExclusion.apply(this, arguments);
      }),
      (c.prototype.removeTag = function (h) {
        return (
          this._change({
            state: this.state.resetPage().removeTagRefinement(h),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.removeFrequentlyBoughtTogether = function (h) {
        return (
          this._recommendChange({ state: this.recommendState.removeParams(h) }),
          this
        );
      }),
      (c.prototype.removeRelatedProducts = function (h) {
        return (
          this._recommendChange({ state: this.recommendState.removeParams(h) }),
          this
        );
      }),
      (c.prototype.removeTrendingItems = function (h) {
        return (
          this._recommendChange({ state: this.recommendState.removeParams(h) }),
          this
        );
      }),
      (c.prototype.removeTrendingFacets = function (h) {
        return (
          this._recommendChange({ state: this.recommendState.removeParams(h) }),
          this
        );
      }),
      (c.prototype.removeLookingSimilar = function (h) {
        return (
          this._recommendChange({ state: this.recommendState.removeParams(h) }),
          this
        );
      }),
      (c.prototype.toggleFacetExclusion = function (h, b) {
        return (
          this._change({
            state: this.state.resetPage().toggleExcludeFacetRefinement(h, b),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.toggleExclude = function () {
        return this.toggleFacetExclusion.apply(this, arguments);
      }),
      (c.prototype.toggleRefinement = function (h, b) {
        return this.toggleFacetRefinement(h, b);
      }),
      (c.prototype.toggleFacetRefinement = function (h, b) {
        return (
          this._change({
            state: this.state.resetPage().toggleFacetRefinement(h, b),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.toggleRefine = function () {
        return this.toggleFacetRefinement.apply(this, arguments);
      }),
      (c.prototype.toggleTag = function (h) {
        return (
          this._change({
            state: this.state.resetPage().toggleTagRefinement(h),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.nextPage = function () {
        var h = this.state.page || 0;
        return this.setPage(h + 1);
      }),
      (c.prototype.previousPage = function () {
        var h = this.state.page || 0;
        return this.setPage(h - 1);
      }));
    function g(h) {
      if (h < 0) throw new Error("Page requested below 0.");
      return (
        this._change({ state: this.state.setPage(h), isPageReset: !1 }),
        this
      );
    }
    ((c.prototype.setCurrentPage = g),
      (c.prototype.setPage = g),
      (c.prototype.setIndex = function (h) {
        return (
          this._change({
            state: this.state.resetPage().setIndex(h),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.setQueryParameter = function (h, b) {
        return (
          this._change({
            state: this.state.resetPage().setQueryParameter(h, b),
            isPageReset: !0,
          }),
          this
        );
      }),
      (c.prototype.setState = function (h) {
        return (this._change({ state: m.make(h), isPageReset: !1 }), this);
      }),
      (c.prototype.overrideStateWithoutTriggeringChangeEvent = function (h) {
        return ((this.state = new m(h)), this);
      }),
      (c.prototype.hasRefinements = function (h) {
        return a(this.state.getNumericRefinements(h))
          ? !0
          : this.state.isConjunctiveFacet(h)
            ? this.state.isFacetRefined(h)
            : this.state.isDisjunctiveFacet(h)
              ? this.state.isDisjunctiveFacetRefined(h)
              : this.state.isHierarchicalFacet(h)
                ? this.state.isHierarchicalFacetRefined(h)
                : !1;
      }),
      (c.prototype.isExcluded = function (h, b) {
        return this.state.isExcludeRefined(h, b);
      }),
      (c.prototype.isDisjunctiveRefined = function (h, b) {
        return this.state.isDisjunctiveFacetRefined(h, b);
      }),
      (c.prototype.hasTag = function (h) {
        return this.state.isTagRefined(h);
      }),
      (c.prototype.isTagRefined = function () {
        return this.hasTagRefinements.apply(this, arguments);
      }),
      (c.prototype.getIndex = function () {
        return this.state.index;
      }));
    function v() {
      return this.state.page;
    }
    return (
      (c.prototype.getCurrentPage = v),
      (c.prototype.getPage = v),
      (c.prototype.getTags = function () {
        return this.state.tagRefinements;
      }),
      (c.prototype.getRefinements = function (h) {
        var b = [];
        if (this.state.isConjunctiveFacet(h)) {
          var S = this.state.getConjunctiveRefinements(h);
          S.forEach(function ($) {
            b.push({ value: $, type: "conjunctive" });
          });
          var O = this.state.getExcludeRefinements(h);
          O.forEach(function ($) {
            b.push({ value: $, type: "exclude" });
          });
        } else if (this.state.isDisjunctiveFacet(h)) {
          var _ = this.state.getDisjunctiveRefinements(h);
          _.forEach(function ($) {
            b.push({ value: $, type: "disjunctive" });
          });
        }
        var R = this.state.getNumericRefinements(h);
        return (
          Object.keys(R).forEach(function ($) {
            var y = R[$];
            b.push({ value: y, operator: $, type: "numeric" });
          }),
          b
        );
      }),
      (c.prototype.getNumericRefinement = function (h, b) {
        return this.state.getNumericRefinement(h, b);
      }),
      (c.prototype.getHierarchicalFacetBreadcrumb = function (h) {
        return this.state.getHierarchicalFacetBreadcrumb(h);
      }),
      (c.prototype._search = function (h) {
        var b = this.state,
          S = [],
          O = [];
        h.onlyWithDerivedHelpers ||
          ((O = f._getQueries(b.index, b)),
          S.push({ state: b, queriesCount: O.length, helper: this }),
          this.emit("search", { state: b, results: this.lastResults }));
        var _ = this.derivedHelpers.map(function (y) {
            var P = y.getModifiedState(b),
              w = P.index ? f._getQueries(P.index, P) : [];
            return (
              S.push({ state: P, queriesCount: w.length, helper: y }),
              y.emit("search", { state: P, results: y.lastResults }),
              w
            );
          }),
          R = Array.prototype.concat.apply(O, _),
          $ = this._queryId++;
        if ((this._currentNbQueries++, !R.length))
          return Promise.resolve({ results: [] }).then(
            this._dispatchAlgoliaResponse.bind(this, S, $),
          );
        try {
          this.client
            .search(R)
            .then(this._dispatchAlgoliaResponse.bind(this, S, $))
            .catch(this._dispatchAlgoliaError.bind(this, $));
        } catch (y) {
          this.emit("error", { error: y });
        }
      }),
      (c.prototype._runComposition = function () {
        var h = this.state,
          b = [],
          S = [],
          O = this.derivedHelpers.map(function (y) {
            var P = y.getModifiedState(h),
              w = f._getCompositionQueries(P);
            return (
              b.push({ state: P, queriesCount: w.length, helper: y }),
              y.emit("search", { state: P, results: y.lastResults }),
              w
            );
          }),
          _ = Array.prototype.concat.apply(S, O),
          R = this._queryId++;
        if ((this._currentNbQueries++, !_.length))
          return Promise.resolve({ results: [] }).then(
            this._dispatchAlgoliaResponse.bind(this, b, R),
          );
        if (_.length > 1)
          throw new Error(
            "Only one query is allowed when using a composition.",
          );
        var $ = _[0];
        try {
          this.client
            .search($)
            .then(this._dispatchAlgoliaResponse.bind(this, b, R))
            .catch(this._dispatchAlgoliaError.bind(this, R));
        } catch (y) {
          this.emit("error", { error: y });
        }
      }),
      (c.prototype._recommend = function () {
        var h = this.state,
          b = this.recommendState,
          S = this.getIndex(),
          O = [{ state: b, index: S, helper: this }],
          _ = b.params.map(function (w) {
            return w.$$id;
          });
        this.emit("fetch", {
          recommend: { state: b, results: this.lastRecommendResults },
        });
        var R = this._recommendCache,
          $ = this.derivedHelpers.map(function (w) {
            var j = w.getModifiedState(h).index;
            if (!j) return [];
            var T = w.getModifiedRecommendState(new s());
            return (
              O.push({ state: T, index: j, helper: w }),
              (_ = Array.prototype.concat.apply(
                _,
                T.params.map(function (N) {
                  return N.$$id;
                }),
              )),
              w.emit("fetch", {
                recommend: { state: T, results: w.lastRecommendResults },
              }),
              T._buildQueries(j, R)
            );
          }),
          y = Array.prototype.concat.apply(
            this.recommendState._buildQueries(S, R),
            $,
          );
        if (y.length !== 0) {
          if (y.length > 0 && typeof this.client.getRecommendations > "u") {
            console.warn(
              "Please update algoliasearch/lite to the latest version in order to use recommend widgets.",
            );
            return;
          }
          var P = this._recommendQueryId++;
          this._currentNbRecommendQueries++;
          try {
            this.client
              .getRecommendations(y)
              .then(this._dispatchRecommendResponse.bind(this, P, O, _))
              .catch(this._dispatchRecommendError.bind(this, P));
          } catch (w) {
            this.emit("error", { error: w });
          }
        }
      }),
      (c.prototype._dispatchAlgoliaResponse = function (h, b, S) {
        var O = this;
        if (!(b < this._lastQueryIdReceived)) {
          ((this._currentNbQueries -= b - this._lastQueryIdReceived),
            (this._lastQueryIdReceived = b),
            this._currentNbQueries === 0 && this.emit("searchQueueEmpty"));
          var _ = S.results.slice(),
            R = Object.keys(S).reduce(function ($, y) {
              return (y !== "results" && ($[y] = S[y]), $);
            }, {});
          (Object.keys(R).length <= 0 && (R = void 0),
            h.forEach(function ($) {
              var y = $.state,
                P = $.queriesCount,
                w = $.helper,
                j = _.splice(0, P);
              if (!y.index) {
                w.emit("result", { results: null, state: y });
                return;
              }
              ((w.lastResults = new d(y, j, O._searchResultsOptions)),
                R !== void 0 && (w.lastResults._rawContent = R),
                w.emit("result", { results: w.lastResults, state: y }));
            }));
        }
      }),
      (c.prototype._dispatchRecommendResponse = function (h, b, S, O) {
        if (!(h < this._lastRecommendQueryIdReceived)) {
          ((this._currentNbRecommendQueries -=
            h - this._lastRecommendQueryIdReceived),
            (this._lastRecommendQueryIdReceived = h),
            this._currentNbRecommendQueries === 0 &&
              this.emit("recommendQueueEmpty"));
          var _ = this._recommendCache,
            R = {};
          (S.filter(function (y) {
            return _[y] === void 0;
          }).forEach(function (y, P) {
            (R[y] || (R[y] = []), R[y].push(P));
          }),
            Object.keys(R).forEach(function (y) {
              var P = R[y],
                w = O.results[P[0]];
              if (P.length === 1) {
                _[y] = w;
                return;
              }
              _[y] = Object.assign({}, w, {
                hits: p(
                  S,
                  P.map(function (j) {
                    return O.results[j].hits;
                  }),
                ),
              });
            }));
          var $ = {};
          (S.forEach(function (y) {
            $[y] = _[y];
          }),
            b.forEach(function (y) {
              var P = y.state,
                w = y.helper;
              if (!y.index) {
                w.emit("recommend:result", { results: null, state: P });
                return;
              }
              ((w.lastRecommendResults = new l(P, $)),
                w.emit("recommend:result", {
                  recommend: { results: w.lastRecommendResults, state: P },
                }));
            }));
        }
      }),
      (c.prototype._dispatchAlgoliaError = function (h, b) {
        h < this._lastQueryIdReceived ||
          ((this._currentNbQueries -= h - this._lastQueryIdReceived),
          (this._lastQueryIdReceived = h),
          this.emit("error", { error: b }),
          this._currentNbQueries === 0 && this.emit("searchQueueEmpty"));
      }),
      (c.prototype._dispatchRecommendError = function (h, b) {
        h < this._lastRecommendQueryIdReceived ||
          ((this._currentNbRecommendQueries -=
            h - this._lastRecommendQueryIdReceived),
          (this._lastRecommendQueryIdReceived = h),
          this.emit("error", { error: b }),
          this._currentNbRecommendQueries === 0 &&
            this.emit("recommendQueueEmpty"));
      }),
      (c.prototype.containsRefinement = function (h, b, S, O) {
        return h || b.length !== 0 || S.length !== 0 || O.length !== 0;
      }),
      (c.prototype._hasDisjunctiveRefinements = function (h) {
        return (
          this.state.disjunctiveRefinements[h] &&
          this.state.disjunctiveRefinements[h].length > 0
        );
      }),
      (c.prototype._change = function (h) {
        var b = h.state,
          S = h.isPageReset;
        b !== this.state &&
          ((this.state = b),
          this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: S,
          }));
      }),
      (c.prototype._recommendChange = function (h) {
        var b = h.state;
        b !== this.recommendState &&
          ((this.recommendState = b),
          this.emit("recommend:change", {
            search: { results: this.lastResults, state: this.state },
            recommend: {
              results: this.lastRecommendResults,
              state: this.recommendState,
            },
          }));
      }),
      (c.prototype.clearCache = function () {
        return (this.client.clearCache && this.client.clearCache(), this);
      }),
      (c.prototype.setClient = function (h) {
        return this.client === h
          ? this
          : (typeof h.addAlgoliaAgent == "function" &&
              h.addAlgoliaAgent("JS Helper (" + u + ")"),
            (this.client = h),
            this);
      }),
      (c.prototype.getClient = function () {
        return this.client;
      }),
      (c.prototype.derive = function (h, b) {
        var S = new t(this, h, b);
        return (this.derivedHelpers.push(S), S);
      }),
      (c.prototype.detachDerivedHelper = function (h) {
        var b = this.derivedHelpers.indexOf(h);
        if (b === -1) throw new Error("Derived helper already detached");
        this.derivedHelpers.splice(b, 1);
      }),
      (c.prototype.hasPendingRequests = function () {
        return this._currentNbQueries > 0;
      }),
      (Ln = c),
      Ln
    );
  }
  var Mn, es;
  function wl() {
    if (es) return Mn;
    es = 1;
    var e = Ol(),
      t = $a(),
      n = Fa(),
      r = La(),
      i = za();
    function a(o, s, l, f) {
      return new e(o, s, l, f);
    }
    return (
      (a.version = Xa()),
      (a.AlgoliaSearchHelper = e),
      (a.SearchParameters = r),
      (a.RecommendParameters = t),
      (a.SearchResults = i),
      (a.RecommendResults = n),
      (Mn = a),
      Mn
    );
  }
  var Rl = wl();
  const Se = wt(Rl);
  function jl() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (e) {
        var t = (Math.random() * 16) | 0,
          n = e === "x" ? t : (t & 3) | 8;
        return n.toString(16);
      },
    );
  }
  function Wt(e) {
    "@babel/helpers - typeof";
    return (
      (Wt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Wt(e)
    );
  }
  function ts(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Xe(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? ts(Object(n), !0).forEach(function (r) {
            $l(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : ts(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function $l(e, t, n) {
    return (
      (t = xl(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function xl(e) {
    var t = Fl(e, "string");
    return Wt(t) == "symbol" ? t : String(t);
  }
  function Fl(e, t) {
    if (Wt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Wt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function He(e, t) {
    return Il(e) || Tl(e, t) || rs(e, t) || El();
  }
  function El() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Tl(e, t) {
    var n =
      e == null
        ? null
        : (typeof Symbol < "u" && e[Symbol.iterator]) || e["@@iterator"];
    if (n != null) {
      var r,
        i,
        a,
        o,
        s = [],
        l = !0,
        f = !1;
      try {
        if (((a = (n = n.call(e)).next), t === 0)) {
          if (Object(n) !== n) return;
          l = !1;
        } else
          for (
            ;
            !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== t);
            l = !0
          );
      } catch (m) {
        ((f = !0), (i = m));
      } finally {
        try {
          if (!l && n.return != null && ((o = n.return()), Object(o) !== o))
            return;
        } finally {
          if (f) throw i;
        }
      }
      return s;
    }
  }
  function Il(e) {
    if (Array.isArray(e)) return e;
  }
  function Nl(e) {
    return Dl(e) || Al(e) || rs(e) || Cl();
  }
  function Cl() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function rs(e, t) {
    if (e) {
      if (typeof e == "string") return Wn(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return Wn(e, t);
    }
  }
  function Al(e) {
    if (
      (typeof Symbol < "u" && e[Symbol.iterator] != null) ||
      e["@@iterator"] != null
    )
      return Array.from(e);
  }
  function Dl(e) {
    if (Array.isArray(e)) return Wn(e);
  }
  function Wn(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  var ns = "2.17.2",
    Hl = "https://cdn.jsdelivr.net/npm/search-insights@".concat(
      ns,
      "/dist/search-insights.min.js",
    );
  function is() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      t = e.insightsClient,
      n = e.insightsInitParams,
      r = e.onEvent,
      i = e.$$internal,
      a = i === void 0 ? !1 : i,
      o = e.$$automatic,
      s = o === void 0 ? !1 : o,
      l = t;
    !t &&
      t !== null &&
      Ie(function (m) {
        var d = m.window,
          p = d.AlgoliaAnalyticsObject || "aa";
        (typeof p == "string" && (l = d[p]),
          l ||
            ((d.AlgoliaAnalyticsObject = p),
            d[p] ||
              ((d[p] = function () {
                d[p].queue || (d[p].queue = []);
                for (
                  var u = arguments.length, c = new Array(u), g = 0;
                  g < u;
                  g++
                )
                  c[g] = arguments[g];
                d[p].queue.push(c);
              }),
              (d[p].version = ns),
              (d[p].shouldAddScript = !0)),
            (l = d[p])));
      });
    var f = l || he;
    return function (m) {
      var d = m.instantSearchInstance,
        p = d.middleware
          .filter(function (P) {
            return (
              P.instance.$$type === "ais.insights" && P.instance.$$internal
            );
          })
          .map(function (P) {
            return P.creator;
          });
      d.unuse.apply(d, Nl(p));
      var u = Ji(d.client),
        c = He(u, 2),
        g = c[0],
        v = c[1],
        h = void 0,
        b = void 0,
        S = void 0,
        O = f.queue;
      if (Array.isArray(O)) {
        var _ = ["setUserToken", "init"].map(function (P) {
            var w =
                _r(O.slice().reverse(), function (N) {
                  var Q = He(N, 1),
                    W = Q[0];
                  return W === P;
                }) || [],
              j = He(w, 2),
              T = j[1];
            return T;
          }),
          R = He(_, 2);
        ((b = R[0]), (h = R[1]));
      }
      (f("getUserToken", null, function (P, w) {
        S = ss(w);
      }),
        (n || !as(f)) &&
          f("init", Xe({ appId: g, apiKey: v, partial: !0 }, n)));
      var $, y;
      return {
        $$type: "ais.insights",
        $$internal: a,
        $$automatic: s,
        onStateChange: function () {},
        subscribe: function () {
          if (f.shouldAddScript) {
            var w =
              "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
            try {
              var j = document.createElement("script");
              ((j.async = !0),
                (j.src = Hl),
                (j.onerror = function () {
                  d.emit("error", new Error(w));
                }),
                document.body.appendChild(j),
                (f.shouldAddScript = !1));
            } catch {
              ((f.shouldAddScript = !1), d.emit("error", new Error(w)));
            }
          }
        },
        started: function () {
          (f("addAlgoliaAgent", "insights-middleware"), (y = d.mainHelper));
          var w = f.queue;
          if (Array.isArray(w)) {
            var j = ["setUserToken", "init"].map(function (k) {
                var z =
                    _r(w.slice().reverse(), function (F) {
                      var E = He(F, 1),
                        I = E[0];
                      return I === k;
                    }) || [],
                  ee = He(z, 2),
                  x = ee[1];
                return x;
              }),
              T = He(j, 2);
            ((b = T[0]), (h = T[1]));
          }
          (($ = Ll(d)),
            s ||
              y.overrideStateWithoutTriggeringChangeEvent(
                Xe(Xe({}, y.state), {}, { clickAnalytics: !0 }),
              ),
            a || d.scheduleSearch());
          var N = function (z) {
            var ee =
                arguments.length > 1 && arguments[1] !== void 0
                  ? arguments[1]
                  : !1,
              x = ss(z);
            if (!x) return;
            var F = y.state.userToken;
            function E() {
              (y.overrideStateWithoutTriggeringChangeEvent(
                Xe(Xe({}, y.state), {}, { userToken: x }),
              ),
                F && F !== z && d.scheduleSearch());
            }
            ee ? E() : setTimeout(E, 0);
          };
          function Q(k) {
            (N(k, !0), f("setUserToken", k));
          }
          var W = void 0,
            G = ga();
          if (G) W = G;
          else {
            var B = "anonymous-".concat(jl());
            W = B;
          }
          var A,
            C = $.userToken;
          if ((n != null && n.userToken && (A = n.userToken), A)) Q(A);
          else if (C) Q(C);
          else if (S) Q(S);
          else if (b) Q(b);
          else if (W) {
            var q;
            if (
              (Q(W),
              (n != null && n.useCookie) ||
                ((q = h) !== null && q !== void 0 && q.useCookie))
            ) {
              var M;
              Ml(
                W,
                (n == null ? void 0 : n.cookieDuration) ||
                  ((M = h) === null || M === void 0
                    ? void 0
                    : M.cookieDuration),
              );
            }
          }
          f(
            "onUserTokenChange",
            function (k) {
              return N(k, !0);
            },
            { immediate: !0 },
          );
          var K = f;
          as(f) &&
            (K = function (z, ee) {
              var x = Ji(d.client),
                F = He(x, 2),
                E = F[0],
                I = F[1],
                D = {
                  headers: {
                    "X-Algolia-Application-Id": E,
                    "X-Algolia-API-Key": I,
                  },
                };
              return f(z, ee, D);
            });
          var Y = new Set(),
            Z;
          (d.mainHelper.derivedHelpers[0].on("result", function (k) {
            var z = k.results;
            z &&
              (!z.queryID || z.queryID !== Z) &&
              ((Z = z.queryID), Y.clear());
          }),
            (d.sendEventToInsights = function (k) {
              if (r) r(k, K);
              else if (k.insightsMethod) {
                if (k.insightsMethod === "viewedObjectIDs") {
                  var z = k.payload,
                    ee = z.objectIDs.filter(function (x) {
                      return !Y.has(x);
                    });
                  if (ee.length === 0) return;
                  (ee.forEach(function (x) {
                    return Y.add(x);
                  }),
                    (z.objectIDs = ee));
                }
                ((k.payload.algoliaSource = ["instantsearch"]),
                  s && k.payload.algoliaSource.push("instantsearch-automatic"),
                  k.eventModifier === "internal" &&
                    k.payload.algoliaSource.push("instantsearch-internal"),
                  K(k.insightsMethod, k.payload));
              }
            }));
        },
        unsubscribe: function () {
          (f("onUserTokenChange", void 0),
            (d.sendEventToInsights = he),
            y &&
              $ &&
              (y.overrideStateWithoutTriggeringChangeEvent(
                Xe(Xe({}, y.state), $),
              ),
              d.scheduleSearch()));
        },
      };
    };
  }
  function Ll(e) {
    var t,
      n,
      r =
        ((t = e._initialResults) === null ||
        t === void 0 ||
        (n = t[e.indexName]) === null ||
        n === void 0
          ? void 0
          : n.state) || {},
      i = e.mainHelper.state;
    return {
      userToken: r.userToken || i.userToken,
      clickAnalytics: r.clickAnalytics || i.clickAnalytics,
    };
  }
  function Ml(e, t) {
    var n = 2592e6,
      r = new Date();
    r.setTime(r.getTime() + (t || n * 6));
    var i = "expires=".concat(r.toUTCString());
    document.cookie = "_ALGOLIA=".concat(e, ";").concat(i, ";path=/");
  }
  function as(e) {
    var t = (e.version || "").split(".").map(Number),
      n = He(t, 2),
      r = n[0],
      i = n[1],
      a = r >= 3,
      o = r === 2 && i >= 6,
      s = r === 1 && i >= 10;
    return a || o || s;
  }
  function ss(e) {
    if (e) return typeof e == "number" ? e.toString() : e;
  }
  function os(e, t, n) {
    var r = Ht(t, t.mainIndex, t._initialUiState);
    e.forEach(function (i) {
      var a = {};
      if (i.getWidgetRenderState) {
        var o = i.getWidgetRenderState(r);
        o && o.widgetParams && (a = o.widgetParams);
      }
      var s = Object.keys(a).filter(function (l) {
        return a[l] !== void 0;
      });
      (n.widgets.push({
        type: i.$$type,
        widgetType: i.$$widgetType,
        params: s,
      }),
        i.$$type === "ais.index" && os(i.getWidgets(), t, n));
    });
  }
  function Wl() {
    return Ie(
      function (e) {
        var t,
          n,
          r = e.window;
        return (
          ((t = r.navigator) === null ||
          t === void 0 ||
          (n = t.userAgent) === null ||
          n === void 0
            ? void 0
            : n.indexOf("Algolia Crawler")) > -1
        );
      },
      {
        fallback: function () {
          return !1;
        },
      },
    );
  }
  function ql() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      t = e.$$internal,
      n = t === void 0 ? !1 : t;
    return function (r) {
      var i = r.instantSearchInstance,
        a = { widgets: [] },
        o = document.createElement("meta"),
        s = document.querySelector("head");
      return (
        (o.name = "instantsearch:widgets"),
        {
          $$type: "ais.metadata",
          $$internal: n,
          onStateChange: function () {},
          subscribe: function () {
            setTimeout(function () {
              var f = i.client;
              ((a.ua =
                f.transporter && f.transporter.userAgent
                  ? f.transporter.userAgent.value
                  : f._ua),
                os(i.mainIndex.getWidgets(), i, a),
                i.middleware.forEach(function (m) {
                  return a.widgets.push({
                    middleware: !0,
                    type: m.instance.$$type,
                    internal: m.instance.$$internal,
                  });
                }),
                (o.content = JSON.stringify(a)),
                s.appendChild(o));
            }, 0);
          },
          started: function () {},
          unsubscribe: function () {
            o.remove();
          },
        }
      );
    };
  }
  var qn, us;
  function Un() {
    if (us) return qn;
    us = 1;
    var e = String.prototype.replace,
      t = /%20/g,
      n = { RFC1738: "RFC1738", RFC3986: "RFC3986" };
    return (
      (qn = {
        default: n.RFC3986,
        formatters: {
          RFC1738: function (r) {
            return e.call(r, t, "+");
          },
          RFC3986: function (r) {
            return String(r);
          },
        },
        RFC1738: n.RFC1738,
        RFC3986: n.RFC3986,
      }),
      qn
    );
  }
  var kn, cs;
  function ls() {
    if (cs) return kn;
    cs = 1;
    var e = Un(),
      t = Object.prototype.hasOwnProperty,
      n = Array.isArray,
      r = (function () {
        for (var g = [], v = 0; v < 256; ++v)
          g.push("%" + ((v < 16 ? "0" : "") + v.toString(16)).toUpperCase());
        return g;
      })(),
      i = function (v) {
        for (; v.length > 1; ) {
          var h = v.pop(),
            b = h.obj[h.prop];
          if (n(b)) {
            for (var S = [], O = 0; O < b.length; ++O)
              typeof b[O] < "u" && S.push(b[O]);
            h.obj[h.prop] = S;
          }
        }
      },
      a = function (v, h) {
        for (
          var b = h && h.plainObjects ? Object.create(null) : {}, S = 0;
          S < v.length;
          ++S
        )
          typeof v[S] < "u" && (b[S] = v[S]);
        return b;
      },
      o = function g(v, h, b) {
        if (!h) return v;
        if (typeof h != "object") {
          if (n(v)) v.push(h);
          else if (v && typeof v == "object")
            ((b && (b.plainObjects || b.allowPrototypes)) ||
              !t.call(Object.prototype, h)) &&
              (v[h] = !0);
          else return [v, h];
          return v;
        }
        if (!v || typeof v != "object") return [v].concat(h);
        var S = v;
        return (
          n(v) && !n(h) && (S = a(v, b)),
          n(v) && n(h)
            ? (h.forEach(function (O, _) {
                if (t.call(v, _)) {
                  var R = v[_];
                  R && typeof R == "object" && O && typeof O == "object"
                    ? (v[_] = g(R, O, b))
                    : v.push(O);
                } else v[_] = O;
              }),
              v)
            : Object.keys(h).reduce(function (O, _) {
                var R = h[_];
                return (t.call(O, _) ? (O[_] = g(O[_], R, b)) : (O[_] = R), O);
              }, S)
        );
      },
      s = function (v, h) {
        return Object.keys(h).reduce(function (b, S) {
          return ((b[S] = h[S]), b);
        }, v);
      },
      l = function (g, v, h) {
        var b = g.replace(/\+/g, " ");
        if (h === "iso-8859-1") return b.replace(/%[0-9a-f]{2}/gi, unescape);
        try {
          return decodeURIComponent(b);
        } catch {
          return b;
        }
      },
      f = function (v, h, b, S, O) {
        if (v.length === 0) return v;
        var _ = v;
        if (
          (typeof v == "symbol"
            ? (_ = Symbol.prototype.toString.call(v))
            : typeof v != "string" && (_ = String(v)),
          b === "iso-8859-1")
        )
          return escape(_).replace(/%u[0-9a-f]{4}/gi, function (P) {
            return "%26%23" + parseInt(P.slice(2), 16) + "%3B";
          });
        for (var R = "", $ = 0; $ < _.length; ++$) {
          var y = _.charCodeAt($);
          if (
            y === 45 ||
            y === 46 ||
            y === 95 ||
            y === 126 ||
            (y >= 48 && y <= 57) ||
            (y >= 65 && y <= 90) ||
            (y >= 97 && y <= 122) ||
            (O === e.RFC1738 && (y === 40 || y === 41))
          ) {
            R += _.charAt($);
            continue;
          }
          if (y < 128) {
            R = R + r[y];
            continue;
          }
          if (y < 2048) {
            R = R + (r[192 | (y >> 6)] + r[128 | (y & 63)]);
            continue;
          }
          if (y < 55296 || y >= 57344) {
            R =
              R +
              (r[224 | (y >> 12)] +
                r[128 | ((y >> 6) & 63)] +
                r[128 | (y & 63)]);
            continue;
          }
          (($ += 1),
            (y = 65536 + (((y & 1023) << 10) | (_.charCodeAt($) & 1023))),
            (R +=
              r[240 | (y >> 18)] +
              r[128 | ((y >> 12) & 63)] +
              r[128 | ((y >> 6) & 63)] +
              r[128 | (y & 63)]));
        }
        return R;
      },
      m = function (v) {
        for (
          var h = [{ obj: { o: v }, prop: "o" }], b = [], S = 0;
          S < h.length;
          ++S
        )
          for (
            var O = h[S], _ = O.obj[O.prop], R = Object.keys(_), $ = 0;
            $ < R.length;
            ++$
          ) {
            var y = R[$],
              P = _[y];
            typeof P == "object" &&
              P !== null &&
              b.indexOf(P) === -1 &&
              (h.push({ obj: _, prop: y }), b.push(P));
          }
        return (i(h), v);
      },
      d = function (v) {
        return Object.prototype.toString.call(v) === "[object RegExp]";
      },
      p = function (v) {
        return !v || typeof v != "object"
          ? !1
          : !!(
              v.constructor &&
              v.constructor.isBuffer &&
              v.constructor.isBuffer(v)
            );
      },
      u = function (v, h) {
        return [].concat(v, h);
      },
      c = function (v, h) {
        if (n(v)) {
          for (var b = [], S = 0; S < v.length; S += 1) b.push(h(v[S]));
          return b;
        }
        return h(v);
      };
    return (
      (kn = {
        arrayToObject: a,
        assign: s,
        combine: u,
        compact: m,
        decode: l,
        encode: f,
        isBuffer: p,
        isRegExp: d,
        maybeMap: c,
        merge: o,
      }),
      kn
    );
  }
  var Qn, fs;
  function Ul() {
    if (fs) return Qn;
    fs = 1;
    var e = ls(),
      t = Un(),
      n = Object.prototype.hasOwnProperty,
      r = {
        brackets: function (g) {
          return g + "[]";
        },
        comma: "comma",
        indices: function (g, v) {
          return g + "[" + v + "]";
        },
        repeat: function (g) {
          return g;
        },
      },
      i = Array.isArray,
      a = String.prototype.split,
      o = Array.prototype.push,
      s = function (c, g) {
        o.apply(c, i(g) ? g : [g]);
      },
      l = Date.prototype.toISOString,
      f = t.default,
      m = {
        addQueryPrefix: !1,
        allowDots: !1,
        charset: "utf-8",
        charsetSentinel: !1,
        delimiter: "&",
        encode: !0,
        encoder: e.encode,
        encodeValuesOnly: !1,
        format: f,
        formatter: t.formatters[f],
        indices: !1,
        serializeDate: function (g) {
          return l.call(g);
        },
        skipNulls: !1,
        strictNullHandling: !1,
      },
      d = function (g) {
        return (
          typeof g == "string" ||
          typeof g == "number" ||
          typeof g == "boolean" ||
          typeof g == "symbol" ||
          typeof g == "bigint"
        );
      },
      p = function c(g, v, h, b, S, O, _, R, $, y, P, w, j, T) {
        var N = g;
        if (
          (typeof _ == "function"
            ? (N = _(v, N))
            : N instanceof Date
              ? (N = y(N))
              : h === "comma" &&
                i(N) &&
                (N = e.maybeMap(N, function (k) {
                  return k instanceof Date ? y(k) : k;
                })),
          N === null)
        ) {
          if (b) return O && !j ? O(v, m.encoder, T, "key", P) : v;
          N = "";
        }
        if (d(N) || e.isBuffer(N)) {
          if (O) {
            var Q = j ? v : O(v, m.encoder, T, "key", P);
            if (h === "comma" && j) {
              for (
                var W = a.call(String(N), ","), G = "", B = 0;
                B < W.length;
                ++B
              )
                G +=
                  (B === 0 ? "" : ",") + w(O(W[B], m.encoder, T, "value", P));
              return [w(Q) + "=" + G];
            }
            return [w(Q) + "=" + w(O(N, m.encoder, T, "value", P))];
          }
          return [w(v) + "=" + w(String(N))];
        }
        var A = [];
        if (typeof N > "u") return A;
        var C;
        if (h === "comma" && i(N))
          C = [{ value: N.length > 0 ? N.join(",") || null : void 0 }];
        else if (i(_)) C = _;
        else {
          var q = Object.keys(N);
          C = R ? q.sort(R) : q;
        }
        for (var M = 0; M < C.length; ++M) {
          var K = C[M],
            Y = typeof K == "object" && typeof K.value < "u" ? K.value : N[K];
          if (!(S && Y === null)) {
            var Z = i(N)
              ? typeof h == "function"
                ? h(v, K)
                : v
              : v + ($ ? "." + K : "[" + K + "]");
            s(A, c(Y, Z, h, b, S, O, _, R, $, y, P, w, j, T));
          }
        }
        return A;
      },
      u = function (g) {
        if (!g) return m;
        if (
          g.encoder !== null &&
          typeof g.encoder < "u" &&
          typeof g.encoder != "function"
        )
          throw new TypeError("Encoder has to be a function.");
        var v = g.charset || m.charset;
        if (
          typeof g.charset < "u" &&
          g.charset !== "utf-8" &&
          g.charset !== "iso-8859-1"
        )
          throw new TypeError(
            "The charset option must be either utf-8, iso-8859-1, or undefined",
          );
        var h = t.default;
        if (typeof g.format < "u") {
          if (!n.call(t.formatters, g.format))
            throw new TypeError("Unknown format option provided.");
          h = g.format;
        }
        var b = t.formatters[h],
          S = m.filter;
        return (
          (typeof g.filter == "function" || i(g.filter)) && (S = g.filter),
          {
            addQueryPrefix:
              typeof g.addQueryPrefix == "boolean"
                ? g.addQueryPrefix
                : m.addQueryPrefix,
            allowDots: typeof g.allowDots > "u" ? m.allowDots : !!g.allowDots,
            charset: v,
            charsetSentinel:
              typeof g.charsetSentinel == "boolean"
                ? g.charsetSentinel
                : m.charsetSentinel,
            delimiter: typeof g.delimiter > "u" ? m.delimiter : g.delimiter,
            encode: typeof g.encode == "boolean" ? g.encode : m.encode,
            encoder: typeof g.encoder == "function" ? g.encoder : m.encoder,
            encodeValuesOnly:
              typeof g.encodeValuesOnly == "boolean"
                ? g.encodeValuesOnly
                : m.encodeValuesOnly,
            filter: S,
            format: h,
            formatter: b,
            serializeDate:
              typeof g.serializeDate == "function"
                ? g.serializeDate
                : m.serializeDate,
            skipNulls:
              typeof g.skipNulls == "boolean" ? g.skipNulls : m.skipNulls,
            sort: typeof g.sort == "function" ? g.sort : null,
            strictNullHandling:
              typeof g.strictNullHandling == "boolean"
                ? g.strictNullHandling
                : m.strictNullHandling,
          }
        );
      };
    return (
      (Qn = function (c, g) {
        var v = c,
          h = u(g),
          b,
          S;
        typeof h.filter == "function"
          ? ((S = h.filter), (v = S("", v)))
          : i(h.filter) && ((S = h.filter), (b = S));
        var O = [];
        if (typeof v != "object" || v === null) return "";
        var _;
        g && g.arrayFormat in r
          ? (_ = g.arrayFormat)
          : g && "indices" in g
            ? (_ = g.indices ? "indices" : "repeat")
            : (_ = "indices");
        var R = r[_];
        (b || (b = Object.keys(v)), h.sort && b.sort(h.sort));
        for (var $ = 0; $ < b.length; ++$) {
          var y = b[$];
          (h.skipNulls && v[y] === null) ||
            s(
              O,
              p(
                v[y],
                y,
                R,
                h.strictNullHandling,
                h.skipNulls,
                h.encode ? h.encoder : null,
                h.filter,
                h.sort,
                h.allowDots,
                h.serializeDate,
                h.format,
                h.formatter,
                h.encodeValuesOnly,
                h.charset,
              ),
            );
        }
        var P = O.join(h.delimiter),
          w = h.addQueryPrefix === !0 ? "?" : "";
        return (
          h.charsetSentinel &&
            (h.charset === "iso-8859-1"
              ? (w += "utf8=%26%2310003%3B&")
              : (w += "utf8=%E2%9C%93&")),
          P.length > 0 ? w + P : ""
        );
      }),
      Qn
    );
  }
  var Bn, hs;
  function kl() {
    if (hs) return Bn;
    hs = 1;
    var e = ls(),
      t = Object.prototype.hasOwnProperty,
      n = Array.isArray,
      r = {
        allowDots: !1,
        allowPrototypes: !1,
        arrayLimit: 20,
        charset: "utf-8",
        charsetSentinel: !1,
        comma: !1,
        decoder: e.decode,
        delimiter: "&",
        depth: 5,
        ignoreQueryPrefix: !1,
        interpretNumericEntities: !1,
        parameterLimit: 1e3,
        parseArrays: !0,
        plainObjects: !1,
        strictNullHandling: !1,
      },
      i = function (p) {
        return p.replace(/&#(\d+);/g, function (u, c) {
          return String.fromCharCode(parseInt(c, 10));
        });
      },
      a = function (p, u) {
        return p && typeof p == "string" && u.comma && p.indexOf(",") > -1
          ? p.split(",")
          : p;
      },
      o = "utf8=%26%2310003%3B",
      s = "utf8=%E2%9C%93",
      l = function (u, c) {
        var g = {},
          v = c.ignoreQueryPrefix ? u.replace(/^\?/, "") : u,
          h = c.parameterLimit === 1 / 0 ? void 0 : c.parameterLimit,
          b = v.split(c.delimiter, h),
          S = -1,
          O,
          _ = c.charset;
        if (c.charsetSentinel)
          for (O = 0; O < b.length; ++O)
            b[O].indexOf("utf8=") === 0 &&
              (b[O] === s ? (_ = "utf-8") : b[O] === o && (_ = "iso-8859-1"),
              (S = O),
              (O = b.length));
        for (O = 0; O < b.length; ++O)
          if (O !== S) {
            var R = b[O],
              $ = R.indexOf("]="),
              y = $ === -1 ? R.indexOf("=") : $ + 1,
              P,
              w;
            (y === -1
              ? ((P = c.decoder(R, r.decoder, _, "key")),
                (w = c.strictNullHandling ? null : ""))
              : ((P = c.decoder(R.slice(0, y), r.decoder, _, "key")),
                (w = e.maybeMap(a(R.slice(y + 1), c), function (j) {
                  return c.decoder(j, r.decoder, _, "value");
                }))),
              w &&
                c.interpretNumericEntities &&
                _ === "iso-8859-1" &&
                (w = i(w)),
              R.indexOf("[]=") > -1 && (w = n(w) ? [w] : w),
              t.call(g, P) ? (g[P] = e.combine(g[P], w)) : (g[P] = w));
          }
        return g;
      },
      f = function (p, u, c, g) {
        for (var v = g ? u : a(u, c), h = p.length - 1; h >= 0; --h) {
          var b,
            S = p[h];
          if (S === "[]" && c.parseArrays) b = [].concat(v);
          else {
            b = c.plainObjects ? Object.create(null) : {};
            var O =
                S.charAt(0) === "[" && S.charAt(S.length - 1) === "]"
                  ? S.slice(1, -1)
                  : S,
              _ = parseInt(O, 10);
            !c.parseArrays && O === ""
              ? (b = { 0: v })
              : !isNaN(_) &&
                  S !== O &&
                  String(_) === O &&
                  _ >= 0 &&
                  c.parseArrays &&
                  _ <= c.arrayLimit
                ? ((b = []), (b[_] = v))
                : O !== "__proto__" && (b[O] = v);
          }
          v = b;
        }
        return v;
      },
      m = function (u, c, g, v) {
        if (u) {
          var h = g.allowDots ? u.replace(/\.([^.[]+)/g, "[$1]") : u,
            b = /(\[[^[\]]*])/,
            S = /(\[[^[\]]*])/g,
            O = g.depth > 0 && b.exec(h),
            _ = O ? h.slice(0, O.index) : h,
            R = [];
          if (_) {
            if (
              !g.plainObjects &&
              t.call(Object.prototype, _) &&
              !g.allowPrototypes
            )
              return;
            R.push(_);
          }
          for (
            var $ = 0;
            g.depth > 0 && (O = S.exec(h)) !== null && $ < g.depth;
          ) {
            if (
              (($ += 1),
              !g.plainObjects &&
                t.call(Object.prototype, O[1].slice(1, -1)) &&
                !g.allowPrototypes)
            )
              return;
            R.push(O[1]);
          }
          return (O && R.push("[" + h.slice(O.index) + "]"), f(R, c, g, v));
        }
      },
      d = function (u) {
        if (!u) return r;
        if (
          u.decoder !== null &&
          u.decoder !== void 0 &&
          typeof u.decoder != "function"
        )
          throw new TypeError("Decoder has to be a function.");
        if (
          typeof u.charset < "u" &&
          u.charset !== "utf-8" &&
          u.charset !== "iso-8859-1"
        )
          throw new TypeError(
            "The charset option must be either utf-8, iso-8859-1, or undefined",
          );
        var c = typeof u.charset > "u" ? r.charset : u.charset;
        return {
          allowDots: typeof u.allowDots > "u" ? r.allowDots : !!u.allowDots,
          allowPrototypes:
            typeof u.allowPrototypes == "boolean"
              ? u.allowPrototypes
              : r.allowPrototypes,
          arrayLimit:
            typeof u.arrayLimit == "number" ? u.arrayLimit : r.arrayLimit,
          charset: c,
          charsetSentinel:
            typeof u.charsetSentinel == "boolean"
              ? u.charsetSentinel
              : r.charsetSentinel,
          comma: typeof u.comma == "boolean" ? u.comma : r.comma,
          decoder: typeof u.decoder == "function" ? u.decoder : r.decoder,
          delimiter:
            typeof u.delimiter == "string" || e.isRegExp(u.delimiter)
              ? u.delimiter
              : r.delimiter,
          depth:
            typeof u.depth == "number" || u.depth === !1 ? +u.depth : r.depth,
          ignoreQueryPrefix: u.ignoreQueryPrefix === !0,
          interpretNumericEntities:
            typeof u.interpretNumericEntities == "boolean"
              ? u.interpretNumericEntities
              : r.interpretNumericEntities,
          parameterLimit:
            typeof u.parameterLimit == "number"
              ? u.parameterLimit
              : r.parameterLimit,
          parseArrays: u.parseArrays !== !1,
          plainObjects:
            typeof u.plainObjects == "boolean"
              ? u.plainObjects
              : r.plainObjects,
          strictNullHandling:
            typeof u.strictNullHandling == "boolean"
              ? u.strictNullHandling
              : r.strictNullHandling,
        };
      };
    return (
      (Bn = function (p, u) {
        var c = d(u);
        if (p === "" || p === null || typeof p > "u")
          return c.plainObjects ? Object.create(null) : {};
        for (
          var g = typeof p == "string" ? l(p, c) : p,
            v = c.plainObjects ? Object.create(null) : {},
            h = Object.keys(g),
            b = 0;
          b < h.length;
          ++b
        ) {
          var S = h[b],
            O = m(S, g[S], c, typeof p == "string");
          v = e.merge(v, O, c);
        }
        return e.compact(v);
      }),
      Bn
    );
  }
  var Vn, ds;
  function Ql() {
    if (ds) return Vn;
    ds = 1;
    var e = Ul(),
      t = kl(),
      n = Un();
    return ((Vn = { formats: n, parse: t, stringify: e }), Vn);
  }
  var Bl = Ql();
  const ps = wt(Bl);
  function qt(e) {
    "@babel/helpers - typeof";
    return (
      (qt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      qt(e)
    );
  }
  function Vl(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Kl(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      ((r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, ms(r.key), r));
    }
  }
  function zl(e, t, n) {
    return (
      t && Kl(e.prototype, t),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      e
    );
  }
  function Pe(e, t, n) {
    return (
      (t = ms(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function ms(e) {
    var t = Jl(e, "string");
    return qt(t) == "symbol" ? t : String(t);
  }
  function Jl(e, t) {
    if (qt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (qt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var gs = function (t) {
      t && (window.document.title = t);
    },
    Gl = (function () {
      function e(t) {
        var n = this,
          r = t.windowTitle,
          i = t.writeDelay,
          a = i === void 0 ? 400 : i,
          o = t.createURL,
          s = t.parseURL,
          l = t.getLocation,
          f = t.start,
          m = t.dispose,
          d = t.push,
          p = t.cleanUrlOnDispose;
        (Vl(this, e),
          Pe(this, "$$type", "ais.browser"),
          Pe(this, "windowTitle", void 0),
          Pe(this, "writeDelay", void 0),
          Pe(this, "_createURL", void 0),
          Pe(this, "parseURL", void 0),
          Pe(this, "getLocation", void 0),
          Pe(this, "writeTimer", void 0),
          Pe(this, "_onPopState", void 0),
          Pe(this, "inPopState", !1),
          Pe(this, "isDisposed", !1),
          Pe(this, "latestAcknowledgedHistory", 0),
          Pe(this, "_start", void 0),
          Pe(this, "_dispose", void 0),
          Pe(this, "_push", void 0),
          Pe(this, "_cleanUrlOnDispose", void 0),
          (this.windowTitle = r),
          (this.writeTimer = void 0),
          (this.writeDelay = a),
          (this._createURL = o),
          (this.parseURL = s),
          (this.getLocation = l),
          (this._start = f),
          (this._dispose = m),
          (this._push = d),
          (this._cleanUrlOnDispose = typeof p > "u" ? !0 : p),
          Ie(function (u) {
            var c = u.window,
              g = n.windowTitle && n.windowTitle(n.read());
            (gs(g), (n.latestAcknowledgedHistory = c.history.length));
          }));
      }
      return (
        zl(e, [
          {
            key: "read",
            value: function () {
              return this.parseURL({
                qsModule: ps,
                location: this.getLocation(),
              });
            },
          },
          {
            key: "write",
            value: function (n) {
              var r = this;
              Ie(function (i) {
                var a = i.window,
                  o = r.createURL(n),
                  s = r.windowTitle && r.windowTitle(n);
                (r.writeTimer && clearTimeout(r.writeTimer),
                  (r.writeTimer = setTimeout(function () {
                    (gs(s),
                      r.shouldWrite(o) &&
                        (r._push
                          ? r._push(o)
                          : a.history.pushState(n, s || "", o),
                        (r.latestAcknowledgedHistory = a.history.length)),
                      (r.inPopState = !1),
                      (r.writeTimer = void 0));
                  }, r.writeDelay)));
              });
            },
          },
          {
            key: "onUpdate",
            value: function (n) {
              var r = this;
              (this._start &&
                this._start(function () {
                  n(r.read());
                }),
                (this._onPopState = function () {
                  (r.writeTimer &&
                    (clearTimeout(r.writeTimer), (r.writeTimer = void 0)),
                    (r.inPopState = !0),
                    n(r.read()));
                }),
                Ie(function (i) {
                  var a = i.window;
                  a.addEventListener("popstate", r._onPopState);
                }));
            },
          },
          {
            key: "createURL",
            value: function (n) {
              var r = this._createURL({
                qsModule: ps,
                routeState: n,
                location: this.getLocation(),
              });
              return r;
            },
          },
          {
            key: "dispose",
            value: function () {
              var n = this;
              (this._dispose && this._dispose(),
                (this.isDisposed = !0),
                Ie(function (r) {
                  var i = r.window;
                  n._onPopState &&
                    i.removeEventListener("popstate", n._onPopState);
                }),
                this.writeTimer && clearTimeout(this.writeTimer),
                this._cleanUrlOnDispose && this.write({}));
            },
          },
          {
            key: "start",
            value: function () {
              this.isDisposed = !1;
            },
          },
          {
            key: "shouldWrite",
            value: function (n) {
              var r = this;
              return Ie(function (i) {
                var a = i.window;
                if (r.isDisposed && !r._cleanUrlOnDispose) return !1;
                var o = !(
                  r.isDisposed &&
                  r.latestAcknowledgedHistory !== a.history.length
                );
                return !r.inPopState && o && n !== a.location.href;
              });
            },
          },
        ]),
        e
      );
    })();
  function vs() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      t = e.createURL,
      n =
        t === void 0
          ? function (c) {
              var g = c.qsModule,
                v = c.routeState,
                h = c.location,
                b = h.protocol,
                S = h.hostname,
                O = h.port,
                _ = O === void 0 ? "" : O,
                R = h.pathname,
                $ = h.hash,
                y = g.stringify(v),
                P = _ === "" ? "" : ":".concat(_);
              return y
                ? ""
                    .concat(b, "//")
                    .concat(S)
                    .concat(P)
                    .concat(R, "?")
                    .concat(y)
                    .concat($)
                : "".concat(b, "//").concat(S).concat(P).concat(R).concat($);
            }
          : t,
      r = e.parseURL,
      i =
        r === void 0
          ? function (c) {
              var g = c.qsModule,
                v = c.location;
              return g.parse(v.search.slice(1), { arrayLimit: 99 });
            }
          : r,
      a = e.writeDelay,
      o = a === void 0 ? 400 : a,
      s = e.windowTitle,
      l = e.getLocation,
      f =
        l === void 0
          ? function () {
              return Ie(
                function (c) {
                  var g = c.window;
                  return g.location;
                },
                {
                  fallback: function () {
                    throw new Error(
                      "You need to provide `getLocation` to the `history` router in environments where `window` does not exist.",
                    );
                  },
                },
              );
            }
          : l,
      m = e.start,
      d = e.dispose,
      p = e.push,
      u = e.cleanUrlOnDispose;
    return new Gl({
      createURL: n,
      parseURL: i,
      writeDelay: o,
      windowTitle: s,
      getLocation: f,
      start: m,
      dispose: d,
      push: p,
      cleanUrlOnDispose: u,
    });
  }
  function Ut(e) {
    "@babel/helpers - typeof";
    return (
      (Ut =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Ut(e)
    );
  }
  var Yl = ["configure"];
  function ys(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function $r(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? ys(Object(n), !0).forEach(function (r) {
            Kn(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : ys(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Kn(e, t, n) {
    return (
      (t = Xl(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Xl(e) {
    var t = Zl(e, "string");
    return Ut(t) == "symbol" ? t : String(t);
  }
  function Zl(e, t) {
    if (Ut(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Ut(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function ef(e, t) {
    if (e == null) return {};
    var n = tf(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function tf(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function bs(e) {
    e.configure;
    var t = ef(e, Yl);
    return t;
  }
  function rf() {
    return {
      $$type: "ais.simple",
      stateToRoute: function (t) {
        return Object.keys(t).reduce(function (n, r) {
          return $r($r({}, n), {}, Kn({}, r, bs(t[r])));
        }, {});
      },
      routeToState: function () {
        var t =
          arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return Object.keys(t).reduce(function (n, r) {
          return $r($r({}, n), {}, Kn({}, r, bs(t[r])));
        }, {});
      },
    };
  }
  function kt(e) {
    "@babel/helpers - typeof";
    return (
      (kt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      kt(e)
    );
  }
  function Ss(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function xr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Ss(Object(n), !0).forEach(function (r) {
            Ps(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Ss(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Ps(e, t, n) {
    return (
      (t = nf(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function nf(e) {
    var t = af(e, "string");
    return kt(t) == "symbol" ? t : String(t);
  }
  function af(e, t) {
    if (kt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (kt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var sf = function () {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      n = t.router,
      r = n === void 0 ? vs() : n,
      i = t.stateMapping,
      a = i === void 0 ? rf() : i,
      o = t.$$internal,
      s = o === void 0 ? !1 : o;
    return function (l) {
      var f = l.instantSearchInstance;
      function m(u) {
        var c =
            f.mainIndex.getWidgets().length === 0
              ? f._initialUiState
              : f.mainIndex.getWidgetUiState({}),
          g = Object.keys(u).reduce(function (h, b) {
            return xr(xr({}, h), {}, Ps({}, b, u[b]));
          }, c),
          v = a.stateToRoute(g);
        return r.createURL(v);
      }
      f._createURL = m;
      var d = void 0,
        p = f._initialUiState;
      return {
        $$type: "ais.router({router:"
          .concat(r.$$type || "__unknown__", ", stateMapping:")
          .concat(a.$$type || "__unknown__", "})"),
        $$internal: s,
        onStateChange: function (c) {
          var g = c.uiState,
            v = a.stateToRoute(g);
          (d === void 0 || !ct(d, v)) && (r.write(v), (d = v));
        },
        subscribe: function () {
          ((f._initialUiState = xr(xr({}, p), a.routeToState(r.read()))),
            r.onUpdate(function (c) {
              f.mainIndex.getWidgets().length > 0 &&
                f.setUiState(a.routeToState(c));
            }));
        },
        started: function () {
          var c;
          (c = r.start) === null || c === void 0 || c.call(r);
        },
        unsubscribe: function () {
          r.dispose();
        },
      };
    };
  };
  function Qt(e) {
    "@babel/helpers - typeof";
    return (
      (Qt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Qt(e)
    );
  }
  var of = ["initialSearchParameters"],
    uf = ["initialRecommendParameters"];
  function _s(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Ne(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? _s(Object(n), !0).forEach(function (r) {
            lt(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : _s(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function lt(e, t, n) {
    return (
      (t = cf(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function cf(e) {
    var t = lf(e, "string");
    return Qt(t) == "symbol" ? t : String(t);
  }
  function lf(e, t) {
    if (Qt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Qt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Os(e) {
    return pf(e) || df(e) || hf(e) || ff();
  }
  function ff() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function hf(e, t) {
    if (e) {
      if (typeof e == "string") return zn(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return zn(e, t);
    }
  }
  function df(e) {
    if (
      (typeof Symbol < "u" && e[Symbol.iterator] != null) ||
      e["@@iterator"] != null
    )
      return Array.from(e);
  }
  function pf(e) {
    if (Array.isArray(e)) return zn(e);
  }
  function zn(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function ws(e, t) {
    if (e == null) return {};
    var n = mf(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function mf(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  var Bt = Oe({ name: "index-widget" });
  function Rs(e, t) {
    var n = t.state,
      r = t.recommendState,
      i = t.isPageReset,
      a = t._uiState;
    (n !== e.state &&
      ((e.state = n),
      e.emit("change", {
        state: e.state,
        results: e.lastResults,
        isPageReset: i,
        _uiState: a,
      })),
      r !== e.recommendState && (e.recommendState = r));
  }
  function Vt(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return e.reduce(function (r, i) {
      return Re(i) || (!i.getWidgetUiState && !i.getWidgetState)
        ? r
        : i.getWidgetUiState
          ? i.getWidgetUiState(r, t)
          : i.getWidgetState(r, t);
    }, n);
  }
  function Kt(e, t) {
    var n = t.initialSearchParameters,
      r = ws(t, of);
    return e.reduce(function (i, a) {
      return !a.getWidgetSearchParameters || Re(a)
        ? i
        : a.dependsOn === "search" && a.getWidgetParameters
          ? a.getWidgetParameters(i, r)
          : a.getWidgetSearchParameters(i, r);
    }, n);
  }
  function js(e, t) {
    var n = t.initialRecommendParameters,
      r = ws(t, uf);
    return e.reduce(function (i, a) {
      return !Re(a) && a.dependsOn === "recommend" && a.getWidgetParameters
        ? a.getWidgetParameters(i, r)
        : i;
    }, n);
  }
  function $s(e) {
    var t = e.filter(Re);
    t.length !== 0 &&
      t.forEach(function (n) {
        var r = n.getHelper();
        (Rs(r, {
          state: r.state.resetPage(),
          recommendState: r.recommendState,
          isPageReset: !0,
        }),
          $s(n.getWidgets()));
      });
  }
  function xs(e) {
    var t = e.filter(Re);
    return t.reduce(function (n, r) {
      return n.concat.apply(
        n,
        [
          {
            indexId: r.getIndexId(),
            results: r.getResults(),
            helper: r.getHelper(),
          },
        ].concat(Os(xs(r.getWidgets()))),
      );
    }, []);
  }
  var gf = function (t) {
    if (t === void 0 || t.indexName === void 0)
      throw new Error(Bt("The `indexName` option is required."));
    var n = t.indexName,
      r = t.indexId,
      i = r === void 0 ? n : r,
      a = [],
      o = {},
      s = null,
      l = null,
      f = null,
      m = null,
      d = null,
      p = !1,
      u = !1;
    return {
      $$type: "ais.index",
      $$widgetType: "ais.index",
      getIndexName: function () {
        return n;
      },
      getIndexId: function () {
        return i;
      },
      getHelper: function () {
        return f;
      },
      getResults: function () {
        var g;
        return (g = m) !== null && g !== void 0 && g.lastResults
          ? ((m.lastResults._state = f.state), m.lastResults)
          : null;
      },
      getResultsForWidget: function (g) {
        var v;
        return g.dependsOn !== "recommend" || Re(g) || g.$$id === void 0
          ? this.getResults()
          : (v = f) !== null && v !== void 0 && v.lastRecommendResults
            ? f.lastRecommendResults[g.$$id]
            : null;
      },
      getPreviousState: function () {
        return d;
      },
      getScopedResults: function () {
        var g = this.getParent(),
          v;
        return (
          g
            ? (v = g.getWidgets())
            : n.length === 0
              ? (v = this.getWidgets())
              : (v = [this]),
          xs(v)
        );
      },
      getParent: function () {
        return l;
      },
      createURL: function (g) {
        return typeof g == "function"
          ? s._createURL(lt({}, i, g(o)))
          : s._createURL(lt({}, i, Vt(a, { searchParameters: g, helper: f })));
      },
      getWidgets: function () {
        return a;
      },
      addWidgets: function (g) {
        var v = this;
        if (!Array.isArray(g))
          throw new Error(
            Bt("The `addWidgets` method expects an array of widgets."),
          );
        if (
          g.some(function (h) {
            return typeof h.init != "function" && typeof h.render != "function";
          })
        )
          throw new Error(
            Bt(
              "The widget definition expects a `render` and/or an `init` method.",
            ),
          );
        return (
          g.forEach(function (h) {
            Re(h) ||
              (s && h.dependsOn === "recommend"
                ? (s._hasRecommendWidget = !0)
                : s
                  ? (s._hasSearchWidget = !0)
                  : h.dependsOn === "recommend"
                    ? (p = !0)
                    : (u = !0),
              pu(h));
          }),
          (a = a.concat(g)),
          s &&
            g.length &&
            (Rs(f, {
              state: Kt(a, { uiState: o, initialSearchParameters: f.state }),
              recommendState: js(a, {
                uiState: o,
                initialRecommendParameters: f.recommendState,
              }),
              _uiState: o,
            }),
            g.forEach(function (h) {
              if (h.getRenderState) {
                var b = h.getRenderState(
                  s.renderState[v.getIndexId()] || {},
                  Ht(s, v, s._initialUiState),
                );
                Jn({ renderState: b, instantSearchInstance: s, parent: v });
              }
            }),
            g.forEach(function (h) {
              h.init && h.init(Ht(s, v, s._initialUiState));
            }),
            s.scheduleSearch()),
          this
        );
      },
      removeWidgets: function (g) {
        var v = this;
        if (!Array.isArray(g))
          throw new Error(
            Bt("The `removeWidgets` method expects an array of widgets."),
          );
        if (
          g.some(function (_) {
            return typeof _.dispose != "function";
          })
        )
          throw new Error(
            Bt("The widget definition expects a `dispose` method."),
          );
        if (
          ((a = a.filter(function (_) {
            return g.indexOf(_) === -1;
          })),
          a.forEach(function (_) {
            Re(_) ||
              (s && _.dependsOn === "recommend"
                ? (s._hasRecommendWidget = !0)
                : s
                  ? (s._hasSearchWidget = !0)
                  : _.dependsOn === "recommend"
                    ? (p = !0)
                    : (u = !0));
          }),
          s && g.length)
        ) {
          var h = g.reduce(
              function (_, R) {
                var $ = R.dispose({
                  helper: f,
                  state: _.cleanedSearchState,
                  recommendState: _.cleanedRecommendState,
                  parent: v,
                });
                return (
                  $ instanceof Se.RecommendParameters
                    ? (_.cleanedRecommendState = $)
                    : $ && (_.cleanedSearchState = $),
                  _
                );
              },
              {
                cleanedSearchState: f.state,
                cleanedRecommendState: f.recommendState,
              },
            ),
            b = h.cleanedSearchState,
            S = h.cleanedRecommendState,
            O = s.future.preserveSharedStateOnUnmount
              ? Kt(a, {
                  uiState: o,
                  initialSearchParameters: new Se.SearchParameters({
                    index: this.getIndexName(),
                  }),
                })
              : Kt(a, {
                  uiState: Vt(a, { searchParameters: b, helper: f }),
                  initialSearchParameters: b,
                });
          ((o = Vt(a, { searchParameters: O, helper: f })),
            f.setState(O),
            (f.recommendState = S),
            a.length && s.scheduleSearch());
        }
        return this;
      },
      init: function (g) {
        var v = this,
          h,
          b = g.instantSearchInstance,
          S = g.parent,
          O = g.uiState;
        if (f === null) {
          ((s = b), (l = S), (o = O[i] || {}));
          var _ = b.mainHelper,
            R = Kt(a, {
              uiState: o,
              initialSearchParameters: new Se.SearchParameters({ index: n }),
            }),
            $ = js(a, {
              uiState: o,
              initialRecommendParameters: new Se.RecommendParameters(),
            });
          ((f = Se({}, R.index, R)),
            (f.recommendState = $),
            (f.search = function () {
              return b.onStateChange
                ? (b.onStateChange({
                    uiState: b.mainIndex.getWidgetUiState({}),
                    setUiState: function (T) {
                      return b.setUiState(T, !1);
                    },
                  }),
                  _)
                : _.search();
            }),
            (f.searchWithoutTriggeringOnStateChange = function () {
              return _.search();
            }),
            (f.searchForFacetValues = function (j, T, N, Q) {
              var W = f.state.setQueryParameters(Q);
              return _.searchForFacetValues(j, T, N, W);
            }),
            (m = _.derive(
              function () {
                return Or.apply(void 0, [_.state].concat(Os(Vc(v))));
              },
              function () {
                return v.getHelper().recommendState;
              },
            )));
          var y =
            (h = b._initialResults) === null || h === void 0
              ? void 0
              : h[this.getIndexId()];
          if (y != null && y.results) {
            var P = new Se.SearchResults(
              new Se.SearchParameters(y.state),
              y.results,
            );
            ((m.lastResults = P), (f.lastResults = P));
          }
          if (y != null && y.recommendResults) {
            var w = new Se.RecommendResults(
              new Se.RecommendParameters({ params: y.recommendResults.params }),
              y.recommendResults.results,
            );
            ((m.lastRecommendResults = w), (f.lastRecommendResults = w));
          }
          (f.on("change", function (j) {
            var T = j.isPageReset;
            T && $s(a);
          }),
            m.on("search", function () {
              b.scheduleStalledRender();
            }),
            m.on("result", function (j) {
              var T = j.results;
              (b.scheduleRender(),
                (f.lastResults = T),
                (d = T == null ? void 0 : T._state));
            }),
            m.on("recommend:result", function (j) {
              var T = j.recommend;
              (b.scheduleRender(), (f.lastRecommendResults = T.results));
            }),
            a.forEach(function (j) {
              if (j.getRenderState) {
                var T = j.getRenderState(
                  b.renderState[v.getIndexId()] || {},
                  Ht(b, v, O),
                );
                Jn({ renderState: T, instantSearchInstance: b, parent: v });
              }
            }),
            a.forEach(function (j) {
              j.init && j.init(Ht(b, v, O));
            }),
            f.on("change", function (j) {
              var T = j.state,
                N = j._uiState;
              ((o = Vt(a, { searchParameters: T, helper: f }, N || {})),
                b.onStateChange || b.onInternalStateChange());
            }),
            y && b.scheduleRender(),
            p && (b._hasRecommendWidget = !0),
            u && (b._hasSearchWidget = !0));
        }
      },
      render: function (g) {
        var v,
          h = this,
          b = g.instantSearchInstance;
        b.status === "error" &&
          !b.mainHelper.hasPendingRequests() &&
          d &&
          f.setState(d);
        var S =
          this.getResults() ||
          ((v = m) !== null && v !== void 0 && v.lastRecommendResults)
            ? a
            : a.filter(Re);
        ((S = S.filter(function (O) {
          return O.shouldRender
            ? O.shouldRender({ instantSearchInstance: b })
            : !0;
        })),
          S.forEach(function (O) {
            if (O.getRenderState) {
              var _ = O.getRenderState(
                b.renderState[h.getIndexId()] || {},
                ua(b, h, O),
              );
              Jn({ renderState: _, instantSearchInstance: b, parent: h });
            }
          }),
          S.forEach(function (O) {
            O.render && O.render(ua(b, h, O));
          }));
      },
      dispose: function () {
        var g = this,
          v,
          h;
        (a.forEach(function (b) {
          b.dispose &&
            f &&
            b.dispose({
              helper: f,
              state: f.state,
              recommendState: f.recommendState,
              parent: g,
            });
        }),
          (s = null),
          (l = null),
          (v = f) === null || v === void 0 || v.removeAllListeners(),
          (f = null),
          (h = m) === null || h === void 0 || h.detach(),
          (m = null));
      },
      getWidgetUiState: function (g) {
        return a.filter(Re).reduce(
          function (v, h) {
            return h.getWidgetUiState(v);
          },
          Ne(Ne({}, g), {}, lt({}, i, Ne(Ne({}, g[i]), o))),
        );
      },
      getWidgetState: function (g) {
        return this.getWidgetUiState(g);
      },
      getWidgetSearchParameters: function (g, v) {
        var h = v.uiState;
        return Kt(a, { uiState: h, initialSearchParameters: g });
      },
      refreshUiState: function () {
        o = Vt(
          a,
          {
            searchParameters: this.getHelper().state,
            helper: this.getHelper(),
          },
          o,
        );
      },
      setIndexUiState: function (g) {
        var v = typeof g == "function" ? g(o) : g;
        s.setUiState(function (h) {
          return Ne(Ne({}, h), {}, lt({}, i, v));
        });
      },
    };
  };
  function Jn(e) {
    var t = e.renderState,
      n = e.instantSearchInstance,
      r = e.parent,
      i = r ? r.getIndexId() : n.mainIndex.getIndexId();
    n.renderState = Ne(
      Ne({}, n.renderState),
      {},
      lt({}, i, Ne(Ne({}, n.renderState[i]), t)),
    );
  }
  function Fs(e, t) {
    return e.toLocaleString(t);
  }
  function zt(e) {
    "@babel/helpers - typeof";
    return (
      (zt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      zt(e)
    );
  }
  function Es(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Le(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Es(Object(n), !0).forEach(function (r) {
            vf(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Es(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function vf(e, t, n) {
    return (
      (t = yf(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function yf(e) {
    var t = bf(e, "string");
    return zt(t) == "symbol" ? t : String(t);
  }
  function bf(e, t) {
    if (zt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (zt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Sf(e) {
    var t = e.numberLocale;
    return {
      formatNumber: function (r, i) {
        return Fs(Number(i(r)), t);
      },
      highlight: function (r, i) {
        try {
          var a = JSON.parse(r);
          return i(fa(Le(Le({}, a), {}, { hit: this })));
        } catch {
          throw new Error(`
The highlight helper expects a JSON object of the format:
{ "attribute": "name", "highlightedTagName": "mark" }`);
        }
      },
      reverseHighlight: function (r, i) {
        try {
          var a = JSON.parse(r);
          return i(ha(Le(Le({}, a), {}, { hit: this })));
        } catch {
          throw new Error(`
  The reverseHighlight helper expects a JSON object of the format:
  { "attribute": "name", "highlightedTagName": "mark" }`);
        }
      },
      snippet: function (r, i) {
        try {
          var a = JSON.parse(r);
          return i(da(Le(Le({}, a), {}, { hit: this })));
        } catch {
          throw new Error(`
The snippet helper expects a JSON object of the format:
{ "attribute": "name", "highlightedTagName": "mark" }`);
        }
      },
      reverseSnippet: function (r, i) {
        try {
          var a = JSON.parse(r);
          return i(pa(Le(Le({}, a), {}, { hit: this })));
        } catch {
          throw new Error(`
  The reverseSnippet helper expects a JSON object of the format:
  { "attribute": "name", "highlightedTagName": "mark" }`);
        }
      },
      insights: function (r, i) {
        try {
          var a = JSON.parse(r),
            o = a.method,
            s = a.payload;
          return i(ma(o, Le({ objectIDs: [this.objectID] }, s)));
        } catch {
          throw new Error(`
The insights helper expects a JSON object of the format:
{ "method": "method-name", "payload": { "eventName": "name of the event" } }`);
        }
      },
    };
  }
  const Ts = "4.78.3";
  function ft(e) {
    "@babel/helpers - typeof";
    return (
      (ft =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      ft(e)
    );
  }
  function Is(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Gn(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Is(Object(n), !0).forEach(function (r) {
            ne(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Is(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Pf(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function _f(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      ((r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, Ns(r.key), r));
    }
  }
  function Of(e, t, n) {
    return (
      t && _f(e.prototype, t),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      e
    );
  }
  function wf(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    ((e.prototype = Object.create(t && t.prototype, {
      constructor: { value: e, writable: !0, configurable: !0 },
    })),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      t && Yn(e, t));
  }
  function Yn(e, t) {
    return (
      (Yn = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (r, i) {
            return ((r.__proto__ = i), r);
          }),
      Yn(e, t)
    );
  }
  function Rf(e) {
    var t = $f();
    return function () {
      var r = Fr(e),
        i;
      if (t) {
        var a = Fr(this).constructor;
        i = Reflect.construct(r, arguments, a);
      } else i = r.apply(this, arguments);
      return jf(this, i);
    };
  }
  function jf(e, t) {
    if (t && (ft(t) === "object" || typeof t == "function")) return t;
    if (t !== void 0)
      throw new TypeError(
        "Derived constructors may only return object or undefined",
      );
    return re(e);
  }
  function re(e) {
    if (e === void 0)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called",
      );
    return e;
  }
  function $f() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {}),
        ),
        !0
      );
    } catch {
      return !1;
    }
  }
  function Fr(e) {
    return (
      (Fr = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (n) {
            return n.__proto__ || Object.getPrototypeOf(n);
          }),
      Fr(e)
    );
  }
  function ne(e, t, n) {
    return (
      (t = Ns(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Ns(e) {
    var t = xf(e, "string");
    return ft(t) == "symbol" ? t : String(t);
  }
  function xf(e, t) {
    if (ft(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (ft(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Fe = Oe({ name: "instantsearch" });
  function Ff() {
    return "#";
  }
  var Ef = {
      preserveSharedStateOnUnmount: !1,
      persistHierarchicalRootCount: !1,
    },
    Tf = (function (e) {
      wf(n, e);
      var t = Rf(n);
      function n(r) {
        var i;
        (Pf(this, n),
          (i = t.call(this)),
          ne(re(i), "client", void 0),
          ne(re(i), "indexName", void 0),
          ne(re(i), "compositionID", void 0),
          ne(re(i), "insightsClient", void 0),
          ne(re(i), "onStateChange", null),
          ne(re(i), "future", void 0),
          ne(re(i), "helper", void 0),
          ne(re(i), "mainHelper", void 0),
          ne(re(i), "mainIndex", void 0),
          ne(re(i), "started", void 0),
          ne(re(i), "templatesConfig", void 0),
          ne(re(i), "renderState", {}),
          ne(re(i), "_stalledSearchDelay", void 0),
          ne(re(i), "_searchStalledTimer", void 0),
          ne(re(i), "_initialUiState", void 0),
          ne(re(i), "_initialResults", void 0),
          ne(re(i), "_createURL", void 0),
          ne(re(i), "_searchFunction", void 0),
          ne(re(i), "_mainHelperSearch", void 0),
          ne(re(i), "_hasSearchWidget", !1),
          ne(re(i), "_hasRecommendWidget", !1),
          ne(re(i), "_insights", void 0),
          ne(re(i), "middleware", []),
          ne(re(i), "sendEventToInsights", void 0),
          ne(re(i), "status", "idle"),
          ne(re(i), "error", void 0),
          ne(
            re(i),
            "scheduleSearch",
            Ft(function () {
              i.started && i.mainHelper.search();
            }),
          ),
          ne(
            re(i),
            "scheduleRender",
            Ft(function () {
              var T,
                N =
                  arguments.length > 0 && arguments[0] !== void 0
                    ? arguments[0]
                    : !0;
              (((T = i.mainHelper) !== null &&
                T !== void 0 &&
                T.hasPendingRequests()) ||
                (clearTimeout(i._searchStalledTimer),
                (i._searchStalledTimer = null),
                N && ((i.status = "idle"), (i.error = void 0))),
                i.mainIndex.render({ instantSearchInstance: re(i) }),
                i.emit("render"));
            }),
          ),
          ne(
            re(i),
            "onInternalStateChange",
            Ft(function () {
              var T = i.mainIndex.getWidgetUiState({});
              i.middleware.forEach(function (N) {
                var Q = N.instance;
                Q.onStateChange({ uiState: T });
              });
            }),
          ),
          i.setMaxListeners(100));
        var a = r.indexName,
          o = a === void 0 ? "" : a,
          s = r.compositionID,
          l = r.numberLocale,
          f = r.initialUiState,
          m = f === void 0 ? {} : f,
          d = r.routing,
          p = d === void 0 ? null : d,
          u = r.insights,
          c = u === void 0 ? void 0 : u,
          g = r.searchFunction,
          v = r.stalledSearchDelay,
          h = v === void 0 ? 200 : v,
          b = r.searchClient,
          S = b === void 0 ? null : b,
          O = r.insightsClient,
          _ = O === void 0 ? null : O,
          R = r.onStateChange,
          $ = R === void 0 ? null : R,
          y = r.future,
          P = y === void 0 ? Gn(Gn({}, Ef), r.future || {}) : y;
        if (S === null)
          throw new Error(Fe("The `searchClient` option is required."));
        if (typeof S.search != "function")
          throw new Error(
            "The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/",
          );
        if (
          (typeof S.addAlgoliaAgent == "function" &&
            S.addAlgoliaAgent("instantsearch.js (".concat(Ts, ")")),
          _ && typeof _ != "function")
        )
          throw new Error(
            Fe("The `insightsClient` option should be a function."),
          );
        if (
          ((i.client = S),
          (i.future = P),
          (i.insightsClient = _),
          (i.indexName = o),
          (i.compositionID = s),
          (i.helper = null),
          (i.mainHelper = null),
          (i.mainIndex = gf({ indexName: i.compositionID || i.indexName })),
          (i.onStateChange = $),
          (i.started = !1),
          (i.templatesConfig = {
            helpers: Sf({ numberLocale: l }),
            compileOptions: {},
          }),
          (i._stalledSearchDelay = h),
          (i._searchStalledTimer = null),
          (i._createURL = Ff),
          (i._initialUiState = m),
          (i._initialResults = null),
          (i._insights = c),
          g && (i._searchFunction = g),
          (i.sendEventToInsights = he),
          p)
        ) {
          var w = typeof p == "boolean" ? {} : p;
          ((w.$$internal = !0), i.use(sf(w)));
        }
        if (c) {
          var j = typeof c == "boolean" ? {} : c;
          ((j.$$internal = !0), i.use(is(j)));
        }
        return (Wl() && i.use(ql({ $$internal: !0 })), i);
      }
      return (
        Of(n, [
          {
            key: "_isSearchStalled",
            get: function () {
              return this.status === "stalled";
            },
          },
          {
            key: "use",
            value: function () {
              for (
                var i = this, a = arguments.length, o = new Array(a), s = 0;
                s < a;
                s++
              )
                o[s] = arguments[s];
              var l = o.map(function (f) {
                var m = Gn(
                  {
                    $$type: "__unknown__",
                    $$internal: !1,
                    subscribe: he,
                    started: he,
                    unsubscribe: he,
                    onStateChange: he,
                  },
                  f({ instantSearchInstance: i }),
                );
                return (i.middleware.push({ creator: f, instance: m }), m);
              });
              return (
                this.started &&
                  l.forEach(function (f) {
                    (f.subscribe(), f.started());
                  }),
                this
              );
            },
          },
          {
            key: "unuse",
            value: function () {
              for (
                var i = arguments.length, a = new Array(i), o = 0;
                o < i;
                o++
              )
                a[o] = arguments[o];
              return (
                this.middleware
                  .filter(function (s) {
                    return a.includes(s.creator);
                  })
                  .forEach(function (s) {
                    return s.instance.unsubscribe();
                  }),
                (this.middleware = this.middleware.filter(function (s) {
                  return !a.includes(s.creator);
                })),
                this
              );
            },
          },
          {
            key: "EXPERIMENTAL_use",
            value: function () {
              return this.use.apply(this, arguments);
            },
          },
          {
            key: "addWidget",
            value: function (i) {
              return this.addWidgets([i]);
            },
          },
          {
            key: "addWidgets",
            value: function (i) {
              if (!Array.isArray(i))
                throw new Error(
                  Fe(
                    "The `addWidgets` method expects an array of widgets. Please use `addWidget`.",
                  ),
                );
              if (
                i.some(function (a) {
                  return (
                    typeof a.init != "function" && typeof a.render != "function"
                  );
                })
              )
                throw new Error(
                  Fe(
                    "The widget definition expects a `render` and/or an `init` method.",
                  ),
                );
              if (this.compositionID && i.some(Re))
                throw new Error(
                  Fe(
                    "The `index` widget cannot be used with a composition-based InstantSearch implementation.",
                  ),
                );
              return (this.mainIndex.addWidgets(i), this);
            },
          },
          {
            key: "removeWidget",
            value: function (i) {
              return this.removeWidgets([i]);
            },
          },
          {
            key: "removeWidgets",
            value: function (i) {
              if (!Array.isArray(i))
                throw new Error(
                  Fe(
                    "The `removeWidgets` method expects an array of widgets. Please use `removeWidget`.",
                  ),
                );
              if (
                i.some(function (a) {
                  return typeof a.dispose != "function";
                })
              )
                throw new Error(
                  Fe("The widget definition expects a `dispose` method."),
                );
              return (this.mainIndex.removeWidgets(i), this);
            },
          },
          {
            key: "start",
            value: function () {
              var i = this;
              if (this.started)
                throw new Error(
                  Fe("The `start` method has already been called once."),
                );
              var a =
                this.mainHelper ||
                Se(this.client, this.indexName, void 0, {
                  persistHierarchicalRootCount:
                    this.future.persistHierarchicalRootCount,
                });
              if (
                (this.compositionID &&
                  (a.searchForFacetValues =
                    a.searchForCompositionFacetValues.bind(a)),
                (a.search = function () {
                  return (
                    (i.status = "loading"),
                    i.scheduleRender(!1),
                    i._hasSearchWidget &&
                      (i.compositionID
                        ? a.searchWithComposition()
                        : a.searchOnlyWithDerivedHelpers()),
                    i._hasRecommendWidget && a.recommend(),
                    a
                  );
                }),
                this._searchFunction)
              ) {
                var o = {
                  search: function () {
                    return new Promise(he);
                  },
                };
                ((this._mainHelperSearch = a.search.bind(a)),
                  (a.search = function () {
                    var l = i.mainIndex.getHelper(),
                      f = Se(o, l.state.index, l.state);
                    return (
                      f.once("search", function (m) {
                        var d = m.state;
                        (l.overrideStateWithoutTriggeringChangeEvent(d),
                          i._mainHelperSearch());
                      }),
                      f.on("change", function (m) {
                        var d = m.state;
                        l.setState(d);
                      }),
                      i._searchFunction(f),
                      a
                    );
                  }));
              }
              if (
                (a.on("error", function (l) {
                  var f = l.error;
                  if (!(f instanceof Error)) {
                    var m = f;
                    f = Object.keys(m).reduce(function (d, p) {
                      return ((d[p] = m[p]), d);
                    }, new Error(m.message));
                  }
                  ((f.error = f),
                    (i.error = f),
                    (i.status = "error"),
                    i.scheduleRender(!1),
                    i.emit("error", f));
                }),
                (this.mainHelper = a),
                this.middleware.forEach(function (l) {
                  var f = l.instance;
                  f.subscribe();
                }),
                this.mainIndex.init({
                  instantSearchInstance: this,
                  parent: null,
                  uiState: this._initialUiState,
                }),
                this._initialResults)
              ) {
                (Pc(this.client, this._initialResults),
                  dc(this.mainHelper, this._initialResults));
                var s = this.scheduleSearch;
                ((this.scheduleSearch = Ft(he)),
                  Ft(function () {
                    i.scheduleSearch = s;
                  })());
              } else
                this.mainIndex.getWidgets().length > 0 && this.scheduleSearch();
              ((this.helper = this.mainIndex.getHelper()),
                (this.started = !0),
                this.middleware.forEach(function (l) {
                  var f = l.instance;
                  f.started();
                }),
                typeof this._insights > "u" &&
                  a.derivedHelpers[0].once("result", function () {
                    var l = i.mainIndex.getScopedResults().some(function (f) {
                      var m = f.results;
                      return m == null ? void 0 : m._automaticInsights;
                    });
                    l && i.use(is({ $$internal: !0, $$automatic: !0 }));
                  }));
            },
          },
          {
            key: "dispose",
            value: function () {
              var i;
              (this.scheduleSearch.cancel(),
                this.scheduleRender.cancel(),
                clearTimeout(this._searchStalledTimer),
                this.removeWidgets(this.mainIndex.getWidgets()),
                this.mainIndex.dispose(),
                (this.started = !1),
                this.removeAllListeners(),
                (i = this.mainHelper) === null ||
                  i === void 0 ||
                  i.removeAllListeners(),
                (this.mainHelper = null),
                (this.helper = null),
                this.middleware.forEach(function (a) {
                  var o = a.instance;
                  o.unsubscribe();
                }));
            },
          },
          {
            key: "scheduleStalledRender",
            value: function () {
              var i = this;
              this._searchStalledTimer ||
                (this._searchStalledTimer = setTimeout(function () {
                  ((i.status = "stalled"), i.scheduleRender());
                }, this._stalledSearchDelay));
            },
          },
          {
            key: "setUiState",
            value: function (i) {
              var a = this,
                o =
                  arguments.length > 1 && arguments[1] !== void 0
                    ? arguments[1]
                    : !0;
              if (!this.mainHelper)
                throw new Error(
                  Fe(
                    "The `start` method needs to be called before `setUiState`.",
                  ),
                );
              this.mainIndex.refreshUiState();
              var s =
                typeof i == "function"
                  ? i(this.mainIndex.getWidgetUiState({}))
                  : i;
              this.onStateChange && o
                ? this.onStateChange({
                    uiState: s,
                    setUiState: function (f) {
                      (Xr(typeof f == "function" ? f(s) : f, a.mainIndex),
                        a.scheduleSearch(),
                        a.onInternalStateChange());
                    },
                  })
                : (Xr(s, this.mainIndex),
                  this.scheduleSearch(),
                  this.onInternalStateChange());
            },
          },
          {
            key: "getUiState",
            value: function () {
              return (
                this.started && this.mainIndex.refreshUiState(),
                this.mainIndex.getWidgetUiState({})
              );
            },
          },
          {
            key: "createURL",
            value: function () {
              var i =
                arguments.length > 0 && arguments[0] !== void 0
                  ? arguments[0]
                  : {};
              if (!this.started)
                throw new Error(
                  Fe(
                    "The `start` method needs to be called before `createURL`.",
                  ),
                );
              return this._createURL(i);
            },
          },
          {
            key: "refresh",
            value: function () {
              if (!this.mainHelper)
                throw new Error(
                  Fe("The `start` method needs to be called before `refresh`."),
                );
              this.mainHelper.clearCache().search();
            },
          },
        ]),
        n
      );
    })(ll),
    je = function (t) {
      return new Tf(t);
    };
  ((je.version = Ts),
    (je.createInfiniteHitsSessionStorageCache = Rt(ul)),
    (je.highlight = Rt(fa)),
    (je.reverseHighlight = Rt(ha)),
    (je.snippet = Rt(da)),
    (je.reverseSnippet = Rt(pa)),
    (je.insights = ma),
    (je.getInsightsAnonymousUserToken = il),
    Object.defineProperty(je, "widgets", {
      get: function () {
        throw new ReferenceError(`"instantsearch.widgets" are not available from the ES build.

To import the widgets:

import { searchBox } from 'instantsearch.js/es/widgets'`);
      },
    }),
    Object.defineProperty(je, "connectors", {
      get: function () {
        throw new ReferenceError(`"instantsearch.connectors" are not available from the ES build.

To import the connectors:

import { connectSearchBox } from 'instantsearch.js/es/connectors'`);
      },
    }),
    Object.defineProperty(je, "templates", {
      get: function () {
        throw new ReferenceError(`"instantsearch.templates" are not available from the ES build.

To import the templates:

import { carousel } from 'instantsearch.js/es/templates'`);
      },
    }));
  function Er() {
    return (
      (Er = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      Er.apply(null, arguments)
    );
  }
  function If(e, t) {
    if (e == null) return {};
    var n = {};
    for (var r in e)
      if ({}.hasOwnProperty.call(e, r)) {
        if (t.indexOf(r) !== -1) continue;
        n[r] = e[r];
      }
    return n;
  }
  function Cs(e, t) {
    if (e == null) return {};
    var n,
      r,
      i = If(e, t);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (r = 0; r < a.length; r++)
        ((n = a[r]),
          t.indexOf(n) === -1 &&
            {}.propertyIsEnumerable.call(e, n) &&
            (i[n] = e[n]));
    }
    return i;
  }
  function L() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return t
      .reduce(function (r, i) {
        return Array.isArray(i) ? r.concat(i) : r.concat([i]);
      }, [])
      .filter(Boolean)
      .join(" ");
  }
  var Nf = [
    "parts",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator",
    "className",
    "classNames",
  ];
  function Cf(e) {
    var t = e.createElement;
    return function (r) {
      var i = r.classNames,
        a = r.children,
        o = r.highlightedTagName,
        s = r.isHighlighted,
        l = r.nonHighlightedTagName,
        f = s ? o : l;
      return t(f, { className: s ? i.highlighted : i.nonHighlighted }, a);
    };
  }
  function Af(e) {
    var t = e.createElement,
      n = e.Fragment,
      r = Cf({ createElement: t });
    return function (a) {
      var o = a.parts,
        s = a.highlightedTagName,
        l = s === void 0 ? "mark" : s,
        f = a.nonHighlightedTagName,
        m = f === void 0 ? "span" : f,
        d = a.separator,
        p = d === void 0 ? ", " : d,
        u = a.className,
        c = a.classNames,
        g = c === void 0 ? {} : c,
        v = Cs(a, Nf);
      return t(
        "span",
        Er({}, v, { className: L(g.root, u) }),
        o.map(function (h, b) {
          var S = b === o.length - 1;
          return t(
            n,
            { key: b },
            h.map(function (O, _) {
              return t(
                r,
                {
                  key: _,
                  classNames: g,
                  highlightedTagName: l,
                  nonHighlightedTagName: m,
                  isHighlighted: O.isHighlighted,
                },
                O.value,
              );
            }),
            !S && t("span", { className: g.separator }, p),
          );
        }),
      );
    };
  }
  var Df = [
    "classNames",
    "hits",
    "itemComponent",
    "sendEvent",
    "emptyComponent",
    "banner",
    "bannerComponent",
  ];
  function Hf(e) {
    var t = e.createElement;
    return function (r) {
      var i = r.classNames,
        a = r.banner;
      return a.image.urls[0].url
        ? t(
            "aside",
            { className: L("ais-Hits-banner", i.bannerRoot) },
            a.link
              ? t(
                  "a",
                  {
                    className: L("ais-Hits-banner-link", i.bannerLink),
                    href: a.link.url,
                    target: a.link.target,
                  },
                  t("img", {
                    className: L("ais-Hits-banner-image", i.bannerImage),
                    src: a.image.urls[0].url,
                    alt: a.image.title,
                  }),
                )
              : t("img", {
                  className: L("ais-Hits-banner-image", i.bannerImage),
                  src: a.image.urls[0].url,
                  alt: a.image.title,
                }),
          )
        : null;
    };
  }
  function Lf(e) {
    var t = e.createElement,
      n = Hf({ createElement: t });
    return function (i) {
      var a = i.classNames,
        o = a === void 0 ? {} : a,
        s = i.hits,
        l = i.itemComponent,
        f = i.sendEvent,
        m = i.emptyComponent,
        d = i.banner,
        p = i.bannerComponent,
        u = Cs(i, Df);
      return t(
        "div",
        Er({}, u, {
          className: L(
            "ais-Hits",
            o.root,
            s.length === 0 && L("ais-Hits--empty", o.emptyRoot),
            u.className,
          ),
        }),
        d &&
          (p
            ? t(p, { className: L("ais-Hits-banner", o.bannerRoot), banner: d })
            : t(n, { classNames: o, banner: d })),
        s.length === 0 && m
          ? t(m, null) // Add 2 classes beside the ais-Hits-list class
          : t(
              "ol",
              {
                className: L(
                  "row row-cols-xl-4 bls__grid bls__product-style-3 ais-Hits-list",
                  o.list,
                ),
              },
              s.map(function (c, g) {
                // Adding a class beside ais-Hits-item class
                return t(l, {
                  key: c.objectID,
                  hit: c,
                  index: g,
                  className: L("bls__product-load ais-Hits-item", o.item),
                  onClick: function () {
                    f("click:internal", c, "Hit Clicked");
                  },
                  onAuxClick: function () {
                    f("click:internal", c, "Hit Clicked");
                  },
                });
              }),
            ),
      );
    };
  }
  var Tr,
    ce,
    As,
    Ze,
    Ds,
    Hs,
    Ls,
    Ms,
    Xn,
    Zn,
    ei,
    Jt = {},
    Ws = [],
    Mf = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
    Ir = Array.isArray;
  function Me(e, t) {
    for (var n in t) e[n] = t[n];
    return e;
  }
  function ti(e) {
    e && e.parentNode && e.parentNode.removeChild(e);
  }
  function H(e, t, n) {
    var r,
      i,
      a,
      o = {};
    for (a in t)
      a == "key" ? (r = t[a]) : a == "ref" ? (i = t[a]) : (o[a] = t[a]);
    if (
      (arguments.length > 2 &&
        (o.children = arguments.length > 3 ? Tr.call(arguments, 2) : n),
      typeof e == "function" && e.defaultProps != null)
    )
      for (a in e.defaultProps) o[a] == null && (o[a] = e.defaultProps[a]);
    return Nr(e, o, r, i, null);
  }
  function Nr(e, t, n, r, i) {
    var a = {
      type: e,
      props: t,
      key: n,
      ref: r,
      __k: null,
      __: null,
      __b: 0,
      __e: null,
      __c: null,
      constructor: void 0,
      __v: i ?? ++As,
      __i: -1,
      __u: 0,
    };
    return (i == null && ce.vnode != null && ce.vnode(a), a);
  }
  function Gt() {
    return { current: null };
  }
  function et(e) {
    return e.children;
  }
  function Ce(e, t) {
    ((this.props = e), (this.context = t));
  }
  function ht(e, t) {
    if (t == null) return e.__ ? ht(e.__, e.__i + 1) : null;
    for (var n; t < e.__k.length; t++)
      if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
    return typeof e.type == "function" ? ht(e) : null;
  }
  function qs(e) {
    var t, n;
    if ((e = e.__) != null && e.__c != null) {
      for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
        if ((n = e.__k[t]) != null && n.__e != null) {
          e.__e = e.__c.base = n.__e;
          break;
        }
      return qs(e);
    }
  }
  function Us(e) {
    ((!e.__d && (e.__d = !0) && Ze.push(e) && !Cr.__r++) ||
      Ds != ce.debounceRendering) &&
      ((Ds = ce.debounceRendering) || Hs)(Cr);
  }
  function Cr() {
    for (var e, t, n, r, i, a, o, s = 1; Ze.length; )
      (Ze.length > s && Ze.sort(Ls),
        (e = Ze.shift()),
        (s = Ze.length),
        e.__d &&
          ((n = void 0),
          (i = (r = (t = e).__v).__e),
          (a = []),
          (o = []),
          t.__P &&
            (((n = Me({}, r)).__v = r.__v + 1),
            ce.vnode && ce.vnode(n),
            ri(
              t.__P,
              n,
              r,
              t.__n,
              t.__P.namespaceURI,
              32 & r.__u ? [i] : null,
              a,
              i ?? ht(r),
              !!(32 & r.__u),
              o,
            ),
            (n.__v = r.__v),
            (n.__.__k[n.__i] = n),
            Ks(a, n, o),
            n.__e != i && qs(n))));
    Cr.__r = 0;
  }
  function ks(e, t, n, r, i, a, o, s, l, f, m) {
    var d,
      p,
      u,
      c,
      g,
      v,
      h = (r && r.__k) || Ws,
      b = t.length;
    for (l = Wf(n, t, h, l, b), d = 0; d < b; d++)
      (u = n.__k[d]) != null &&
        ((p = u.__i == -1 ? Jt : h[u.__i] || Jt),
        (u.__i = d),
        (v = ri(e, u, p, i, a, o, s, l, f, m)),
        (c = u.__e),
        u.ref &&
          p.ref != u.ref &&
          (p.ref && ni(p.ref, null, u), m.push(u.ref, u.__c || c, u)),
        g == null && c != null && (g = c),
        4 & u.__u || p.__k === u.__k
          ? (l = Qs(u, l, e))
          : typeof u.type == "function" && v !== void 0
            ? (l = v)
            : c && (l = c.nextSibling),
        (u.__u &= -7));
    return ((n.__e = g), l);
  }
  function Wf(e, t, n, r, i) {
    var a,
      o,
      s,
      l,
      f,
      m = n.length,
      d = m,
      p = 0;
    for (e.__k = new Array(i), a = 0; a < i; a++)
      (o = t[a]) != null && typeof o != "boolean" && typeof o != "function"
        ? ((l = a + p),
          ((o = e.__k[a] =
            typeof o == "string" ||
            typeof o == "number" ||
            typeof o == "bigint" ||
            o.constructor == String
              ? Nr(null, o, null, null, null)
              : Ir(o)
                ? Nr(et, { children: o }, null, null, null)
                : o.constructor == null && o.__b > 0
                  ? Nr(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v)
                  : o).__ = e),
          (o.__b = e.__b + 1),
          (s = null),
          (f = o.__i = qf(o, n, l, d)) != -1 &&
            (d--, (s = n[f]) && (s.__u |= 2)),
          s == null || s.__v == null
            ? (f == -1 && (i > m ? p-- : i < m && p++),
              typeof o.type != "function" && (o.__u |= 4))
            : f != l &&
              (f == l - 1
                ? p--
                : f == l + 1
                  ? p++
                  : (f > l ? p-- : p++, (o.__u |= 4))))
        : (e.__k[a] = null);
    if (d)
      for (a = 0; a < m; a++)
        (s = n[a]) != null &&
          (2 & s.__u) == 0 &&
          (s.__e == r && (r = ht(s)), Js(s, s));
    return r;
  }
  function Qs(e, t, n) {
    var r, i;
    if (typeof e.type == "function") {
      for (r = e.__k, i = 0; r && i < r.length; i++)
        r[i] && ((r[i].__ = e), (t = Qs(r[i], t, n)));
      return t;
    }
    e.__e != t &&
      (t && e.type && !n.contains(t) && (t = ht(e)),
      n.insertBefore(e.__e, t || null),
      (t = e.__e));
    do t = t && t.nextSibling;
    while (t != null && t.nodeType == 8);
    return t;
  }
  function qf(e, t, n, r) {
    var i,
      a,
      o = e.key,
      s = e.type,
      l = t[n];
    if (
      (l === null && e.key == null) ||
      (l && o == l.key && s == l.type && (2 & l.__u) == 0)
    )
      return n;
    if (r > (l != null && (2 & l.__u) == 0 ? 1 : 0))
      for (i = n - 1, a = n + 1; i >= 0 || a < t.length; ) {
        if (i >= 0) {
          if ((l = t[i]) && (2 & l.__u) == 0 && o == l.key && s == l.type)
            return i;
          i--;
        }
        if (a < t.length) {
          if ((l = t[a]) && (2 & l.__u) == 0 && o == l.key && s == l.type)
            return a;
          a++;
        }
      }
    return -1;
  }
  function Bs(e, t, n) {
    t[0] == "-"
      ? e.setProperty(t, n ?? "")
      : (e[t] =
          n == null ? "" : typeof n != "number" || Mf.test(t) ? n : n + "px");
  }
  function Ar(e, t, n, r, i) {
    var a;
    e: if (t == "style")
      if (typeof n == "string") e.style.cssText = n;
      else {
        if ((typeof r == "string" && (e.style.cssText = r = ""), r))
          for (t in r) (n && t in n) || Bs(e.style, t, "");
        if (n) for (t in n) (r && n[t] == r[t]) || Bs(e.style, t, n[t]);
      }
    else if (t[0] == "o" && t[1] == "n")
      ((a = t != (t = t.replace(Ms, "$1"))),
        (t =
          t.toLowerCase() in e || t == "onFocusOut" || t == "onFocusIn"
            ? t.toLowerCase().slice(2)
            : t.slice(2)),
        e.l || (e.l = {}),
        (e.l[t + a] = n),
        n
          ? r
            ? (n.u = r.u)
            : ((n.u = Xn), e.addEventListener(t, a ? ei : Zn, a))
          : e.removeEventListener(t, a ? ei : Zn, a));
    else {
      if (i == "http://www.w3.org/2000/svg")
        t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (
        t != "width" &&
        t != "height" &&
        t != "href" &&
        t != "list" &&
        t != "form" &&
        t != "tabIndex" &&
        t != "download" &&
        t != "rowSpan" &&
        t != "colSpan" &&
        t != "role" &&
        t != "popover" &&
        t in e
      )
        try {
          e[t] = n ?? "";
          break e;
        } catch {}
      typeof n == "function" ||
        (n == null || (n === !1 && t[4] != "-")
          ? e.removeAttribute(t)
          : e.setAttribute(t, t == "popover" && n == 1 ? "" : n));
    }
  }
  function Vs(e) {
    return function (t) {
      if (this.l) {
        var n = this.l[t.type + e];
        if (t.t == null) t.t = Xn++;
        else if (t.t < n.u) return;
        return n(ce.event ? ce.event(t) : t);
      }
    };
  }
  function ri(e, t, n, r, i, a, o, s, l, f) {
    var m,
      d,
      p,
      u,
      c,
      g,
      v,
      h,
      b,
      S,
      O,
      _,
      R,
      $,
      y,
      P,
      w,
      j = t.type;
    if (t.constructor != null) return null;
    (128 & n.__u && ((l = !!(32 & n.__u)), (a = [(s = t.__e = n.__e)])),
      (m = ce.__b) && m(t));
    e: if (typeof j == "function")
      try {
        if (
          ((h = t.props),
          (b = "prototype" in j && j.prototype.render),
          (S = (m = j.contextType) && r[m.__c]),
          (O = m ? (S ? S.props.value : m.__) : r),
          n.__c
            ? (v = (d = t.__c = n.__c).__ = d.__E)
            : (b
                ? (t.__c = d = new j(h, O))
                : ((t.__c = d = new Ce(h, O)),
                  (d.constructor = j),
                  (d.render = kf)),
              S && S.sub(d),
              (d.props = h),
              d.state || (d.state = {}),
              (d.context = O),
              (d.__n = r),
              (p = d.__d = !0),
              (d.__h = []),
              (d._sb = [])),
          b && d.__s == null && (d.__s = d.state),
          b &&
            j.getDerivedStateFromProps != null &&
            (d.__s == d.state && (d.__s = Me({}, d.__s)),
            Me(d.__s, j.getDerivedStateFromProps(h, d.__s))),
          (u = d.props),
          (c = d.state),
          (d.__v = t),
          p)
        )
          (b &&
            j.getDerivedStateFromProps == null &&
            d.componentWillMount != null &&
            d.componentWillMount(),
            b &&
              d.componentDidMount != null &&
              d.__h.push(d.componentDidMount));
        else {
          if (
            (b &&
              j.getDerivedStateFromProps == null &&
              h !== u &&
              d.componentWillReceiveProps != null &&
              d.componentWillReceiveProps(h, O),
            (!d.__e &&
              d.shouldComponentUpdate != null &&
              d.shouldComponentUpdate(h, d.__s, O) === !1) ||
              t.__v == n.__v)
          ) {
            for (
              t.__v != n.__v &&
                ((d.props = h), (d.state = d.__s), (d.__d = !1)),
                t.__e = n.__e,
                t.__k = n.__k,
                t.__k.some(function (T) {
                  T && (T.__ = t);
                }),
                _ = 0;
              _ < d._sb.length;
              _++
            )
              d.__h.push(d._sb[_]);
            ((d._sb = []), d.__h.length && o.push(d));
            break e;
          }
          (d.componentWillUpdate != null && d.componentWillUpdate(h, d.__s, O),
            b &&
              d.componentDidUpdate != null &&
              d.__h.push(function () {
                d.componentDidUpdate(u, c, g);
              }));
        }
        if (
          ((d.context = O),
          (d.props = h),
          (d.__P = e),
          (d.__e = !1),
          (R = ce.__r),
          ($ = 0),
          b)
        ) {
          for (
            d.state = d.__s,
              d.__d = !1,
              R && R(t),
              m = d.render(d.props, d.state, d.context),
              y = 0;
            y < d._sb.length;
            y++
          )
            d.__h.push(d._sb[y]);
          d._sb = [];
        } else
          do
            ((d.__d = !1),
              R && R(t),
              (m = d.render(d.props, d.state, d.context)),
              (d.state = d.__s));
          while (d.__d && ++$ < 25);
        ((d.state = d.__s),
          d.getChildContext != null && (r = Me(Me({}, r), d.getChildContext())),
          b &&
            !p &&
            d.getSnapshotBeforeUpdate != null &&
            (g = d.getSnapshotBeforeUpdate(u, c)),
          (P = m),
          m != null &&
            m.type === et &&
            m.key == null &&
            (P = zs(m.props.children)),
          (s = ks(e, Ir(P) ? P : [P], t, n, r, i, a, o, s, l, f)),
          (d.base = t.__e),
          (t.__u &= -161),
          d.__h.length && o.push(d),
          v && (d.__E = d.__ = null));
      } catch (T) {
        if (((t.__v = null), l || a != null))
          if (T.then) {
            for (
              t.__u |= l ? 160 : 128;
              s && s.nodeType == 8 && s.nextSibling;
            )
              s = s.nextSibling;
            ((a[a.indexOf(s)] = null), (t.__e = s));
          } else for (w = a.length; w--; ) ti(a[w]);
        else ((t.__e = n.__e), (t.__k = n.__k));
        ce.__e(T, t, n);
      }
    else
      a == null && t.__v == n.__v
        ? ((t.__k = n.__k), (t.__e = n.__e))
        : (s = t.__e = Uf(n.__e, t, n, r, i, a, o, l, f));
    return ((m = ce.diffed) && m(t), 128 & t.__u ? void 0 : s);
  }
  function Ks(e, t, n) {
    for (var r = 0; r < n.length; r++) ni(n[r], n[++r], n[++r]);
    (ce.__c && ce.__c(t, e),
      e.some(function (i) {
        try {
          ((e = i.__h),
            (i.__h = []),
            e.some(function (a) {
              a.call(i);
            }));
        } catch (a) {
          ce.__e(a, i.__v);
        }
      }));
  }
  function zs(e) {
    return typeof e != "object" || e == null || (e.__b && e.__b > 0)
      ? e
      : Ir(e)
        ? e.map(zs)
        : Me({}, e);
  }
  function Uf(e, t, n, r, i, a, o, s, l) {
    var f,
      m,
      d,
      p,
      u,
      c,
      g,
      v = n.props,
      h = t.props,
      b = t.type;
    if (
      (b == "svg"
        ? (i = "http://www.w3.org/2000/svg")
        : b == "math"
          ? (i = "http://www.w3.org/1998/Math/MathML")
          : i || (i = "http://www.w3.org/1999/xhtml"),
      a != null)
    ) {
      for (f = 0; f < a.length; f++)
        if (
          (u = a[f]) &&
          "setAttribute" in u == !!b &&
          (b ? u.localName == b : u.nodeType == 3)
        ) {
          ((e = u), (a[f] = null));
          break;
        }
    }
    if (e == null) {
      if (b == null) return document.createTextNode(h);
      ((e = document.createElementNS(i, b, h.is && h)),
        s && (ce.__m && ce.__m(t, a), (s = !1)),
        (a = null));
    }
    if (b == null) v === h || (s && e.data == h) || (e.data = h);
    else {
      if (
        ((a = a && Tr.call(e.childNodes)), (v = n.props || Jt), !s && a != null)
      )
        for (v = {}, f = 0; f < e.attributes.length; f++)
          v[(u = e.attributes[f]).name] = u.value;
      for (f in v)
        if (((u = v[f]), f != "children")) {
          if (f == "dangerouslySetInnerHTML") d = u;
          else if (!(f in h)) {
            if (
              (f == "value" && "defaultValue" in h) ||
              (f == "checked" && "defaultChecked" in h)
            )
              continue;
            Ar(e, f, null, u, i);
          }
        }
      for (f in h)
        ((u = h[f]),
          f == "children"
            ? (p = u)
            : f == "dangerouslySetInnerHTML"
              ? (m = u)
              : f == "value"
                ? (c = u)
                : f == "checked"
                  ? (g = u)
                  : (s && typeof u != "function") ||
                    v[f] === u ||
                    Ar(e, f, u, v[f], i));
      if (m)
        (s ||
          (d && (m.__html == d.__html || m.__html == e.innerHTML)) ||
          (e.innerHTML = m.__html),
          (t.__k = []));
      else if (
        (d && (e.innerHTML = ""),
        ks(
          t.type == "template" ? e.content : e,
          Ir(p) ? p : [p],
          t,
          n,
          r,
          b == "foreignObject" ? "http://www.w3.org/1999/xhtml" : i,
          a,
          o,
          a ? a[0] : n.__k && ht(n, 0),
          s,
          l,
        ),
        a != null)
      )
        for (f = a.length; f--; ) ti(a[f]);
      s ||
        ((f = "value"),
        b == "progress" && c == null
          ? e.removeAttribute("value")
          : c != null &&
            (c !== e[f] ||
              (b == "progress" && !c) ||
              (b == "option" && c != v[f])) &&
            Ar(e, f, c, v[f], i),
        (f = "checked"),
        g != null && g != e[f] && Ar(e, f, g, v[f], i));
    }
    return e;
  }
  function ni(e, t, n) {
    try {
      if (typeof e == "function") {
        var r = typeof e.__u == "function";
        (r && e.__u(), (r && t == null) || (e.__u = e(t)));
      } else e.current = t;
    } catch (i) {
      ce.__e(i, n);
    }
  }
  function Js(e, t, n) {
    var r, i;
    if (
      (ce.unmount && ce.unmount(e),
      (r = e.ref) && ((r.current && r.current != e.__e) || ni(r, null, t)),
      (r = e.__c) != null)
    ) {
      if (r.componentWillUnmount)
        try {
          r.componentWillUnmount();
        } catch (a) {
          ce.__e(a, t);
        }
      r.base = r.__P = null;
    }
    if ((r = e.__k))
      for (i = 0; i < r.length; i++)
        r[i] && Js(r[i], t, n || typeof e.type != "function");
    (n || ti(e.__e), (e.__c = e.__ = e.__e = void 0));
  }
  function kf(e, t, n) {
    return this.constructor(e, n);
  }
  function Ve(e, t, n) {
    var r, i, a, o;
    (t == document && (t = document.documentElement),
      ce.__ && ce.__(e, t),
      (i = (r = !1) ? null : t.__k),
      (a = []),
      (o = []),
      ri(
        t,
        (e = t.__k = H(et, null, [e])),
        i || Jt,
        Jt,
        t.namespaceURI,
        i ? null : t.firstChild ? Tr.call(t.childNodes) : null,
        a,
        i ? i.__e : t.firstChild,
        r,
        o,
      ),
      Ks(a, e, o));
  }
  ((Tr = Ws.slice),
    (ce = {
      __e: function (e, t, n, r) {
        for (var i, a, o; (t = t.__); )
          if ((i = t.__c) && !i.__)
            try {
              if (
                ((a = i.constructor) &&
                  a.getDerivedStateFromError != null &&
                  (i.setState(a.getDerivedStateFromError(e)), (o = i.__d)),
                i.componentDidCatch != null &&
                  (i.componentDidCatch(e, r || {}), (o = i.__d)),
                o)
              )
                return (i.__E = i);
            } catch (s) {
              e = s;
            }
        throw e;
      },
    }),
    (As = 0),
    (Ce.prototype.setState = function (e, t) {
      var n;
      ((n =
        this.__s != null && this.__s != this.state
          ? this.__s
          : (this.__s = Me({}, this.state))),
        typeof e == "function" && (e = e(Me({}, n), this.props)),
        e && Me(n, e),
        e != null && this.__v && (t && this._sb.push(t), Us(this)));
    }),
    (Ce.prototype.forceUpdate = function (e) {
      this.__v && ((this.__e = !0), e && this.__h.push(e), Us(this));
    }),
    (Ce.prototype.render = et),
    (Ze = []),
    (Hs =
      typeof Promise == "function"
        ? Promise.prototype.then.bind(Promise.resolve())
        : setTimeout),
    (Ls = function (e, t) {
      return e.__v.__b - t.__v.__b;
    }),
    (Cr.__r = 0),
    (Ms = /(PointerCapture)$|Capture$/i),
    (Xn = 0),
    (Zn = Vs(!1)),
    (ei = Vs(!0)));
  function Yt(e) {
    "@babel/helpers - typeof";
    return (
      (Yt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Yt(e)
    );
  }
  function Gs(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Qf(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Gs(Object(n), !0).forEach(function (r) {
            Bf(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Gs(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Bf(e, t, n) {
    return (
      (t = Vf(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Vf(e) {
    var t = Kf(e, "string");
    return Yt(t) == "symbol" ? t : String(t);
  }
  function Kf(e, t) {
    if (Yt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Yt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Ys(e) {
    return Yf(e) || Gf(e) || Jf(e) || zf();
  }
  function zf() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Jf(e, t) {
    if (e) {
      if (typeof e == "string") return ii(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return ii(e, t);
    }
  }
  function Gf(e) {
    if (
      (typeof Symbol < "u" && e[Symbol.iterator] != null) ||
      e["@@iterator"] != null
    )
      return Array.from(e);
  }
  function Yf(e) {
    if (Array.isArray(e)) return ii(e);
  }
  function ii(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Xf(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      n = en([].concat(Ys(Object.keys(e || {})), Ys(Object.keys(t))));
    return n.reduce(
      function (r, i) {
        var a = e ? e[i] : void 0,
          o = t[i],
          s = o !== void 0 && o !== a;
        return (
          (r.templates[i] = s ? o : a),
          (r.useCustomCompileOptions[i] = s),
          r
        );
      },
      { templates: {}, useCustomCompileOptions: {} },
    );
  }
  function ai(e) {
    var t = e.defaultTemplates,
      n = e.templates,
      r = e.templatesConfig,
      i = Xf(t, n);
    return Qf({ templatesConfig: r }, i);
  }
  var si = {},
    Xs;
  function Zf() {
    return (
      Xs ||
        ((Xs = 1),
        (function (e) {
          (function (t) {
            var n = /\S/,
              r = /\"/g,
              i = /\n/g,
              a = /\r/g,
              o = /\\/g,
              s = /\u2028/,
              l = /\u2029/;
            ((t.tags = {
              "#": 1,
              "^": 2,
              "<": 3,
              $: 4,
              "/": 5,
              "!": 6,
              ">": 7,
              "=": 8,
              _v: 9,
              "{": 10,
              "&": 11,
              _t: 12,
            }),
              (t.scan = function (P, w) {
                var j = P.length,
                  T = 0,
                  N = 1,
                  Q = 2,
                  W = T,
                  G = null,
                  B = null,
                  A = "",
                  C = [],
                  q = !1,
                  M = 0,
                  K = 0,
                  Y = "{{",
                  Z = "}}";
                function k() {
                  A.length > 0 &&
                    (C.push({ tag: "_t", text: new String(A) }), (A = ""));
                }
                function z() {
                  for (var F = !0, E = K; E < C.length; E++)
                    if (
                      ((F =
                        t.tags[C[E].tag] < t.tags._v ||
                        (C[E].tag == "_t" && C[E].text.match(n) === null)),
                      !F)
                    )
                      return !1;
                  return F;
                }
                function ee(F, E) {
                  if ((k(), F && z()))
                    for (var I = K, D; I < C.length; I++)
                      C[I].text &&
                        ((D = C[I + 1]) &&
                          D.tag == ">" &&
                          (D.indent = C[I].text.toString()),
                        C.splice(I, 1));
                  else
                    E ||
                      C.push({
                        tag: `
`,
                      });
                  ((q = !1), (K = C.length));
                }
                function x(F, E) {
                  var I = "=" + Z,
                    D = F.indexOf(I, E),
                    V = m(F.substring(F.indexOf("=", E) + 1, D)).split(" ");
                  return ((Y = V[0]), (Z = V[V.length - 1]), D + I.length - 1);
                }
                for (
                  w && ((w = w.split(" ")), (Y = w[0]), (Z = w[1])), M = 0;
                  M < j;
                  M++
                )
                  W == T
                    ? d(Y, P, M)
                      ? (--M, k(), (W = N))
                      : P.charAt(M) ==
                          `
`
                        ? ee(q)
                        : (A += P.charAt(M))
                    : W == N
                      ? ((M += Y.length - 1),
                        (B = t.tags[P.charAt(M + 1)]),
                        (G = B ? P.charAt(M + 1) : "_v"),
                        G == "="
                          ? ((M = x(P, M)), (W = T))
                          : (B && M++, (W = Q)),
                        (q = M))
                      : d(Z, P, M)
                        ? (C.push({
                            tag: G,
                            n: m(A),
                            otag: Y,
                            ctag: Z,
                            i: G == "/" ? q - Y.length : M + Z.length,
                          }),
                          (A = ""),
                          (M += Z.length - 1),
                          (W = T),
                          G == "{" && (Z == "}}" ? M++ : f(C[C.length - 1])))
                        : (A += P.charAt(M));
                return (ee(q, !0), C);
              }));
            function f(y) {
              y.n.substr(y.n.length - 1) === "}" &&
                (y.n = y.n.substring(0, y.n.length - 1));
            }
            function m(y) {
              return y.trim ? y.trim() : y.replace(/^\s*|\s*$/g, "");
            }
            function d(y, P, w) {
              if (P.charAt(w) != y.charAt(0)) return !1;
              for (var j = 1, T = y.length; j < T; j++)
                if (P.charAt(w + j) != y.charAt(j)) return !1;
              return !0;
            }
            var p = { _t: !0, "\n": !0, $: !0, "/": !0 };
            function u(y, P, w, j) {
              var T = [],
                N = null,
                Q = null,
                W = null;
              for (Q = w[w.length - 1]; y.length > 0; ) {
                if (((W = y.shift()), Q && Q.tag == "<" && !(W.tag in p)))
                  throw new Error("Illegal content in < super tag.");
                if (t.tags[W.tag] <= t.tags.$ || c(W, j))
                  (w.push(W), (W.nodes = u(y, W.tag, w, j)));
                else if (W.tag == "/") {
                  if (w.length === 0)
                    throw new Error("Closing tag without opener: /" + W.n);
                  if (((N = w.pop()), W.n != N.n && !g(W.n, N.n, j)))
                    throw new Error("Nesting error: " + N.n + " vs. " + W.n);
                  return ((N.end = W.i), T);
                } else
                  W.tag ==
                    `
` &&
                    (W.last =
                      y.length == 0 ||
                      y[0].tag ==
                        `
`);
                T.push(W);
              }
              if (w.length > 0)
                throw new Error("missing closing tag: " + w.pop().n);
              return T;
            }
            function c(y, P) {
              for (var w = 0, j = P.length; w < j; w++)
                if (P[w].o == y.n) return ((y.tag = "#"), !0);
            }
            function g(y, P, w) {
              for (var j = 0, T = w.length; j < T; j++)
                if (w[j].c == y && w[j].o == P) return !0;
            }
            function v(y) {
              var P = [];
              for (var w in y)
                P.push('"' + S(w) + '": function(c,p,t,i) {' + y[w] + "}");
              return "{ " + P.join(",") + " }";
            }
            function h(y) {
              var P = [];
              for (var w in y.partials)
                P.push(
                  '"' +
                    S(w) +
                    '":{name:"' +
                    S(y.partials[w].name) +
                    '", ' +
                    h(y.partials[w]) +
                    "}",
                );
              return "partials: {" + P.join(",") + "}, subs: " + v(y.subs);
            }
            t.stringify = function (y, P, w) {
              return (
                "{code: function (c,p,i) { " +
                t.wrapMain(y.code) +
                " }," +
                h(y) +
                "}"
              );
            };
            var b = 0;
            ((t.generate = function (y, P, w) {
              b = 0;
              var j = { code: "", subs: {}, partials: {} };
              return (
                t.walk(y, j),
                w.asString
                  ? this.stringify(j, P, w)
                  : this.makeTemplate(j, P, w)
              );
            }),
              (t.wrapMain = function (y) {
                return 'var t=this;t.b(i=i||"");' + y + "return t.fl();";
              }),
              (t.template = t.Template),
              (t.makeTemplate = function (y, P, w) {
                var j = this.makePartials(y);
                return (
                  (j.code = new Function("c", "p", "i", this.wrapMain(y.code))),
                  new this.template(j, P, this, w)
                );
              }),
              (t.makePartials = function (y) {
                var P,
                  w = { subs: {}, partials: y.partials, name: y.name };
                for (P in w.partials)
                  w.partials[P] = this.makePartials(w.partials[P]);
                for (P in y.subs)
                  w.subs[P] = new Function("c", "p", "t", "i", y.subs[P]);
                return w;
              }));
            function S(y) {
              return y
                .replace(o, "\\\\")
                .replace(r, '\\"')
                .replace(i, "\\n")
                .replace(a, "\\r")
                .replace(s, "\\u2028")
                .replace(l, "\\u2029");
            }
            function O(y) {
              return ~y.indexOf(".") ? "d" : "f";
            }
            function _(y, P) {
              var w = "<" + (P.prefix || ""),
                j = w + y.n + b++;
              return (
                (P.partials[j] = { name: y.n, partials: {} }),
                (P.code +=
                  't.b(t.rp("' + S(j) + '",c,p,"' + (y.indent || "") + '"));'),
                j
              );
            }
            t.codegen = {
              "#": function (y, P) {
                ((P.code +=
                  "if(t.s(t." +
                  O(y.n) +
                  '("' +
                  S(y.n) +
                  '",c,p,1),c,p,0,' +
                  y.i +
                  "," +
                  y.end +
                  ',"' +
                  y.otag +
                  " " +
                  y.ctag +
                  '")){t.rs(c,p,function(c,p,t){'),
                  t.walk(y.nodes, P),
                  (P.code += "});c.pop();}"));
              },
              "^": function (y, P) {
                ((P.code +=
                  "if(!t.s(t." +
                  O(y.n) +
                  '("' +
                  S(y.n) +
                  '",c,p,1),c,p,1,0,0,"")){'),
                  t.walk(y.nodes, P),
                  (P.code += "};"));
              },
              ">": _,
              "<": function (y, P) {
                var w = { partials: {}, code: "", subs: {}, inPartial: !0 };
                t.walk(y.nodes, w);
                var j = P.partials[_(y, P)];
                ((j.subs = w.subs), (j.partials = w.partials));
              },
              $: function (y, P) {
                var w = {
                  subs: {},
                  code: "",
                  partials: P.partials,
                  prefix: y.n,
                };
                (t.walk(y.nodes, w),
                  (P.subs[y.n] = w.code),
                  P.inPartial || (P.code += 't.sub("' + S(y.n) + '",c,p,i);'));
              },
              "\n": function (y, P) {
                P.code += $('"\\n"' + (y.last ? "" : " + i"));
              },
              _v: function (y, P) {
                P.code += "t.b(t.v(t." + O(y.n) + '("' + S(y.n) + '",c,p,0)));';
              },
              _t: function (y, P) {
                P.code += $('"' + S(y.text) + '"');
              },
              "{": R,
              "&": R,
            };
            function R(y, P) {
              P.code += "t.b(t.t(t." + O(y.n) + '("' + S(y.n) + '",c,p,0)));';
            }
            function $(y) {
              return "t.b(" + y + ");";
            }
            ((t.walk = function (y, P) {
              for (var w, j = 0, T = y.length; j < T; j++)
                ((w = t.codegen[y[j].tag]), w && w(y[j], P));
              return P;
            }),
              (t.parse = function (y, P, w) {
                return ((w = w || {}), u(y, "", [], w.sectionTags || []));
              }),
              (t.cache = {}),
              (t.cacheKey = function (y, P) {
                return [
                  y,
                  !!P.asString,
                  !!P.disableLambda,
                  P.delimiters,
                  !!P.modelGet,
                ].join("||");
              }),
              (t.compile = function (y, P) {
                P = P || {};
                var w = t.cacheKey(y, P),
                  j = this.cache[w];
                if (j) {
                  var T = j.partials;
                  for (var N in T) delete T[N].instance;
                  return j;
                }
                return (
                  (j = this.generate(
                    this.parse(this.scan(y, P.delimiters), y, P),
                    y,
                    P,
                  )),
                  (this.cache[w] = j)
                );
              }));
          })(e);
        })(si)),
      si
    );
  }
  var oi = {},
    Zs;
  function eh() {
    return (
      Zs ||
        ((Zs = 1),
        (function (e) {
          (function (t) {
            ((t.Template = function (u, c, g, v) {
              ((u = u || {}),
                (this.r = u.code || this.r),
                (this.c = g),
                (this.options = v || {}),
                (this.text = c || ""),
                (this.partials = u.partials || {}),
                (this.subs = u.subs || {}),
                (this.buf = ""));
            }),
              (t.Template.prototype = {
                r: function (u, c, g) {
                  return "";
                },
                v: d,
                t: m,
                render: function (c, g, v) {
                  return this.ri([c], g || {}, v);
                },
                ri: function (u, c, g) {
                  return this.r(u, c, g);
                },
                ep: function (u, c) {
                  var g = this.partials[u],
                    v = c[g.name];
                  if (g.instance && g.base == v) return g.instance;
                  if (typeof v == "string") {
                    if (!this.c) throw new Error("No compiler available.");
                    v = this.c.compile(v, this.options);
                  }
                  if (!v) return null;
                  if (((this.partials[u].base = v), g.subs)) {
                    c.stackText || (c.stackText = {});
                    for (key in g.subs)
                      c.stackText[key] ||
                        (c.stackText[key] =
                          this.activeSub !== void 0 &&
                          c.stackText[this.activeSub]
                            ? c.stackText[this.activeSub]
                            : this.text);
                    v = r(
                      v,
                      g.subs,
                      g.partials,
                      this.stackSubs,
                      this.stackPartials,
                      c.stackText,
                    );
                  }
                  return ((this.partials[u].instance = v), v);
                },
                rp: function (u, c, g, v) {
                  var h = this.ep(u, g);
                  return h ? h.ri(c, g, v) : "";
                },
                rs: function (u, c, g) {
                  var v = u[u.length - 1];
                  if (!p(v)) {
                    g(u, c, this);
                    return;
                  }
                  for (var h = 0; h < v.length; h++)
                    (u.push(v[h]), g(u, c, this), u.pop());
                },
                s: function (u, c, g, v, h, b, S) {
                  var O;
                  return p(u) && u.length === 0
                    ? !1
                    : (typeof u == "function" &&
                        (u = this.ms(u, c, g, v, h, b, S)),
                      (O = !!u),
                      !v &&
                        O &&
                        c &&
                        c.push(typeof u == "object" ? u : c[c.length - 1]),
                      O);
                },
                d: function (u, c, g, v) {
                  var h,
                    b = u.split("."),
                    S = this.f(b[0], c, g, v),
                    O = this.options.modelGet,
                    _ = null;
                  if (u === "." && p(c[c.length - 2])) S = c[c.length - 1];
                  else
                    for (var R = 1; R < b.length; R++)
                      ((h = n(b[R], S, O)),
                        h !== void 0 ? ((_ = S), (S = h)) : (S = ""));
                  return v && !S
                    ? !1
                    : (!v &&
                        typeof S == "function" &&
                        (c.push(_), (S = this.mv(S, c, g)), c.pop()),
                      S);
                },
                f: function (u, c, g, v) {
                  for (
                    var h = !1,
                      b = null,
                      S = !1,
                      O = this.options.modelGet,
                      _ = c.length - 1;
                    _ >= 0;
                    _--
                  )
                    if (((b = c[_]), (h = n(u, b, O)), h !== void 0)) {
                      S = !0;
                      break;
                    }
                  return S
                    ? (!v && typeof h == "function" && (h = this.mv(h, c, g)),
                      h)
                    : v
                      ? !1
                      : "";
                },
                ls: function (u, c, g, v, h) {
                  var b = this.options.delimiters;
                  return (
                    (this.options.delimiters = h),
                    this.b(this.ct(m(u.call(c, v)), c, g)),
                    (this.options.delimiters = b),
                    !1
                  );
                },
                ct: function (u, c, g) {
                  if (this.options.disableLambda)
                    throw new Error("Lambda features disabled.");
                  return this.c.compile(u, this.options).render(c, g);
                },
                b: function (u) {
                  this.buf += u;
                },
                fl: function () {
                  var u = this.buf;
                  return ((this.buf = ""), u);
                },
                ms: function (u, c, g, v, h, b, S) {
                  var O,
                    _ = c[c.length - 1],
                    R = u.call(_);
                  return typeof R == "function"
                    ? v
                      ? !0
                      : ((O =
                          this.activeSub &&
                          this.subsText &&
                          this.subsText[this.activeSub]
                            ? this.subsText[this.activeSub]
                            : this.text),
                        this.ls(R, _, g, O.substring(h, b), S))
                    : R;
                },
                mv: function (u, c, g) {
                  var v = c[c.length - 1],
                    h = u.call(v);
                  return typeof h == "function"
                    ? this.ct(m(h.call(v)), v, g)
                    : h;
                },
                sub: function (u, c, g, v) {
                  var h = this.subs[u];
                  h &&
                    ((this.activeSub = u),
                    h(c, g, this, v),
                    (this.activeSub = !1));
                },
              }));
            function n(u, c, g) {
              var v;
              return (
                c &&
                  typeof c == "object" &&
                  (c[u] !== void 0
                    ? (v = c[u])
                    : g &&
                      c.get &&
                      typeof c.get == "function" &&
                      (v = c.get(u))),
                v
              );
            }
            function r(u, c, g, v, h, b) {
              function S() {}
              S.prototype = u;
              function O() {}
              O.prototype = u.subs;
              var _,
                R = new S();
              ((R.subs = new O()),
                (R.subsText = {}),
                (R.buf = ""),
                (v = v || {}),
                (R.stackSubs = v),
                (R.subsText = b));
              for (_ in c) v[_] || (v[_] = c[_]);
              for (_ in v) R.subs[_] = v[_];
              ((h = h || {}), (R.stackPartials = h));
              for (_ in g) h[_] || (h[_] = g[_]);
              for (_ in h) R.partials[_] = h[_];
              return R;
            }
            var i = /&/g,
              a = /</g,
              o = />/g,
              s = /\'/g,
              l = /\"/g,
              f = /[&<>\"\']/;
            function m(u) {
              return String(u ?? "");
            }
            function d(u) {
              return (
                (u = m(u)),
                f.test(u)
                  ? u
                      .replace(i, "&amp;")
                      .replace(a, "&lt;")
                      .replace(o, "&gt;")
                      .replace(s, "&#39;")
                      .replace(l, "&quot;")
                  : u
              );
            }
            var p =
              Array.isArray ||
              function (u) {
                return Object.prototype.toString.call(u) === "[object Array]";
              };
          })(e);
        })(oi)),
      oi
    );
  }
  var ui, eo;
  function th() {
    if (eo) return ui;
    eo = 1;
    var e = Zf();
    return (
      (e.Template = eh().Template),
      (e.template = e.Template),
      (ui = e),
      ui
    );
  }
  var rh = th();
  const to = wt(rh);
  var ro = function (e, t, n, r) {
      var i;
      t[0] = 0;
      for (var a = 1; a < t.length; a++) {
        var o = t[a++],
          s = t[a] ? ((t[0] |= o ? 1 : 2), n[t[a++]]) : t[++a];
        o === 3
          ? (r[0] = s)
          : o === 4
            ? (r[1] = Object.assign(r[1] || {}, s))
            : o === 5
              ? ((r[1] = r[1] || {})[t[++a]] = s)
              : o === 6
                ? (r[1][t[++a]] += s + "")
                : o
                  ? ((i = e.apply(s, ro(e, s, n, ["", null]))),
                    r.push(i),
                    s[0] ? (t[0] |= 2) : ((t[a - 2] = 0), (t[a] = i)))
                  : r.push(s);
      }
      return r;
    },
    no = new Map();
  function nh(e) {
    var t = no.get(this);
    return (
      t || ((t = new Map()), no.set(this, t)),
      (t = ro(
        this,
        t.get(e) ||
          (t.set(
            e,
            (t = (function (n) {
              for (
                var r,
                  i,
                  a = 1,
                  o = "",
                  s = "",
                  l = [0],
                  f = function (p) {
                    (a === 1 &&
                    (p || (o = o.replace(/^\s*\n\s*|\s*\n\s*$/g, "")))
                      ? l.push(0, p, o)
                      : a === 3 && (p || o)
                        ? (l.push(3, p, o), (a = 2))
                        : a === 2 && o === "..." && p
                          ? l.push(4, p, 0)
                          : a === 2 && o && !p
                            ? l.push(5, 0, !0, o)
                            : a >= 5 &&
                              ((o || (!p && a === 5)) &&
                                (l.push(a, 0, o, i), (a = 6)),
                              p && (l.push(a, p, 0, i), (a = 6))),
                      (o = ""));
                  },
                  m = 0;
                m < n.length;
                m++
              ) {
                m && (a === 1 && f(), f(m));
                for (var d = 0; d < n[m].length; d++)
                  ((r = n[m][d]),
                    a === 1
                      ? r === "<"
                        ? (f(), (l = [l]), (a = 3))
                        : (o += r)
                      : a === 4
                        ? o === "--" && r === ">"
                          ? ((a = 1), (o = ""))
                          : (o = r + o[0])
                        : s
                          ? r === s
                            ? (s = "")
                            : (o += r)
                          : r === '"' || r === "'"
                            ? (s = r)
                            : r === ">"
                              ? (f(), (a = 1))
                              : a &&
                                (r === "="
                                  ? ((a = 5), (i = o), (o = ""))
                                  : r === "/" && (a < 5 || n[m][d + 1] === ">")
                                    ? (f(),
                                      a === 3 && (l = l[0]),
                                      (a = l),
                                      (l = l[0]).push(2, 0, a),
                                      (a = 0))
                                    : r === " " ||
                                        r === "	" ||
                                        r ===
                                          `
` ||
                                        r === "\r"
                                      ? (f(), (a = 2))
                                      : (o += r)),
                    a === 3 && o === "!--" && ((a = 4), (l = l[0])));
              }
              return (f(), l);
            })(e)),
          ),
          t),
        arguments,
        [],
      )).length > 1
        ? t
        : t[0]
    );
  }
  var ih = nh.bind(H),
    Dr = Af({ createElement: H, Fragment: et }),
    ah = ["classNames"];
  function ci() {
    return (
      (ci = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      ci.apply(this, arguments)
    );
  }
  function sh(e, t) {
    if (e == null) return {};
    var n = oh(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function oh(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function uh(e) {
    var t = e.classNames,
      n = t === void 0 ? {} : t,
      r = sh(e, ah);
    return H(
      Dr,
      ci(
        {
          classNames: {
            root: L("ais-Highlight", n.root),
            highlighted: L("ais-Highlight-highlighted", n.highlighted),
            nonHighlighted: L("ais-Highlight-nonHighlighted", n.nonHighlighted),
            separator: L("ais-Highlight-separator", n.separator),
          },
        },
        r,
      ),
    );
  }
  var ch = ["hit", "attribute", "cssClasses"];
  function li() {
    return (
      (li = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      li.apply(this, arguments)
    );
  }
  function lh(e, t) {
    if (e == null) return {};
    var n = fh(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function fh(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function hh(e) {
    var t = e.hit,
      n = e.attribute,
      r = e.cssClasses,
      i = lh(e, ch),
      a = Be(t._highlightResult, n) || [],
      o = jr(a),
      s = o.map(function (l) {
        var f = l.value;
        return ut($t(f || ""));
      });
    return H(uh, li({}, i, { parts: s, classNames: r }));
  }
  var dh = ["classNames"];
  function fi() {
    return (
      (fi = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      fi.apply(this, arguments)
    );
  }
  function ph(e, t) {
    if (e == null) return {};
    var n = mh(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function mh(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function gh(e) {
    var t = e.classNames,
      n = t === void 0 ? {} : t,
      r = ph(e, dh);
    return H(
      Dr,
      fi(
        {
          classNames: {
            root: L("ais-ReverseHighlight", n.root),
            highlighted: L("ais-ReverseHighlight-highlighted", n.highlighted),
            nonHighlighted: L(
              "ais-ReverseHighlight-nonHighlighted",
              n.nonHighlighted,
            ),
            separator: L("ais-ReverseHighlight-separator", n.separator),
          },
        },
        r,
      ),
    );
  }
  function Xt(e) {
    "@babel/helpers - typeof";
    return (
      (Xt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Xt(e)
    );
  }
  var vh = ["hit", "attribute", "cssClasses"],
    yh = ["isHighlighted"];
  function hi() {
    return (
      (hi = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      hi.apply(this, arguments)
    );
  }
  function io(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function ao(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? io(Object(n), !0).forEach(function (r) {
            bh(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : io(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function bh(e, t, n) {
    return (
      (t = Sh(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Sh(e) {
    var t = Ph(e, "string");
    return Xt(t) == "symbol" ? t : String(t);
  }
  function Ph(e, t) {
    if (Xt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Xt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function so(e, t) {
    if (e == null) return {};
    var n = _h(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function _h(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function Oh(e) {
    var t = e.hit,
      n = e.attribute,
      r = e.cssClasses,
      i = so(e, vh),
      a = Be(t._highlightResult, n) || [],
      o = jr(a),
      s = o.map(function (l) {
        var f = l.value;
        return ut($t(f || "")).map(function (m) {
          var d = m.isHighlighted,
            p = so(m, yh);
          return ao(ao({}, p), {}, { isHighlighted: !d });
        });
      });
    return H(gh, hi({}, i, { parts: s, classNames: r }));
  }
  var wh = ["classNames"];
  function di() {
    return (
      (di = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      di.apply(this, arguments)
    );
  }
  function Rh(e, t) {
    if (e == null) return {};
    var n = jh(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function jh(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function $h(e) {
    var t = e.classNames,
      n = t === void 0 ? {} : t,
      r = Rh(e, wh);
    return H(
      Dr,
      di(
        {
          classNames: {
            root: L("ais-ReverseSnippet", n.root),
            highlighted: L("ais-ReverseSnippet-highlighted", n.highlighted),
            nonHighlighted: L(
              "ais-ReverseSnippet-nonHighlighted",
              n.nonHighlighted,
            ),
            separator: L("ais-ReverseSnippet-separator", n.separator),
          },
        },
        r,
      ),
    );
  }
  function Zt(e) {
    "@babel/helpers - typeof";
    return (
      (Zt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Zt(e)
    );
  }
  var xh = ["hit", "attribute", "cssClasses"],
    Fh = ["isHighlighted"];
  function pi() {
    return (
      (pi = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      pi.apply(this, arguments)
    );
  }
  function oo(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function uo(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? oo(Object(n), !0).forEach(function (r) {
            Eh(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : oo(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Eh(e, t, n) {
    return (
      (t = Th(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Th(e) {
    var t = Ih(e, "string");
    return Zt(t) == "symbol" ? t : String(t);
  }
  function Ih(e, t) {
    if (Zt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (Zt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function co(e, t) {
    if (e == null) return {};
    var n = Nh(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function Nh(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function Ch(e) {
    var t = e.hit,
      n = e.attribute,
      r = e.cssClasses,
      i = co(e, xh),
      a = Be(t._snippetResult, n) || [],
      o = jr(a),
      s = o.map(function (l) {
        var f = l.value;
        return ut($t(f || "")).map(function (m) {
          var d = m.isHighlighted,
            p = co(m, Fh);
          return uo(uo({}, p), {}, { isHighlighted: !d });
        });
      });
    return H($h, pi({}, i, { parts: s, classNames: r }));
  }
  var Ah = ["classNames"];
  function mi() {
    return (
      (mi = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      mi.apply(this, arguments)
    );
  }
  function Dh(e, t) {
    if (e == null) return {};
    var n = Hh(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function Hh(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function Lh(e) {
    var t = e.classNames,
      n = t === void 0 ? {} : t,
      r = Dh(e, Ah);
    return H(
      Dr,
      mi(
        {
          classNames: {
            root: L("ais-Snippet", n.root),
            highlighted: L("ais-Snippet-highlighted", n.highlighted),
            nonHighlighted: L("ais-Snippet-nonHighlighted", n.nonHighlighted),
            separator: L("ais-Snippet-separator", n.separator),
          },
        },
        r,
      ),
    );
  }
  var Mh = ["hit", "attribute", "cssClasses"];
  function gi() {
    return (
      (gi = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      gi.apply(this, arguments)
    );
  }
  function Wh(e, t) {
    if (e == null) return {};
    var n = qh(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function qh(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function Uh(e) {
    var t = e.hit,
      n = e.attribute,
      r = e.cssClasses,
      i = Wh(e, Mh),
      a = Be(t._snippetResult, n) || [],
      o = jr(a),
      s = o.map(function (l) {
        var f = l.value;
        return ut($t(f || ""));
      });
    return H(Lh, gi({}, i, { parts: s, classNames: r }));
  }
  function dt(e) {
    "@babel/helpers - typeof";
    return (
      (dt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      dt(e)
    );
  }
  function lo(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Hr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? lo(Object(n), !0).forEach(function (r) {
            fo(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : lo(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function fo(e, t, n) {
    return (
      (t = kh(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function kh(e) {
    var t = Qh(e, "string");
    return dt(t) == "symbol" ? t : String(t);
  }
  function Qh(e, t) {
    if (dt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (dt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Bh() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      t = arguments.length > 1 ? arguments[1] : void 0,
      n = arguments.length > 2 ? arguments[2] : void 0;
    return Object.keys(e).reduce(function (r, i) {
      return Hr(
        Hr({}, r),
        {},
        fo({}, i, function () {
          var a = this;
          return function (o) {
            var s = function (f) {
              return to.compile(f, t).render(a);
            };
            return e[i].call(n, o, s);
          };
        }),
      );
    }, {});
  }
  function Vh(e) {
    var t = e.templates,
      n = e.templateKey,
      r = e.compileOptions,
      i = e.helpers,
      a = e.data,
      o = e.bindEvent,
      s = e.sendEvent,
      l = t[n];
    if (typeof l != "string" && typeof l != "function")
      throw new Error(
        "Template must be 'string' or 'function', was '"
          .concat(dt(l), "' (key: ")
          .concat(n, ")"),
      );
    if (typeof l == "function") {
      var f = o || {};
      return (
        (f.html = ih),
        (f.sendEvent = s),
        (f.components = {
          Highlight: hh,
          ReverseHighlight: Oh,
          Snippet: Uh,
          ReverseSnippet: Ch,
        }),
        l(a, f)
      );
    }
    var m = Bh(i, r, a);
    return to
      .compile(l, r)
      .render(Hr(Hr({}, a), {}, { helpers: m }))
      .replace(/[ \n\r\t\f\xA0]+/g, function (d) {
        return d.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
      })
      .trim();
  }
  function vi() {
    return (
      (vi = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      vi.apply(this, arguments)
    );
  }
  function tt(e) {
    "@babel/helpers - typeof";
    return (
      (tt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      tt(e)
    );
  }
  function Kh(e) {
    return Yh(e) || Gh(e) || Jh(e) || zh();
  }
  function zh() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Jh(e, t) {
    if (e) {
      if (typeof e == "string") return yi(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return yi(e, t);
    }
  }
  function Gh(e) {
    if (
      (typeof Symbol < "u" && e[Symbol.iterator] != null) ||
      e["@@iterator"] != null
    )
      return Array.from(e);
  }
  function Yh(e) {
    if (Array.isArray(e)) return yi(e);
  }
  function yi(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function ho(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Xh(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      ((r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, vo(r.key), r));
    }
  }
  function po(e, t, n) {
    return (
      t && Xh(e.prototype, t),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      e
    );
  }
  function mo(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    ((e.prototype = Object.create(t && t.prototype, {
      constructor: { value: e, writable: !0, configurable: !0 },
    })),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      t && bi(e, t));
  }
  function bi(e, t) {
    return (
      (bi = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (r, i) {
            return ((r.__proto__ = i), r);
          }),
      bi(e, t)
    );
  }
  function go(e) {
    var t = ed();
    return function () {
      var r = Lr(e),
        i;
      if (t) {
        var a = Lr(this).constructor;
        i = Reflect.construct(r, arguments, a);
      } else i = r.apply(this, arguments);
      return Zh(this, i);
    };
  }
  function Zh(e, t) {
    if (t && (tt(t) === "object" || typeof t == "function")) return t;
    if (t !== void 0)
      throw new TypeError(
        "Derived constructors may only return object or undefined",
      );
    return Si(e);
  }
  function Si(e) {
    if (e === void 0)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called",
      );
    return e;
  }
  function ed() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {}),
        ),
        !0
      );
    } catch {
      return !1;
    }
  }
  function Lr(e) {
    return (
      (Lr = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (n) {
            return n.__proto__ || Object.getPrototypeOf(n);
          }),
      Lr(e)
    );
  }
  function Pi(e, t, n) {
    return (
      (t = vo(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function vo(e) {
    var t = td(e, "string");
    return tt(t) == "symbol" ? t : String(t);
  }
  function td(e, t) {
    if (tt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (tt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var rd = (function (e) {
      mo(n, e);
      var t = go(n);
      function n() {
        var r;
        ho(this, n);
        for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
          a[o] = arguments[o];
        return (
          (r = t.call.apply(t, [this].concat(a))),
          Pi(Si(r), "ref", Gt()),
          Pi(Si(r), "nodes", []),
          r
        );
      }
      return (
        po(n, [
          {
            key: "componentDidMount",
            value: function () {
              var i = new DocumentFragment(),
                a = document.createElement("div");
              ((a.innerHTML = this.props.content),
                (this.nodes = Kh(a.childNodes)),
                this.nodes.forEach(function (o) {
                  return i.appendChild(o);
                }),
                this.ref.current.replaceWith(i));
            },
          },
          {
            key: "componentWillUnmount",
            value: function () {
              (this.nodes.forEach(function (i) {
                if (i instanceof Element) {
                  i.outerHTML = "";
                  return;
                }
                i.nodeValue = "";
              }),
                this.nodes[0].nodeValue && (this.nodes[0].nodeValue = ""));
            },
          },
          {
            key: "render",
            value: function () {
              return H("div", { ref: this.ref });
            },
          },
        ]),
        n
      );
    })(Ce),
    nd = {
      data: {},
      rootTagName: "div",
      useCustomCompileOptions: {},
      templates: {},
      templatesConfig: {},
    },
    $e = (function (e) {
      mo(n, e);
      var t = go(n);
      function n() {
        return (ho(this, n), t.apply(this, arguments));
      }
      return (
        po(n, [
          {
            key: "shouldComponentUpdate",
            value: function (i) {
              return (
                !ct(this.props.data, i.data) ||
                this.props.templateKey !== i.templateKey ||
                !ct(this.props.rootProps, i.rootProps)
              );
            },
          },
          {
            key: "render",
            value: function () {
              var i =
                  this.props.rootTagName === "fragment"
                    ? et
                    : this.props.rootTagName,
                a = this.props.useCustomCompileOptions[this.props.templateKey],
                o = a ? this.props.templatesConfig.compileOptions : {},
                s = Vh({
                  templates: this.props.templates,
                  templateKey: this.props.templateKey,
                  compileOptions: o,
                  helpers: this.props.templatesConfig.helpers,
                  data: this.props.data,
                  bindEvent: this.props.bindEvent,
                  sendEvent: this.props.sendEvent,
                });
              return s === null
                ? null
                : tt(s) === "object"
                  ? H(i, this.props.rootProps, s)
                  : i === et
                    ? H(rd, { content: s, key: Math.random() })
                    : H(
                        i,
                        vi({}, this.props.rootProps, {
                          dangerouslySetInnerHTML: { __html: s },
                        }),
                      );
            },
          },
        ]),
        n
      );
    })(Ce);
  Pi($e, "defaultProps", nd);
  function er(e) {
    "@babel/helpers - typeof";
    return (
      (er =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      er(e)
    );
  }
  function yo(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function me(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? yo(Object(n), !0).forEach(function (r) {
            bo(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : yo(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function bo(e, t, n) {
    return (
      (t = id(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function id(e) {
    var t = ad(e, "string");
    return er(t) == "symbol" ? t : String(t);
  }
  function ad(e, t) {
    if (er(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (er(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var sd = Oe({ name: "configure", connector: !0 });
  function So(e, t) {
    return e.setQueryParameters(
      Object.keys(t.searchParameters).reduce(function (n, r) {
        return me(me({}, n), {}, bo({}, r, void 0));
      }, {}),
    );
  }
  var od = function () {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : he,
      n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : he;
    return function (r) {
      if (!r || !Hi(r.searchParameters))
        throw new Error(sd("The `searchParameters` option expects an object."));
      var i = {};
      function a(o) {
        return function (s) {
          var l = So(o.state, r),
            f = Or(l, new Se.SearchParameters(s));
          ((r.searchParameters = s), o.setState(f).search());
        };
      }
      return {
        $$type: "ais.configure",
        init: function (s) {
          var l = s.instantSearchInstance;
          t(
            me(
              me({}, this.getWidgetRenderState(s)),
              {},
              { instantSearchInstance: l },
            ),
            !0,
          );
        },
        render: function (s) {
          var l = s.instantSearchInstance;
          t(
            me(
              me({}, this.getWidgetRenderState(s)),
              {},
              { instantSearchInstance: l },
            ),
            !1,
          );
        },
        dispose: function (s) {
          var l = s.state;
          return (n(), So(l, r));
        },
        getRenderState: function (s, l) {
          var f,
            m = this.getWidgetRenderState(l);
          return me(
            me({}, s),
            {},
            {
              configure: me(
                me({}, m),
                {},
                {
                  widgetParams: me(
                    me({}, m.widgetParams),
                    {},
                    {
                      searchParameters: Or(
                        new Se.SearchParameters(
                          (f = s.configure) === null || f === void 0
                            ? void 0
                            : f.widgetParams.searchParameters,
                        ),
                        new Se.SearchParameters(
                          m.widgetParams.searchParameters,
                        ),
                      ).getQueryParams(),
                    },
                  ),
                },
              ),
            },
          );
        },
        getWidgetRenderState: function (s) {
          var l = s.helper;
          return (
            i.refine || (i.refine = a(l)),
            { refine: i.refine, widgetParams: r }
          );
        },
        getWidgetSearchParameters: function (s, l) {
          var f = l.uiState;
          return Or(
            s,
            new Se.SearchParameters(
              me(me({}, f.configure), r.searchParameters),
            ),
          );
        },
        getWidgetUiState: function (s) {
          return me(
            me({}, s),
            {},
            { configure: me(me({}, s.configure), r.searchParameters) },
          );
        },
      };
    };
  };
  function tr(e) {
    "@babel/helpers - typeof";
    return (
      (tr =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      tr(e)
    );
  }
  function Po(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function _o(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Po(Object(n), !0).forEach(function (r) {
            ud(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Po(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function ud(e, t, n) {
    return (
      (t = cd(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function cd(e) {
    var t = ld(e, "string");
    return tr(t) == "symbol" ? t : String(t);
  }
  function ld(e, t) {
    if (tr(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (tr(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var fd = function (t) {
    var n = od(he);
    return _o(
      _o({}, n({ searchParameters: t })),
      {},
      { $$widgetType: "ais.configure" },
    );
  };
  function pt(e) {
    "@babel/helpers - typeof";
    return (
      (pt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      pt(e)
    );
  }
  function hd(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function dd(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      ((r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, Oo(r.key), r));
    }
  }
  function pd(e, t, n) {
    return (
      t && dd(e.prototype, t),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      e
    );
  }
  function md(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    ((e.prototype = Object.create(t && t.prototype, {
      constructor: { value: e, writable: !0, configurable: !0 },
    })),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      t && _i(e, t));
  }
  function _i(e, t) {
    return (
      (_i = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (r, i) {
            return ((r.__proto__ = i), r);
          }),
      _i(e, t)
    );
  }
  function gd(e) {
    var t = yd();
    return function () {
      var r = Mr(e),
        i;
      if (t) {
        var a = Mr(this).constructor;
        i = Reflect.construct(r, arguments, a);
      } else i = r.apply(this, arguments);
      return vd(this, i);
    };
  }
  function vd(e, t) {
    if (t && (pt(t) === "object" || typeof t == "function")) return t;
    if (t !== void 0)
      throw new TypeError(
        "Derived constructors may only return object or undefined",
      );
    return Ke(e);
  }
  function Ke(e) {
    if (e === void 0)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called",
      );
    return e;
  }
  function yd() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {}),
        ),
        !0
      );
    } catch {
      return !1;
    }
  }
  function Mr(e) {
    return (
      (Mr = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (n) {
            return n.__proto__ || Object.getPrototypeOf(n);
          }),
      Mr(e)
    );
  }
  function ze(e, t, n) {
    return (
      (t = Oo(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Oo(e) {
    var t = bd(e, "string");
    return pt(t) == "symbol" ? t : String(t);
  }
  function bd(e, t) {
    if (pt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (pt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Sd = {
      query: "",
      showSubmit: !0,
      showReset: !0,
      showLoadingIndicator: !0,
      autofocus: !1,
      searchAsYouType: !0,
      ignoreCompositionEvents: !1,
      isSearchStalled: !1,
      disabled: !1,
      ariaLabel: "Search",
      onChange: he,
      onSubmit: he,
      onReset: he,
      refine: he,
    },
    wo = (function (e) {
      md(n, e);
      var t = gd(n);
      function n() {
        var r;
        hd(this, n);
        for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
          a[o] = arguments[o];
        return (
          (r = t.call.apply(t, [this].concat(a))),
          ze(Ke(r), "state", { query: r.props.query, focused: !1 }),
          ze(Ke(r), "input", Gt()),
          ze(Ke(r), "onInput", function (s) {
            var l = r.props,
              f = l.searchAsYouType,
              m = l.refine,
              d = l.onChange,
              p = s.target.value;
            (r.props.ignoreCompositionEvents && s.isComposing) ||
              (f && m(p), r.setState({ query: p }), d(s));
          }),
          ze(Ke(r), "onSubmit", function (s) {
            var l = r.props,
              f = l.searchAsYouType,
              m = l.refine,
              d = l.onSubmit;
            return (
              s.preventDefault(),
              s.stopPropagation(),
              r.input.current && r.input.current.blur(),
              f || m(r.state.query),
              d(s),
              !1
            );
          }),
          ze(Ke(r), "onReset", function (s) {
            var l = r.props,
              f = l.refine,
              m = l.onReset,
              d = "";
            (r.input.current && r.input.current.focus(),
              f(d),
              r.setState({ query: d }),
              m(s));
          }),
          ze(Ke(r), "onBlur", function () {
            r.setState({ focused: !1 });
          }),
          ze(Ke(r), "onFocus", function () {
            r.setState({ focused: !0 });
          }),
          r
        );
      }
      return (
        pd(n, [
          {
            key: "resetInput",
            value: function () {
              this.setState({ query: "" });
            },
          },
          {
            key: "componentWillReceiveProps",
            value: function (i) {
              !this.state.focused &&
                i.query !== this.state.query &&
                this.setState({ query: i.query });
            },
          },
          {
            key: "render",
            value: function () {
              var i = this.props,
                a = i.cssClasses,
                o = i.placeholder,
                s = i.autofocus,
                l = i.showSubmit,
                f = i.showReset,
                m = i.showLoadingIndicator,
                d = i.templates,
                p = i.isSearchStalled,
                u = i.ariaLabel;
              return H(
                "div",
                { className: a.root },
                H(
                  "form",
                  {
                    action: "",
                    role: "search",
                    className: a.form,
                    noValidate: !0,
                    onSubmit: this.onSubmit,
                    onReset: this.onReset,
                  },
                  H("input", {
                    ref: this.input,
                    value: this.state.query,
                    disabled: this.props.disabled,
                    className: a.input,
                    type: "search",
                    placeholder: o,
                    autoFocus: s,
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    spellCheck: "false",
                    maxLength: 512,
                    onInput: this.onInput,
                    oncompositionend: this.onInput,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    "aria-label": u,
                  }),
                  H($e, {
                    templateKey: "submit",
                    rootTagName: "button",
                    rootProps: {
                      className: a.submit,
                      type: "submit",
                      title: "Submit the search query",
                      hidden: !l,
                    },
                    templates: d,
                    data: { cssClasses: a },
                  }),
                  H($e, {
                    templateKey: "reset",
                    rootTagName: "button",
                    rootProps: {
                      className: a.reset,
                      type: "reset",
                      title: "Clear the search query",
                      hidden: !(f && this.state.query.trim() && !p),
                    },
                    templates: d,
                    data: { cssClasses: a },
                  }),
                  m &&
                    H($e, {
                      templateKey: "loadingIndicator",
                      rootTagName: "span",
                      rootProps: { className: a.loadingIndicator, hidden: !p },
                      templates: d,
                      data: { cssClasses: a },
                    }),
                ),
              );
            },
          },
        ]),
        n
      );
    })(Ce);
  ze(wo, "defaultProps", Sd);
  function Oi() {
    return (
      (Oi = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      Oi.apply(this, arguments)
    );
  }
  function Pd(e) {
    var t = e.className,
      n = e.handleClick,
      r = e.facetValueToRefine,
      i = e.isRefined,
      a = e.templateProps,
      o = e.templateKey,
      s = e.templateData,
      l = e.subItems;
    return H(
      "li",
      {
        className: t,
        onClick: function (m) {
          n({ facetValueToRefine: r, isRefined: i, originalEvent: m });
        },
      },
      H($e, Oi({}, a, { templateKey: o, data: s })),
      l,
    );
  }
  var _d = ["root"];
  function mt(e) {
    "@babel/helpers - typeof";
    return (
      (mt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      mt(e)
    );
  }
  function Ro(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function jo(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Ro(Object(n), !0).forEach(function (r) {
            rt(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Ro(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function rr() {
    return (
      (rr = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      rr.apply(this, arguments)
    );
  }
  function Od(e, t) {
    if (e == null) return {};
    var n = wd(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function wd(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function Rd(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function jd(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      ((r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, $o(r.key), r));
    }
  }
  function $d(e, t, n) {
    return (
      t && jd(e.prototype, t),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      e
    );
  }
  function xd(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    ((e.prototype = Object.create(t && t.prototype, {
      constructor: { value: e, writable: !0, configurable: !0 },
    })),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      t && wi(e, t));
  }
  function wi(e, t) {
    return (
      (wi = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (r, i) {
            return ((r.__proto__ = i), r);
          }),
      wi(e, t)
    );
  }
  function Fd(e) {
    var t = Td();
    return function () {
      var r = Wr(e),
        i;
      if (t) {
        var a = Wr(this).constructor;
        i = Reflect.construct(r, arguments, a);
      } else i = r.apply(this, arguments);
      return Ed(this, i);
    };
  }
  function Ed(e, t) {
    if (t && (mt(t) === "object" || typeof t == "function")) return t;
    if (t !== void 0)
      throw new TypeError(
        "Derived constructors may only return object or undefined",
      );
    return gt(e);
  }
  function gt(e) {
    if (e === void 0)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called",
      );
    return e;
  }
  function Td() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {}),
        ),
        !0
      );
    } catch {
      return !1;
    }
  }
  function Wr(e) {
    return (
      (Wr = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (n) {
            return n.__proto__ || Object.getPrototypeOf(n);
          }),
      Wr(e)
    );
  }
  function rt(e, t, n) {
    return (
      (t = $o(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function $o(e) {
    var t = Id(e, "string");
    return mt(t) == "symbol" ? t : String(t);
  }
  function Id(e, t) {
    if (mt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (mt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Nd = { cssClasses: {}, depth: 0 };
  function xo(e) {
    return e.data !== void 0;
  }
  var Fo = (function (e) {
    xd(n, e);
    var t = Fd(n);
    function n() {
      var r;
      Rd(this, n);
      for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
        a[o] = arguments[o];
      return (
        (r = t.call.apply(t, [this].concat(a))),
        rt(gt(r), "listRef", Gt()),
        rt(gt(r), "searchBox", Gt()),
        rt(gt(r), "lastRefinedValue", void 0),
        rt(gt(r), "_generateFacetItem", function (s) {
          var l;
          if (xo(s) && Array.isArray(s.data) && s.data.length > 0) {
            var f = r.props.cssClasses;
            f.root;
            var m = Od(f, _d);
            l = H(
              n,
              rr({}, r.props, {
                cssClasses: m,
                depth: r.props.depth + 1,
                facetValues: s.data,
                showMore: !1,
                className: r.props.cssClasses.childList,
              }),
            );
          }
          var d = r.props.createURL(s.value),
            p = jo(
              jo({}, s),
              {},
              {
                url: d,
                attribute: r.props.attribute,
                cssClasses: r.props.cssClasses,
                isFromSearch: r.props.isFromSearch,
              },
            ),
            u = s.value;
          (s.isRefined !== void 0 && (u += "/".concat(s.isRefined)),
            s.count !== void 0 && (u += "/".concat(s.count)));
          var c = L(
            r.props.cssClasses.item,
            s.isRefined && r.props.cssClasses.selectedItem,
            !s.count && r.props.cssClasses.disabledItem,
            !!(xo(s) && Array.isArray(s.data) && s.data.length > 0) &&
              r.props.cssClasses.parentItem,
          );
          return H(Pd, {
            templateKey: "item",
            key: u,
            facetValueToRefine: s.value,
            handleClick: r.handleItemClick,
            isRefined: s.isRefined,
            className: c,
            subItems: l,
            templateData: p,
            templateProps: r.props.templateProps,
          });
        }),
        rt(gt(r), "handleItemClick", function (s) {
          var l = s.facetValueToRefine,
            f = s.isRefined,
            m = s.originalEvent;
          if (!sa(m)) {
            var d = m.target;
            if (
              !(d === null || d.parentNode === null) &&
              !(f && d.parentNode.querySelector('input[type="radio"]:checked'))
            ) {
              if (d.tagName === "INPUT") {
                r.refine(l);
                return;
              }
              for (; d !== m.currentTarget; ) {
                if (
                  d.tagName === "LABEL" &&
                  (d.querySelector('input[type="checkbox"]') ||
                    d.querySelector('input[type="radio"]'))
                )
                  return;
                (d.tagName === "A" && d.href && m.preventDefault(),
                  (d = d.parentNode));
              }
              (m.stopPropagation(), r.refine(l));
            }
          }
        }),
        r
      );
    }
    return (
      $d(n, [
        {
          key: "shouldComponentUpdate",
          value: function (i) {
            var a = !ct(this.props.facetValues, i.facetValues);
            return a;
          },
        },
        {
          key: "refine",
          value: function (i) {
            ((this.lastRefinedValue = i), this.props.toggleRefinement(i));
          },
        },
        {
          key: "componentWillReceiveProps",
          value: function (i) {
            this.searchBox.current &&
              !i.isFromSearch &&
              this.searchBox.current.resetInput();
          },
        },
        {
          key: "componentDidUpdate",
          value: function () {
            var i, a, o;
            ((i = this.listRef.current) === null ||
              i === void 0 ||
              (a = i.querySelector(
                'input[value="'.concat(
                  (o = this.lastRefinedValue) === null || o === void 0
                    ? void 0
                    : o.replace('"', '\\"'),
                  '"]',
                ),
              )) === null ||
              a === void 0 ||
              a.focus(),
              (this.lastRefinedValue = void 0));
          },
        },
        {
          key: "refineFirstValue",
          value: function () {
            var i = this.props.facetValues && this.props.facetValues[0];
            if (i) {
              var a = i.value;
              this.props.toggleRefinement(a);
            }
          },
        },
        {
          key: "render",
          value: function () {
            var i = this,
              a = L(
                this.props.cssClasses.showMore,
                !(this.props.showMore === !0 && this.props.canToggleShowMore) &&
                  this.props.cssClasses.disabledShowMore,
              ),
              o =
                this.props.showMore === !0 &&
                H(
                  $e,
                  rr({}, this.props.templateProps, {
                    templateKey: "showMoreText",
                    rootTagName: "button",
                    rootProps: {
                      className: a,
                      disabled: !this.props.canToggleShowMore,
                      onClick: this.props.toggleShowMore,
                    },
                    data: { isShowingMore: this.props.isShowingMore },
                  }),
                ),
              s =
                this.props.searchIsAlwaysActive !== !0 &&
                !(this.props.isFromSearch || !this.props.hasExhaustiveItems),
              l =
                this.props.searchFacetValues &&
                H(
                  "div",
                  { className: this.props.cssClasses.searchBox },
                  H(wo, {
                    ref: this.searchBox,
                    placeholder: this.props.searchPlaceholder,
                    disabled: s,
                    cssClasses: this.props.cssClasses.searchable,
                    templates: this.props.searchBoxTemplateProps.templates,
                    onChange: function (u) {
                      return i.props.searchFacetValues(u.target.value);
                    },
                    onReset: function () {
                      return i.props.searchFacetValues("");
                    },
                    onSubmit: function () {
                      return i.refineFirstValue();
                    },
                    searchAsYouType: !1,
                    ariaLabel: "Search for filters",
                  }),
                ),
              f =
                this.props.facetValues &&
                this.props.facetValues.length > 0 &&
                H(
                  "ul",
                  { ref: this.listRef, className: this.props.cssClasses.list },
                  this.props.facetValues.map(this._generateFacetItem, this),
                ),
              m =
                this.props.searchFacetValues &&
                this.props.isFromSearch &&
                (!this.props.facetValues ||
                  this.props.facetValues.length === 0) &&
                H(
                  $e,
                  rr({}, this.props.templateProps, {
                    templateKey: "searchableNoResults",
                    rootProps: { className: this.props.cssClasses.noResults },
                  }),
                ),
              d = L(
                this.props.cssClasses.root,
                (!this.props.facetValues ||
                  this.props.facetValues.length === 0) &&
                  this.props.cssClasses.noRefinementRoot,
                this.props.className,
              );
            return H("div", { className: d }, this.props.children, l, f, m, o);
          },
        },
      ]),
      n
    );
  })(Ce);
  rt(Fo, "defaultProps", Nd);
  function nr(e) {
    "@babel/helpers - typeof";
    return (
      (nr =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      nr(e)
    );
  }
  function Eo(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Je(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Eo(Object(n), !0).forEach(function (r) {
            To(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Eo(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function To(e, t, n) {
    return (
      (t = Cd(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Cd(e) {
    var t = Ad(e, "string");
    return nr(t) == "symbol" ? t : String(t);
  }
  function Ad(e, t) {
    if (nr(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (nr(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Dd = Oe({ name: "hits", connector: !0 });
  const Hd = function (t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : he;
    return (
      jt(t, Dd()),
      function (r) {
        var i = r || {},
          a = i.escapeHTML,
          o = a === void 0 ? !0 : a,
          s = i.transformItems,
          l =
            s === void 0
              ? function (d) {
                  return d;
                }
              : s,
          f,
          m;
        return {
          $$type: "ais.hits",
          init: function (p) {
            t(
              Je(
                Je({}, this.getWidgetRenderState(p)),
                {},
                { instantSearchInstance: p.instantSearchInstance },
              ),
              !0,
            );
          },
          render: function (p) {
            var u = this.getWidgetRenderState(p);
            (t(
              Je(
                Je({}, u),
                {},
                { instantSearchInstance: p.instantSearchInstance },
              ),
              !1,
            ),
              u.sendEvent("view:internal", u.items));
          },
          getRenderState: function (p, u) {
            return Je(Je({}, p), {}, { hits: this.getWidgetRenderState(u) });
          },
          getWidgetRenderState: function (p) {
            var u,
              c,
              g,
              v = p.results,
              h = p.helper,
              b = p.instantSearchInstance;
            if (
              (f ||
                (f = zu({
                  instantSearchInstance: b,
                  helper: h,
                  widgetType: this.$$type,
                })),
              m ||
                (m = Ju({
                  helper: h,
                  widgetType: this.$$type,
                  instantSearchInstance: b,
                })),
              !v)
            )
              return {
                hits: [],
                items: [],
                results: void 0,
                banner: void 0,
                sendEvent: f,
                bindEvent: m,
                widgetParams: r,
              };
            o && v.hits.length > 0 && (v.hits = ju(v.hits));
            var S = ac(v.hits, v.page, v.hitsPerPage),
              O = cc(S, v.queryID),
              _ = l(O, { results: v }),
              R =
                (u = v.renderingContent) === null ||
                u === void 0 ||
                (c = u.widgets) === null ||
                c === void 0 ||
                (g = c.banners) === null ||
                g === void 0
                  ? void 0
                  : g[0];
            return {
              hits: _,
              items: _,
              results: v,
              banner: R,
              sendEvent: f,
              bindEvent: m,
              widgetParams: r,
            };
          },
          dispose: function (p) {
            var u = p.state;
            return (
              n(),
              o
                ? u.setQueryParameters(
                    Object.keys(at).reduce(function (c, g) {
                      return Je(Je({}, c), {}, To({}, g, void 0));
                    }, {}),
                  )
                : u
            );
          },
          getWidgetSearchParameters: function (p, u) {
            return o ? p.setQueryParameters(at) : p;
          },
        };
      }
    );
  };
  function ir(e) {
    "@babel/helpers - typeof";
    return (
      (ir =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      ir(e)
    );
  }
  function Io(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function qr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Io(Object(n), !0).forEach(function (r) {
            Ld(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Io(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Ld(e, t, n) {
    return (
      (t = Md(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Md(e) {
    var t = Wd(e, "string");
    return ir(t) == "symbol" ? t : String(t);
  }
  function Wd(e, t) {
    if (ir(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (ir(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var qd = function (t, n) {
      return n.map(function (r) {
        var i = _r(t, function (a) {
          return a.objectID === r;
        });
        if (typeof i > "u")
          throw new Error(
            'Could not find objectID "'.concat(
              r,
              '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.',
            ),
          );
        return i;
      });
    },
    Ud = function (t) {
      var n = en(
        t.map(function (i) {
          return i.__queryID;
        }),
      );
      if (n.length > 1)
        throw new Error(
          "Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.",
        );
      var r = n[0];
      if (typeof r != "string")
        throw new Error(
          "Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7",
        );
      return r;
    },
    kd = function (t) {
      return t.map(function (n) {
        return n.__position;
      });
    },
    Qd = function (t) {
      var n = t.method,
        r = t.results,
        i = t.hits,
        a = t.objectIDs,
        o = r.index,
        s = qd(i, a),
        l = Ud(s);
      switch (n) {
        case "clickedObjectIDsAfterSearch": {
          var f = kd(s);
          return { index: o, queryID: l, objectIDs: a, positions: f };
        }
        case "convertedObjectIDsAfterSearch":
          return { index: o, queryID: l, objectIDs: a };
        default:
          throw new Error(
            'Unsupported method passed to insights: "'.concat(n, '".'),
          );
      }
    },
    Bd = function (t, n, r) {
      return function (i) {
        for (
          var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), s = 1;
          s < a;
          s++
        )
          o[s - 1] = arguments[s];
        var l = o[0];
        if (!t) {
          var f = Oe({ name: "instantsearch" });
          throw new Error(
            f(
              "The `insightsClient` option has not been provided to `instantsearch`.",
            ),
          );
        }
        if (!Array.isArray(l.objectIDs))
          throw new TypeError("Expected `objectIDs` to be an array.");
        var m = Qd({ method: i, results: n, hits: r, objectIDs: l.objectIDs });
        t(i, qr(qr({}, m), l));
      };
    };
  function Vd(e) {
    return function (t, n) {
      return e(function (r, i) {
        var a = r.results,
          o = r.hits,
          s = r.instantSearchInstance;
        if (a && o && s) {
          var l = Bd(s.insightsClient, a, o);
          return t(qr(qr({}, r), {}, { insights: l }), i);
        }
        return t(r, i);
      }, n);
    };
  }
  var Kd = function (t) {
    var n = t.insights,
      r = t.sendEvent;
    return function (i) {
      var a = No(i.target, i.currentTarget, function (d) {
        return d.hasAttribute("data-insights-event");
      });
      if (a) {
        var o = zd(a);
        o.forEach(function (d) {
          return r(d);
        });
      }
      var s = No(i.target, i.currentTarget, function (d) {
        return (
          d.hasAttribute("data-insights-method") &&
          d.hasAttribute("data-insights-payload")
        );
      });
      if (s) {
        var l = el(s),
          f = l.method,
          m = l.payload;
        n(f, m);
      }
    };
  };
  function No(e, t, n) {
    for (var r = e; r && !n(r); ) {
      if (r === t) return null;
      r = r.parentElement;
    }
    return r;
  }
  function zd(e) {
    var t = e.getAttribute("data-insights-event");
    if (typeof t != "string")
      throw new Error(
        "The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.",
      );
    try {
      return Bi(t);
    } catch {
      throw new Error(
        "The insights middleware was unable to parse `data-insights-event`.",
      );
    }
  }
  var Jd = {
    empty: function () {
      return "No results";
    },
    item: function (t) {
      return JSON.stringify(Wc(t, ["__hitIndex"]), null, 2);
    },
  };
  function ar(e) {
    "@babel/helpers - typeof";
    return (
      (ar =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      ar(e)
    );
  }
  var Gd = ["hit", "index"];
  function Co(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function vt(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Co(Object(n), !0).forEach(function (r) {
            Yd(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Co(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Yd(e, t, n) {
    return (
      (t = Xd(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Xd(e) {
    var t = Zd(e, "string");
    return ar(t) == "symbol" ? t : String(t);
  }
  function Zd(e, t) {
    if (ar(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (ar(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function ep(e, t) {
    if (e == null) return {};
    var n = tp(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function tp(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  function rp(e) {
    if (e == null) throw new TypeError("Cannot destructure " + e);
  }
  function yt() {
    return (
      (yt = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      yt.apply(this, arguments)
    );
  }
  var np = Oe({ name: "hits" }),
    ip = Lf({ createElement: H }),
    ap = function (t) {
      var n = t.renderState,
        r = t.cssClasses,
        i = t.containerNode,
        a = t.templates;
      return function (o, s) {
        var l = o.items,
          f = o.results,
          m = o.instantSearchInstance,
          d = o.insights,
          p = o.bindEvent,
          u = o.sendEvent,
          c = o.banner;
        if (s) {
          n.templateProps = ai({
            defaultTemplates: Jd,
            templatesConfig: m.templatesConfig,
            templates: a,
          });
          return;
        }
        var g = Kd({ insights: d, sendEvent: u }),
          v = function (O) {
            var _ = yt({}, (rp(O), O));
            return H(
              $e,
              yt({}, n.templateProps, {
                rootProps: _,
                templateKey: "empty",
                data: f,
                rootTagName: "fragment",
              }),
            );
          },
          h = function (O) {
            var _ = O.hit,
              R = O.index,
              $ = ep(O, Gd);
            return H(
              $e,
              yt({}, n.templateProps, {
                templateKey: "item",
                rootTagName: "li",
                rootProps: vt(
                  vt({}, $),
                  {},
                  {
                    onClick: function (P) {
                      (g(P), $.onClick());
                    },
                    onAuxClick: function (P) {
                      (g(P), $.onAuxClick());
                    },
                  },
                ),
                data: vt(
                  vt({}, _),
                  {},
                  {
                    get __hitIndex() {
                      return R;
                    },
                  },
                ),
                bindEvent: p,
                sendEvent: u,
              }),
            );
          },
          b = function (O) {
            return H(
              $e,
              yt({}, n.templateProps, {
                templateKey: "banner",
                data: O,
                rootTagName: "fragment",
              }),
            );
          };
        Ve(
          H(ip, {
            hits: l,
            itemComponent: h,
            sendEvent: u,
            classNames: r,
            emptyComponent: v,
            banner: c,
            bannerComponent: a.banner ? b : void 0,
          }),
          i,
        );
      };
    };
  const sp = function (t) {
    var n = t || {},
      r = n.container,
      i = n.escapeHTML,
      a = n.transformItems,
      o = n.templates,
      s = o === void 0 ? {} : o,
      l = n.cssClasses,
      f = l === void 0 ? {} : l;
    if (!r) throw new Error(np("The `container` option is required."));
    var m = Et(r),
      d = ap({
        containerNode: m,
        cssClasses: f,
        renderState: {},
        templates: s,
      }),
      p = Vd(Hd)(d, function () {
        return Ve(null, m);
      });
    return vt(
      vt({}, p({ escapeHTML: i, transformItems: a })),
      {},
      { $$widgetType: "ais.hits" },
    );
  };
  function op(e) {
    function t(n) {
      return function (r) {
        sa(r) || (r.preventDefault(), e.setCurrentPage(n));
      };
    }
    return H(
      "div",
      {
        className: L(
          e.cssClasses.root,
          e.nbPages <= 1 && e.cssClasses.noRefinementRoot,
        ),
      },
      H(
        "ul",
        { className: e.cssClasses.list },
        e.showFirst &&
          H(sr, {
            ariaLabel: "First Page",
            className: e.cssClasses.firstPageItem,
            isDisabled: e.isFirstPage,
            templates: e.templates,
            templateKey: "first",
            pageNumber: 0,
            createURL: e.createURL,
            cssClasses: e.cssClasses,
            createClickHandler: t,
          }),
        e.showPrevious &&
          H(sr, {
            ariaLabel: "Previous Page",
            className: e.cssClasses.previousPageItem,
            isDisabled: e.isFirstPage,
            templates: e.templates,
            templateKey: "previous",
            pageNumber: e.currentPage - 1,
            createURL: e.createURL,
            cssClasses: e.cssClasses,
            createClickHandler: t,
          }),
        e.pages.map(function (n) {
          return H(sr, {
            key: n,
            ariaLabel: "Page ".concat(n + 1),
            className: e.cssClasses.pageItem,
            isSelected: n === e.currentPage,
            templates: e.templates,
            templateKey: "page",
            pageNumber: n,
            createURL: e.createURL,
            cssClasses: e.cssClasses,
            createClickHandler: t,
          });
        }),
        e.showNext &&
          H(sr, {
            ariaLabel: "Next Page",
            className: e.cssClasses.nextPageItem,
            isDisabled: e.isLastPage,
            templates: e.templates,
            templateKey: "next",
            pageNumber: e.currentPage + 1,
            createURL: e.createURL,
            cssClasses: e.cssClasses,
            createClickHandler: t,
          }),
        e.showLast &&
          H(sr, {
            ariaLabel: "Last Page, Page ".concat(e.nbPages),
            className: e.cssClasses.lastPageItem,
            isDisabled: e.isLastPage,
            templates: e.templates,
            templateKey: "last",
            pageNumber: e.nbPages - 1,
            createURL: e.createURL,
            cssClasses: e.cssClasses,
            createClickHandler: t,
          }),
      ),
    );
  }
  function sr(e) {
    var t = e.templates,
      n = e.templateKey,
      r = e.ariaLabel,
      i = e.pageNumber,
      a = e.className,
      o = e.isDisabled,
      s = o === void 0 ? !1 : o,
      l = e.isSelected,
      f = l === void 0 ? !1 : l,
      m = e.cssClasses,
      d = e.createURL,
      p = e.createClickHandler;
    return H(
      "li",
      { className: L(m.item, s && m.disabledItem, a, f && m.selectedItem) },
      s
        ? H($e, {
            rootTagName: "span",
            rootProps: { className: m.link, "aria-label": r },
            templateKey: n,
            templates: t,
            data: { page: i + 1 },
          })
        : H($e, {
            rootTagName: "a",
            rootProps: {
              className: m.link,
              "aria-label": r,
              href: d(i),
              onClick: p(i),
            },
            templateKey: n,
            templates: t,
            data: { page: i + 1 },
          }),
    );
  }
  function or(e) {
    "@babel/helpers - typeof";
    return (
      (or =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      or(e)
    );
  }
  function up(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function cp(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      ((r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, Ao(r.key), r));
    }
  }
  function lp(e, t, n) {
    return (
      t && cp(e.prototype, t),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      e
    );
  }
  function Ri(e, t, n) {
    return (
      (t = Ao(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Ao(e) {
    var t = fp(e, "string");
    return or(t) == "symbol" ? t : String(t);
  }
  function fp(e, t) {
    if (or(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (or(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var hp = (function () {
    function e(t) {
      (up(this, e),
        Ri(this, "currentPage", void 0),
        Ri(this, "total", void 0),
        Ri(this, "padding", void 0),
        (this.currentPage = t.currentPage),
        (this.total = t.total),
        (this.padding = t.padding));
    }
    return (
      lp(e, [
        {
          key: "pages",
          value: function () {
            var n = this.total,
              r = this.currentPage,
              i = this.padding;
            if (n === 0) return [0];
            var a = this.nbPagesDisplayed(i, n);
            if (a === n) return wr({ end: n });
            var o = this.calculatePaddingLeft(r, i, n, a),
              s = a - o,
              l = r - o,
              f = r + s;
            return wr({ start: l, end: f });
          },
        },
        {
          key: "nbPagesDisplayed",
          value: function (n, r) {
            return Math.min(2 * n + 1, r);
          },
        },
        {
          key: "calculatePaddingLeft",
          value: function (n, r, i, a) {
            return n <= r ? n : n >= i - r ? a - (i - n) : r;
          },
        },
        {
          key: "isLastPage",
          value: function () {
            return this.currentPage >= this.total - 1;
          },
        },
        {
          key: "isFirstPage",
          value: function () {
            return this.currentPage <= 0;
          },
        },
      ]),
      e
    );
  })();
  function ur(e) {
    "@babel/helpers - typeof";
    return (
      (ur =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      ur(e)
    );
  }
  function Do(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Ae(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Do(Object(n), !0).forEach(function (r) {
            dp(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Do(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function dp(e, t, n) {
    return (
      (t = pp(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function pp(e) {
    var t = mp(e, "string");
    return ur(t) == "symbol" ? t : String(t);
  }
  function mp(e, t) {
    if (ur(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (ur(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var gp = Oe({ name: "pagination", connector: !0 }),
    vp = function (t) {
      var n =
        arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : he;
      return (
        jt(t, gp()),
        function (r) {
          var i = r || {},
            a = i.totalPages,
            o = i.padding,
            s = o === void 0 ? 3 : o,
            l = new hp({ currentPage: 0, total: 0, padding: s }),
            f = {};
          function m(d) {
            var p = d.nbPages;
            return a !== void 0 ? Math.min(a, p) : p;
          }
          return {
            $$type: "ais.pagination",
            init: function (p) {
              var u = p.instantSearchInstance;
              t(
                Ae(
                  Ae({}, this.getWidgetRenderState(p)),
                  {},
                  { instantSearchInstance: u },
                ),
                !0,
              );
            },
            render: function (p) {
              var u = p.instantSearchInstance;
              t(
                Ae(
                  Ae({}, this.getWidgetRenderState(p)),
                  {},
                  { instantSearchInstance: u },
                ),
                !1,
              );
            },
            dispose: function (p) {
              var u = p.state;
              return (n(), u.setQueryParameter("page", void 0));
            },
            getWidgetUiState: function (p, u) {
              var c = u.searchParameters,
                g = c.page || 0;
              return g ? Ae(Ae({}, p), {}, { page: g + 1 }) : p;
            },
            getWidgetSearchParameters: function (p, u) {
              var c = u.uiState,
                g = c.page ? c.page - 1 : 0;
              return p.setQueryParameter("page", g);
            },
            getWidgetRenderState: function (p) {
              var u = p.results,
                c = p.helper,
                g = p.state,
                v = p.createURL;
              (f.refine ||
                (f.refine = function (S) {
                  (c.setPage(S), c.search());
                }),
                f.createURL ||
                  (f.createURL = function (S) {
                    return v(function (O) {
                      return Ae(Ae({}, O), {}, { page: S + 1 });
                    });
                  }));
              var h = g.page || 0,
                b = m(u || { nbPages: 0 });
              return (
                (l.currentPage = h),
                (l.total = b),
                {
                  createURL: f.createURL,
                  refine: f.refine,
                  canRefine: b > 1,
                  currentRefinement: h,
                  nbHits: (u == null ? void 0 : u.nbHits) || 0,
                  nbPages: b,
                  pages: u ? l.pages() : [],
                  isFirstPage: l.isFirstPage(),
                  isLastPage: l.isLastPage(),
                  widgetParams: r,
                }
              );
            },
            getRenderState: function (p, u) {
              return Ae(
                Ae({}, p),
                {},
                { pagination: this.getWidgetRenderState(u) },
              );
            },
          };
        }
      );
    };
  function cr(e) {
    "@babel/helpers - typeof";
    return (
      (cr =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      cr(e)
    );
  }
  function Ho(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Ur(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Ho(Object(n), !0).forEach(function (r) {
            yp(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Ho(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function yp(e, t, n) {
    return (
      (t = bp(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function bp(e) {
    var t = Sp(e, "string");
    return cr(t) == "symbol" ? t : String(t);
  }
  function Sp(e, t) {
    if (cr(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (cr(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var xe = Qe("Pagination"),
    Pp = Oe({ name: "pagination" }),
    _p = {
      previous: function () {
        return "‹";
      },
      next: function () {
        return "›";
      },
      page: function (t) {
        var n = t.page;
        return "".concat(n);
      },
      first: function () {
        return "«";
      },
      last: function () {
        return "»";
      },
    },
    Op = function (t) {
      var n = t.containerNode,
        r = t.cssClasses,
        i = t.templates,
        a = t.showFirst,
        o = t.showLast,
        s = t.showPrevious,
        l = t.showNext,
        f = t.scrollToNode;
      return function (m, d) {
        var p = m.createURL,
          u = m.currentRefinement,
          c = m.nbPages,
          g = m.pages,
          v = m.isFirstPage,
          h = m.isLastPage,
          b = m.refine;
        if (!d) {
          var S = function (_) {
            (b(_), f !== !1 && f.scrollIntoView());
          };
          Ve(
            H(op, {
              createURL: p,
              cssClasses: r,
              currentPage: u,
              templates: i,
              nbPages: c,
              pages: g,
              isFirstPage: v,
              isLastPage: h,
              setCurrentPage: S,
              showFirst: a,
              showLast: o,
              showPrevious: s,
              showNext: l,
            }),
            n,
          );
        }
      };
    },
    wp = function (t) {
      var n = t || {},
        r = n.container,
        i = n.templates,
        a = i === void 0 ? {} : i,
        o = n.cssClasses,
        s = o === void 0 ? {} : o,
        l = n.totalPages,
        f = n.padding,
        m = n.showFirst,
        d = m === void 0 ? !0 : m,
        p = n.showLast,
        u = p === void 0 ? !0 : p,
        c = n.showPrevious,
        g = c === void 0 ? !0 : c,
        v = n.showNext,
        h = v === void 0 ? !0 : v,
        b = n.scrollTo,
        S = b === void 0 ? "body" : b;
      if (!r) throw new Error(Pp("The `container` option is required."));
      var O = Et(r),
        _ = S === !0 ? "body" : S,
        R = _ !== !1 ? Et(_) : !1,
        $ = {
          root: L(xe(), s.root),
          noRefinementRoot: L(
            xe({ modifierName: "noRefinement" }),
            s.noRefinementRoot,
          ),
          list: L(xe({ descendantName: "list" }), s.list),
          item: L(xe({ descendantName: "item" }), s.item),
          firstPageItem: L(
            xe({ descendantName: "item", modifierName: "firstPage" }),
            s.firstPageItem,
          ),
          lastPageItem: L(
            xe({ descendantName: "item", modifierName: "lastPage" }),
            s.lastPageItem,
          ),
          previousPageItem: L(
            xe({ descendantName: "item", modifierName: "previousPage" }),
            s.previousPageItem,
          ),
          nextPageItem: L(
            xe({ descendantName: "item", modifierName: "nextPage" }),
            s.nextPageItem,
          ),
          pageItem: L(
            xe({ descendantName: "item", modifierName: "page" }),
            s.pageItem,
          ),
          selectedItem: L(
            xe({ descendantName: "item", modifierName: "selected" }),
            s.selectedItem,
          ),
          disabledItem: L(
            xe({ descendantName: "item", modifierName: "disabled" }),
            s.disabledItem,
          ),
          link: L(xe({ descendantName: "link" }), s.link),
        },
        y = Ur(Ur({}, _p), a),
        P = Op({
          containerNode: O,
          cssClasses: $,
          templates: y,
          showFirst: d,
          showLast: u,
          showPrevious: g,
          showNext: h,
          scrollToNode: R,
        }),
        w = vp(P, function () {
          return Ve(null, O);
        });
      return Ur(
        Ur({}, w({ totalPages: l, padding: f })),
        {},
        { $$widgetType: "ais.pagination" },
      );
    };
  function lr(e) {
    "@babel/helpers - typeof";
    return (
      (lr =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      lr(e)
    );
  }
  function Lo(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function ye(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Lo(Object(n), !0).forEach(function (r) {
            kr(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Lo(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function kr(e, t, n) {
    return (
      (t = Rp(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Rp(e) {
    var t = jp(e, "string");
    return lr(t) == "symbol" ? t : String(t);
  }
  function jp(e, t) {
    if (lr(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (lr(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function bt(e, t) {
    return Ep(e) || Fp(e, t) || xp(e, t) || $p();
  }
  function $p() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function xp(e, t) {
    if (e) {
      if (typeof e == "string") return Mo(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return Mo(e, t);
    }
  }
  function Mo(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Fp(e, t) {
    var n =
      e == null
        ? null
        : (typeof Symbol < "u" && e[Symbol.iterator]) || e["@@iterator"];
    if (n != null) {
      var r,
        i,
        a,
        o,
        s = [],
        l = !0,
        f = !1;
      try {
        if (((a = (n = n.call(e)).next), t === 0)) {
          if (Object(n) !== n) return;
          l = !1;
        } else
          for (
            ;
            !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== t);
            l = !0
          );
      } catch (m) {
        ((f = !0), (i = m));
      } finally {
        try {
          if (!l && n.return != null && ((o = n.return()), Object(o) !== o))
            return;
        } finally {
          if (f) throw i;
        }
      }
      return s;
    }
  }
  function Ep(e) {
    if (Array.isArray(e)) return e;
  }
  var ji = Oe(
      { name: "range-input", connector: !0 },
      { name: "range-slider", connector: !0 },
    ),
    Tp = "ais.range";
  function Wo(e) {
    var t = e.min,
      n = e.max,
      r = e.precision,
      i = Math.pow(10, r);
    return { min: t && Math.floor(t * i) / i, max: n && Math.ceil(n * i) / i };
  }
  var qo = function (t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : he;
    return (
      jt(t, ji()),
      function (r) {
        var i = r || {},
          a = i.attribute,
          o = a === void 0 ? "" : a,
          s = i.min,
          l = i.max,
          f = i.precision,
          m = f === void 0 ? 0 : f;
        if (!o) throw new Error(ji("The `attribute` option is required."));
        if (ae(s) && ae(l) && s > l)
          throw new Error(ji("The `max` option can't be lower than `min`."));
        var d = function (S) {
            return Number(Number(S).toFixed(m));
          },
          p = {
            from: function (S) {
              return S.toLocaleString();
            },
            to: function (S) {
              return d(S).toLocaleString();
            },
          },
          u = function (S, O, _, R) {
            var $ = S.state,
              y = O.min,
              P = O.max,
              w = $.getNumericRefinement(o, ">=") || [],
              j = bt(w, 1),
              T = j[0],
              N = $.getNumericRefinement(o, "<=") || [],
              Q = bt(N, 1),
              W = Q[0],
              G = _ === void 0 || _ === "",
              B = R === void 0 || R === "",
              A = Wo({
                min: G ? void 0 : parseFloat(_),
                max: B ? void 0 : parseFloat(R),
                precision: m,
              }),
              C = A.min,
              q = A.max,
              M;
            !ae(s) && y === C ? (M = void 0) : ae(s) && G ? (M = s) : (M = C);
            var K;
            !ae(l) && P === q ? (K = void 0) : ae(l) && B ? (K = l) : (K = q);
            var Y = M === void 0,
              Z = ae(y) && y <= M,
              k = Y || (ae(M) && (!ae(y) || Z)),
              z = K === void 0,
              ee = ae(K) && P >= K,
              x = z || (ae(K) && (!ae(P) || ee)),
              F = T !== M,
              E = W !== K;
            return (F || E) && k && x
              ? (($ = $.removeNumericRefinement(o)),
                ae(M) && ($ = $.addNumericRefinement(o, ">=", M)),
                ae(K) && ($ = $.addNumericRefinement(o, "<=", K)),
                $.resetPage())
              : null;
          },
          c = function (S) {
            return function () {
              if (arguments.length === 1) {
                S.sendEventToInsights(
                  arguments.length <= 0 ? void 0 : arguments[0],
                );
                return;
              }
            };
          };
        function g(b) {
          var S;
          ae(s) ? (S = s) : ae(b.min) ? (S = b.min) : (S = 0);
          var O;
          return (
            ae(l) ? (O = l) : ae(b.max) ? (O = b.max) : (O = 0),
            Wo({ min: S, max: O, precision: m })
          );
        }
        function v(b) {
          var S = b.getNumericRefinement(o, ">=") || [],
            O = bt(S, 1),
            _ = O[0],
            R = b.getNumericRefinement(o, "<=") || [],
            $ = bt(R, 1),
            y = $[0],
            P = ae(_) ? _ : -1 / 0,
            w = ae(y) ? y : 1 / 0;
          return [P, w];
        }
        function h(b, S) {
          return function () {
            var O =
                arguments.length > 0 && arguments[0] !== void 0
                  ? arguments[0]
                  : [void 0, void 0],
              _ = bt(O, 2),
              R = _[0],
              $ = _[1],
              y = u(b, S, R, $);
            y && b.setState(y).search();
          };
        }
        return {
          $$type: Tp,
          init: function (S) {
            t(
              ye(
                ye({}, this.getWidgetRenderState(S)),
                {},
                { instantSearchInstance: S.instantSearchInstance },
              ),
              !0,
            );
          },
          render: function (S) {
            t(
              ye(
                ye({}, this.getWidgetRenderState(S)),
                {},
                { instantSearchInstance: S.instantSearchInstance },
              ),
              !1,
            );
          },
          getRenderState: function (S, O) {
            return ye(
              ye({}, S),
              {},
              {
                range: ye(
                  ye({}, S.range),
                  {},
                  kr({}, o, this.getWidgetRenderState(O)),
                ),
              },
            );
          },
          getWidgetRenderState: function (S) {
            var O = S.results,
              _ = S.helper,
              R = S.instantSearchInstance,
              $ = (O && O.disjunctiveFacets) || [],
              y = _r($, function (N) {
                return N.name === o;
              }),
              P = (y && y.stats) || { min: void 0, max: void 0 },
              w = g(P),
              j = v(_),
              T;
            return (
              O ? (T = h(_, w)) : (T = h(_, { min: void 0, max: void 0 })),
              {
                refine: T,
                canRefine: w.min !== w.max,
                format: p,
                range: w,
                sendEvent: c(R),
                widgetParams: ye(ye({}, r), {}, { precision: m }),
                start: j,
              }
            );
          },
          dispose: function (S) {
            var O = S.state;
            return (
              n(),
              O.removeDisjunctiveFacet(o).removeNumericRefinement(o)
            );
          },
          getWidgetUiState: function (S, O) {
            var _ = O.searchParameters,
              R = _.getNumericRefinements(o),
              $ = R[">="],
              y = $ === void 0 ? [] : $,
              P = R["<="],
              w = P === void 0 ? [] : P;
            return y.length === 0 && w.length === 0
              ? S
              : ye(
                  ye({}, S),
                  {},
                  {
                    range: ye(
                      ye({}, S.range),
                      {},
                      kr({}, o, "".concat(y, ":").concat(w)),
                    ),
                  },
                );
          },
          getWidgetSearchParameters: function (S, O) {
            var _ = O.uiState,
              R = S.addDisjunctiveFacet(o).setQueryParameters({
                numericRefinements: ye(
                  ye({}, S.numericRefinements),
                  {},
                  kr({}, o, {}),
                ),
              });
            (ae(s) && (R = R.addNumericRefinement(o, ">=", s)),
              ae(l) && (R = R.addNumericRefinement(o, "<=", l)));
            var $ = _.range && _.range[o];
            if (!$ || $.indexOf(":") === -1) return R;
            var y = $.split(":").map(parseFloat),
              P = bt(y, 2),
              w = P[0],
              j = P[1];
            return (
              ae(w) &&
                (!ae(s) || s < w) &&
                ((R = R.removeNumericRefinement(o, ">=")),
                (R = R.addNumericRefinement(o, ">=", w))),
              ae(j) &&
                (!ae(l) || j < l) &&
                ((R = R.removeNumericRefinement(o, "<=")),
                (R = R.addNumericRefinement(o, "<=", j))),
              R
            );
          },
        };
      }
    );
  };
  function fr(e) {
    "@babel/helpers - typeof";
    return (
      (fr =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      fr(e)
    );
  }
  function Uo(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function ko(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Uo(Object(n), !0).forEach(function (r) {
            Ip(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Uo(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Ip(e, t, n) {
    return (
      (t = Np(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Np(e) {
    var t = Cp(e, "string");
    return fr(t) == "symbol" ? t : String(t);
  }
  function Cp(e, t) {
    if (fr(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (fr(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Ap = function (t) {
    var n = t.style,
      r = t.children,
      i = Math.round(parseFloat(n.left)),
      a = [0, 50, 100].includes(i),
      o = r,
      s = Math.round(parseInt(o, 10) * 100) / 100;
    return H(
      "div",
      {
        style: ko(ko({}, n), {}, { marginLeft: i === 100 ? "-2px" : 0 }),
        className: L(
          "rheostat-marker",
          "rheostat-marker-horizontal",
          a && "rheostat-marker-large",
        ),
      },
      a && H("div", { className: "rheostat-value" }, s),
    );
  };
  function St(e) {
    "@babel/helpers - typeof";
    return (
      (St =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      St(e)
    );
  }
  function Dp(e, t, n) {
    return (Object.defineProperty(e, "prototype", { writable: !1 }), e);
  }
  function Hp(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Lp(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    ((e.prototype = Object.create(t && t.prototype, {
      constructor: { value: e, writable: !0, configurable: !0 },
    })),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      t && $i(e, t));
  }
  function $i(e, t) {
    return (
      ($i = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (r, i) {
            return ((r.__proto__ = i), r);
          }),
      $i(e, t)
    );
  }
  function Mp(e) {
    var t = qp();
    return function () {
      var r = Qr(e),
        i;
      if (t) {
        var a = Qr(this).constructor;
        i = Reflect.construct(r, arguments, a);
      } else i = r.apply(this, arguments);
      return Wp(this, i);
    };
  }
  function Wp(e, t) {
    if (t && (St(t) === "object" || typeof t == "function")) return t;
    if (t !== void 0)
      throw new TypeError(
        "Derived constructors may only return object or undefined",
      );
    return te(e);
  }
  function te(e) {
    if (e === void 0)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called",
      );
    return e;
  }
  function qp() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {}),
        ),
        !0
      );
    } catch {
      return !1;
    }
  }
  function Qr(e) {
    return (
      (Qr = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (n) {
            return n.__proto__ || Object.getPrototypeOf(n);
          }),
      Qr(e)
    );
  }
  function X(e, t, n) {
    return (
      (t = Up(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Up(e) {
    var t = kp(e, "string");
    return St(t) == "symbol" ? t : String(t);
  }
  function kp(e, t) {
    if (St(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (St(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function xi() {
    return (
      (xi = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      xi.apply(this, arguments)
    );
  }
  var We = {
      DOWN: 40,
      END: 35,
      ESC: 27,
      HOME: 36,
      LEFT: 37,
      PAGE_DOWN: 34,
      PAGE_UP: 33,
      RIGHT: 39,
      UP: 38,
    },
    hr = 0,
    qe = 100;
  function dr(e, t, n) {
    return ((e - t) / (n - t)) * 100;
  }
  function Qo(e, t, n) {
    var r = e / 100;
    return e === 0 ? t : e === 100 ? n : Math.round((n - t) * r + t);
  }
  function Bo(e) {
    var t =
      e.orientation === "vertical"
        ? "rheostat-vertical"
        : "rheostat-horizontal";
    return ["rheostat", t].concat(e.className.split(" ")).join(" ");
  }
  function Vo(e) {
    return Number(e.currentTarget.getAttribute("data-handle-key"));
  }
  function Pt(e) {
    (e.stopPropagation(), e.preventDefault());
  }
  function Qp(e) {
    return H("button", xi({}, e, { type: "button" }));
  }
  var Bp = H("div", { className: "rheostat-background" }),
    Ko = (function (e) {
      Lp(n, e);
      var t = Mp(n);
      function n() {
        var r;
        Hp(this, n);
        for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
          a[o] = arguments[o];
        return (
          (r = t.call.apply(t, [this].concat(a))),
          X(
            te(r),
            "x",
            [0, 0].map(function (s) {
              return s;
            }),
          ),
          X(te(r), "state", {
            className: Bo(r.props),
            handlePos: r.props.values.map(function (s) {
              return dr(s, r.props.min, r.props.max);
            }),
            handleDimensions: 0,
            mousePos: null,
            sliderBox: {},
            slidingIndex: null,
            values: r.props.values,
          }),
          X(te(r), "rheostat", Gt()),
          X(te(r), "componentWillReceiveProps", function (s) {
            var l = r.props,
              f = l.className,
              m = l.disabled,
              d = l.min,
              p = l.max,
              u = l.orientation,
              c = r.state,
              g = c.values,
              v = c.slidingIndex,
              h = s.min !== d || s.max !== p,
              b =
                g.length !== s.values.length ||
                g.some(function (_, R) {
                  return s.values[R] !== _;
                }),
              S = s.className !== f || s.orientation !== u,
              O = s.disabled && !m;
            (S && r.setState({ className: Bo(s) }),
              (h || b) && r.updateNewValues(s),
              O && v !== null && r.endSlide());
          }),
          X(te(r), "getPublicState", function () {
            var s = r.props,
              l = s.min,
              f = s.max,
              m = r.state.values;
            return { max: f, min: l, values: m };
          }),
          X(te(r), "getSliderBoundingBox", function () {
            var s = r.rheostat.current,
              l = s.getBoundingClientRect();
            return {
              height: l.height || s.clientHeight,
              left: l.left,
              top: l.top,
              width: l.width || s.clientWidth,
            };
          }),
          X(te(r), "getProgressStyle", function (s) {
            var l = r.state.handlePos,
              f = l[s];
            if (s === 0)
              return r.props.orientation === "vertical"
                ? { height: "".concat(f, "%"), top: 0 }
                : { left: 0, width: "".concat(f, "%") };
            var m = l[s - 1],
              d = f - m;
            return r.props.orientation === "vertical"
              ? { height: "".concat(d, "%"), top: "".concat(m, "%") }
              : { left: "".concat(m, "%"), width: "".concat(d, "%") };
          }),
          X(te(r), "getMinValue", function (s) {
            return r.state.values[s - 1]
              ? Math.max(r.props.min, r.state.values[s - 1])
              : r.props.min;
          }),
          X(te(r), "getMaxValue", function (s) {
            return r.state.values[s + 1]
              ? Math.min(r.props.max, r.state.values[s + 1])
              : r.props.max;
          }),
          X(te(r), "getHandleDimensions", function (s, l) {
            var f = s.currentTarget || null;
            return f
              ? r.props.orientation === "vertical"
                ? ((f.clientHeight / l.height) * qe) / 2
                : ((f.clientWidth / l.width) * qe) / 2
              : 0;
          }),
          X(te(r), "getClosestSnapPoint", function (s) {
            return r.props.snapPoints.length
              ? r.props.snapPoints.reduce(function (l, f) {
                  return Math.abs(l - s) < Math.abs(f - s) ? l : f;
                })
              : s;
          }),
          X(te(r), "getSnapPosition", function (s) {
            if (!r.props.snap) return s;
            var l = r.props,
              f = l.max,
              m = l.min,
              d = Qo(s, m, f),
              p = r.getClosestSnapPoint(d);
            return dr(p, m, f);
          }),
          X(te(r), "getNextPositionForKey", function (s, l) {
            var f,
              m = r.state,
              d = m.handlePos,
              p = m.values,
              u = r.props,
              c = u.max,
              g = u.min,
              v = u.snapPoints,
              h = r.props.snap,
              b = p[s],
              S = d[s],
              O = S,
              _ = 1;
            c >= 100 ? (S = Math.round(S)) : (_ = 100 / (c - g));
            var R = null;
            h && (R = v.indexOf(r.getClosestSnapPoint(p[s])));
            var $ =
              ((f = {}),
              X(f, We.LEFT, function (y) {
                return y * -1;
              }),
              X(f, We.RIGHT, function (y) {
                return y;
              }),
              X(f, We.UP, function (y) {
                return y;
              }),
              X(f, We.DOWN, function (y) {
                return y * -1;
              }),
              X(f, We.PAGE_DOWN, function (y) {
                return y > 1 ? -y : y * -10;
              }),
              X(f, We.PAGE_UP, function (y) {
                return y > 1 ? y : y * 10;
              }),
              f);
            if (Object.prototype.hasOwnProperty.call($, l))
              ((S += $[l](_)),
                h &&
                  R &&
                  (S > O
                    ? R < v.length - 1 && (b = v[R + 1])
                    : R > 0 && (b = v[R - 1])));
            else if (l === We.HOME) ((S = hr), h && (b = v[0]));
            else if (l === We.END) ((S = qe), h && (b = v[v.length - 1]));
            else return null;
            return h ? dr(b, g, c) : S;
          }),
          X(te(r), "getNextState", function (s, l) {
            var f = r.state.handlePos,
              m = r.props,
              d = m.max,
              p = m.min,
              u = r.validatePosition(s, l),
              c = f.map(function (g, v) {
                return v === s ? u : g;
              });
            return {
              handlePos: c,
              values: c.map(function (g) {
                return Qo(g, p, d);
              }),
            };
          }),
          X(te(r), "getClosestHandle", function (s) {
            var l = r.state.handlePos;
            return l.reduce(function (f, m, d) {
              var p = Math.abs(l[d] - s),
                u = Math.abs(l[f] - s);
              return p < u ? d : f;
            }, 0);
          }),
          X(te(r), "setStartSlide", function (s, l, f) {
            var m = r.getSliderBoundingBox();
            r.setState({
              handleDimensions: r.getHandleDimensions(s, m),
              mousePos: { x: l, y: f },
              sliderBox: m,
              slidingIndex: Vo(s),
            });
          }),
          X(te(r), "startMouseSlide", function (s) {
            (r.setStartSlide(s, s.clientX, s.clientY),
              document.addEventListener("mousemove", r.handleMouseSlide, !1),
              document.addEventListener("mouseup", r.endSlide, !1),
              Pt(s));
          }),
          X(te(r), "startTouchSlide", function (s) {
            if (!(s.changedTouches.length > 1)) {
              var l = s.changedTouches[0];
              (r.setStartSlide(s, l.clientX, l.clientY),
                document.addEventListener("touchmove", r.handleTouchSlide, !1),
                document.addEventListener("touchend", r.endSlide, !1),
                r.props.onSliderDragStart && r.props.onSliderDragStart(),
                Pt(s));
            }
          }),
          X(te(r), "handleMouseSlide", function (s) {
            r.state.slidingIndex !== null &&
              (r.handleSlide(s.clientX, s.clientY), Pt(s));
          }),
          X(te(r), "handleTouchSlide", function (s) {
            if (r.state.slidingIndex !== null) {
              if (s.changedTouches.length > 1) {
                r.endSlide();
                return;
              }
              var l = s.changedTouches[0];
              (r.handleSlide(l.clientX, l.clientY), Pt(s));
            }
          }),
          X(te(r), "handleSlide", function (s, l) {
            var f = r.state,
              m = f.slidingIndex,
              d = f.sliderBox,
              p =
                r.props.orientation === "vertical"
                  ? ((l - d.top) / d.height) * qe
                  : ((s - d.left) / d.width) * qe;
            (r.slideTo(m, p),
              r.canMove(m, p) &&
                (r.setState({ mousePos: { x: s, y: l } }),
                r.props.onSliderDragMove && r.props.onSliderDragMove()));
          }),
          X(te(r), "endSlide", function () {
            var s = r.state.slidingIndex;
            if (
              (r.setState({ slidingIndex: null }),
              document.removeEventListener("mouseup", r.endSlide, !1),
              document.removeEventListener("touchend", r.endSlide, !1),
              document.removeEventListener("touchmove", r.handleTouchSlide, !1),
              document.removeEventListener("mousemove", r.handleMouseSlide, !1),
              r.props.onSliderDragEnd && r.props.onSliderDragEnd(),
              r.props.snap)
            ) {
              var l = r.getSnapPosition(r.state.handlePos[s]);
              r.slideTo(s, l, function () {
                return r.fireChangeEvent();
              });
            } else r.fireChangeEvent();
          }),
          X(te(r), "handleClick", function (s) {
            if (!s.target.getAttribute("data-handle-key")) {
              var l = r.getSliderBoundingBox(),
                f =
                  r.props.orientation === "vertical"
                    ? (s.clientY - l.top) / l.height
                    : (s.clientX - l.left) / l.width,
                m = f * qe,
                d = r.getClosestHandle(m),
                p = r.getSnapPosition(m);
              (r.slideTo(d, p, function () {
                return r.fireChangeEvent();
              }),
                r.props.onClick && r.props.onClick());
            }
          }),
          X(te(r), "handleKeydown", function (s) {
            var l = Vo(s);
            if (s.keyCode === We.ESC) {
              s.currentTarget.blur();
              return;
            }
            var f = r.getNextPositionForKey(l, s.keyCode);
            f !== null &&
              (r.canMove(l, f) &&
                (r.slideTo(l, f, function () {
                  return r.fireChangeEvent();
                }),
                r.props.onKeyPress && r.props.onKeyPress()),
              Pt(s));
          }),
          X(te(r), "validatePosition", function (s, l) {
            var f = r.state,
              m = f.handlePos,
              d = f.handleDimensions;
            return Math.max(
              Math.min(l, m[s + 1] !== void 0 ? m[s + 1] - d : qe),
              m[s - 1] !== void 0 ? m[s - 1] + d : hr,
            );
          }),
          X(te(r), "validateValues", function (s, l) {
            var f = l || r.props,
              m = f.max,
              d = f.min;
            return s.map(function (p, u, c) {
              var g = Math.max(Math.min(p, m), d);
              return c.length && g < c[u - 1] ? c[u - 1] : g;
            });
          }),
          X(te(r), "canMove", function (s, l) {
            var f = r.state,
              m = f.handlePos,
              d = f.handleDimensions;
            if (l < hr || l > qe) return !1;
            var p = m[s + 1] !== void 0 ? m[s + 1] - d : 1 / 0;
            if (l > p) return !1;
            var u = m[s - 1] !== void 0 ? m[s - 1] + d : -1 / 0;
            return !(l < u);
          }),
          X(te(r), "fireChangeEvent", function () {
            var s = r.props.onChange;
            s && s(r.getPublicState());
          }),
          X(te(r), "slideTo", function (s, l, f) {
            var m = r.getNextState(s, l);
            r.setState(m, function () {
              var d = r.props.onValuesUpdated;
              (d && d(r.getPublicState()), f && f());
            });
          }),
          X(te(r), "updateNewValues", function (s) {
            var l = r.state.slidingIndex;
            if (l === null) {
              var f = s.max,
                m = s.min,
                d = s.values,
                p = r.validateValues(d, s);
              r.setState(
                {
                  handlePos: p.map(function (u) {
                    return dr(u, m, f);
                  }),
                  values: p,
                },
                function () {
                  return r.fireChangeEvent();
                },
              );
            }
          }),
          X(te(r), "render", function () {
            var s = r.props,
              l = s.children,
              f = s.disabled,
              m = s.handle,
              d = s.max,
              p = s.min,
              u = s.orientation,
              c = s.pitComponent,
              g = s.pitPoints,
              v = s.progressBar,
              h = r.state,
              b = h.className,
              S = h.handlePos,
              O = h.values;
            return H(
              "div",
              {
                className: b,
                ref: r.rheostat,
                onClick: f ? void 0 : r.handleClick,
                style: { position: "relative" },
              },
              Bp,
              S.map(function (_, R) {
                var $ =
                  u === "vertical"
                    ? { top: "".concat(_, "%"), position: "absolute" }
                    : { left: "".concat(_, "%"), position: "absolute" };
                return H(m, {
                  "aria-valuemax": r.getMaxValue(R),
                  "aria-valuemin": r.getMinValue(R),
                  "aria-valuenow": O[R],
                  "aria-disabled": f,
                  "data-handle-key": R,
                  className: "rheostat-handle",
                  key: "handle-".concat(R),
                  onClick: Pt,
                  onKeyDown: f ? void 0 : r.handleKeydown,
                  onMouseDown: f ? void 0 : r.startMouseSlide,
                  onTouchStart: f ? void 0 : r.startTouchSlide,
                  role: "slider",
                  style: $,
                  tabIndex: 0,
                });
              }),
              S.map(function (_, R, $) {
                return R === 0 && $.length > 1
                  ? null
                  : H(v, {
                      className: "rheostat-progress",
                      key: "progress-bar-".concat(R),
                      style: r.getProgressStyle(R),
                    });
              }),
              c &&
                g.map(function (_) {
                  var R = dr(_, p, d),
                    $ =
                      u === "vertical"
                        ? { top: "".concat(R, "%"), position: "absolute" }
                        : { left: "".concat(R, "%"), position: "absolute" };
                  return H(c, { key: "pit-".concat(_), style: $ }, _);
                }),
              l,
            );
          }),
          r
        );
      }
      return Dp(n);
    })(Ce);
  X(Ko, "defaultProps", {
    className: "",
    children: null,
    disabled: !1,
    handle: Qp,
    max: qe,
    min: hr,
    onClick: null,
    onChange: null,
    onKeyPress: null,
    onSliderDragEnd: null,
    onSliderDragMove: null,
    onSliderDragStart: null,
    onValuesUpdated: null,
    orientation: "horizontal",
    pitComponent: null,
    pitPoints: [],
    progressBar: "div",
    snap: !1,
    snapPoints: [],
    values: [hr],
  });
  function zo(e) {
    return Jp(e) || zp(e) || Kp(e) || Vp();
  }
  function Vp() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Kp(e, t) {
    if (e) {
      if (typeof e == "string") return Fi(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return Fi(e, t);
    }
  }
  function zp(e) {
    if (
      (typeof Symbol < "u" && e[Symbol.iterator] != null) ||
      e["@@iterator"] != null
    )
      return Array.from(e);
  }
  function Jp(e) {
    if (Array.isArray(e)) return Fi(e);
  }
  function Fi(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Ei() {
    return (
      (Ei = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      Ei.apply(this, arguments)
    );
  }
  function nt(e) {
    "@babel/helpers - typeof";
    return (
      (nt =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      nt(e)
    );
  }
  function Gp(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Yp(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      ((r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, Go(r.key), r));
    }
  }
  function Xp(e, t, n) {
    return (
      t && Yp(e.prototype, t),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      e
    );
  }
  function Zp(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    ((e.prototype = Object.create(t && t.prototype, {
      constructor: { value: e, writable: !0, configurable: !0 },
    })),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      t && Ti(e, t));
  }
  function Ti(e, t) {
    return (
      (Ti = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (r, i) {
            return ((r.__proto__ = i), r);
          }),
      Ti(e, t)
    );
  }
  function em(e) {
    var t = rm();
    return function () {
      var r = Br(e),
        i;
      if (t) {
        var a = Br(this).constructor;
        i = Reflect.construct(r, arguments, a);
      } else i = r.apply(this, arguments);
      return tm(this, i);
    };
  }
  function tm(e, t) {
    if (t && (nt(t) === "object" || typeof t == "function")) return t;
    if (t !== void 0)
      throw new TypeError(
        "Derived constructors may only return object or undefined",
      );
    return Ii(e);
  }
  function Ii(e) {
    if (e === void 0)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called",
      );
    return e;
  }
  function rm() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {}),
        ),
        !0
      );
    } catch {
      return !1;
    }
  }
  function Br(e) {
    return (
      (Br = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (n) {
            return n.__proto__ || Object.getPrototypeOf(n);
          }),
      Br(e)
    );
  }
  function Jo(e, t, n) {
    return (
      (t = Go(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Go(e) {
    var t = nm(e, "string");
    return nt(t) == "symbol" ? t : String(t);
  }
  function nm(e, t) {
    if (nt(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (nt(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var im = (function (e) {
    Zp(n, e);
    var t = em(n);
    function n() {
      var r;
      Gp(this, n);
      for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
        a[o] = arguments[o];
      return (
        (r = t.call.apply(t, [this].concat(a))),
        Jo(Ii(r), "handleChange", function (s) {
          var l = s.values;
          r.isDisabled || r.props.refine(l);
        }),
        Jo(Ii(r), "createHandleComponent", function (s) {
          return function (l) {
            var f = Math.round(parseFloat(l["aria-valuenow"]) * 100) / 100,
              m = nt(s) === "object" && s.format ? s.format(f) : f,
              d = L(
                l.className,
                l["data-handle-key"] === 0 && "rheostat-handle-lower",
                l["data-handle-key"] === 1 && "rheostat-handle-upper",
              ),
              p =
                l["data-handle-key"] === 0
                  ? "Minimum Filter Handle"
                  : "Maximum Filter Handle";
            return H(
              "div",
              Ei({}, l, { className: d, "aria-label": p }),
              s && H("div", { className: "rheostat-tooltip" }, m),
            );
          };
        }),
        r
      );
    }
    return (
      Xp(n, [
        {
          key: "isDisabled",
          get: function () {
            return this.props.min >= this.props.max;
          },
        },
        {
          key: "computeDefaultPitPoints",
          value: function (i) {
            var a = i.min,
              o = i.max,
              s = o - a,
              l = 34,
              f = s / l,
              m = [a].concat(
                zo(
                  wr({ end: l - 1 }).map(function (d) {
                    return a + f * (d + 1);
                  }),
                ),
                [o],
              );
            return m;
          },
        },
        {
          key: "computeSnapPoints",
          value: function (i) {
            var a = i.min,
              o = i.max,
              s = i.step;
            if (s) return [].concat(zo(wr({ start: a, end: o, step: s })), [o]);
          },
        },
        {
          key: "render",
          value: function () {
            var i = this.props,
              a = i.tooltips,
              o = i.step,
              s = i.pips,
              l = i.values,
              f = i.cssClasses,
              m = this.isDisabled
                ? { min: this.props.min, max: this.props.max + 0.001 }
                : this.props,
              d = m.min,
              p = m.max,
              u = this.computeSnapPoints({ min: d, max: p, step: o }),
              c =
                s === !1
                  ? []
                  : this.computeDefaultPitPoints({ min: d, max: p });
            return H(
              "div",
              { className: L(f.root, this.isDisabled && f.disabledRoot) },
              H(Ko, {
                handle: this.createHandleComponent(a),
                onChange: this.handleChange,
                min: d,
                max: p,
                pitComponent: Ap,
                pitPoints: c,
                snap: !0,
                snapPoints: u,
                values: this.isDisabled ? [d, p] : l,
                disabled: this.isDisabled,
              }),
            );
          },
        },
      ]),
      n
    );
  })(Ce);
  function pr(e) {
    "@babel/helpers - typeof";
    return (
      (pr =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      pr(e)
    );
  }
  function Yo(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Xo(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? Yo(Object(n), !0).forEach(function (r) {
            am(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Yo(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function am(e, t, n) {
    return (
      (t = sm(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function sm(e) {
    var t = om(e, "string");
    return pr(t) == "symbol" ? t : String(t);
  }
  function om(e, t) {
    if (pr(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (pr(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function um(e, t) {
    return hm(e) || fm(e, t) || lm(e, t) || cm();
  }
  function cm() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function lm(e, t) {
    if (e) {
      if (typeof e == "string") return Zo(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (n === "Object" && e.constructor && (n = e.constructor.name),
        n === "Map" || n === "Set")
      )
        return Array.from(e);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return Zo(e, t);
    }
  }
  function Zo(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function fm(e, t) {
    var n =
      e == null
        ? null
        : (typeof Symbol < "u" && e[Symbol.iterator]) || e["@@iterator"];
    if (n != null) {
      var r,
        i,
        a,
        o,
        s = [],
        l = !0,
        f = !1;
      try {
        if (((a = (n = n.call(e)).next), t !== 0))
          for (
            ;
            !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== t);
            l = !0
          );
      } catch (m) {
        ((f = !0), (i = m));
      } finally {
        try {
          if (!l && n.return != null && ((o = n.return()), Object(o) !== o))
            return;
        } finally {
          if (f) throw i;
        }
      }
      return s;
    }
  }
  function hm(e) {
    if (Array.isArray(e)) return e;
  }
  var dm = Oe({ name: "range-slider" }),
    eu = Qe("RangeSlider"),
    pm = function (t) {
      var n = t.containerNode,
        r = t.cssClasses,
        i = t.pips,
        a = t.step,
        o = t.tooltips;
      return function (s, l) {
        var f = s.refine,
          m = s.range,
          d = s.start;
        if (!l) {
          var p = m.min,
            u = m.max,
            c = um(d, 2),
            g = c[0],
            v = c[1],
            h = g === -1 / 0 ? p : g,
            b = v === 1 / 0 ? u : v,
            S = [h > u ? u : h, b < p ? p : b];
          Ve(
            H(im, {
              cssClasses: r,
              refine: f,
              min: p,
              max: u,
              values: S,
              tooltips: o,
              step: a,
              pips: i,
            }),
            n,
          );
        }
      };
    },
    mm = function (t) {
      var n = t || {},
        r = n.container,
        i = n.attribute,
        a = n.min,
        o = n.max,
        s = n.cssClasses,
        l = s === void 0 ? {} : s,
        f = n.step,
        m = n.pips,
        d = m === void 0 ? !0 : m,
        p = n.precision,
        u = p === void 0 ? 0 : p,
        c = n.tooltips,
        g = c === void 0 ? !0 : c;
      if (!r) throw new Error(dm("The `container` option is required."));
      var v = Et(r),
        h = {
          root: L(eu(), l.root),
          disabledRoot: L(eu({ modifierName: "disabled" }), l.disabledRoot),
        },
        b = pm({
          containerNode: v,
          step: f,
          pips: d,
          tooltips: g,
          cssClasses: h,
        }),
        S = qo(b, function () {
          return Ve(null, v);
        });
      return Xo(
        Xo({}, S({ attribute: i, min: a, max: o, precision: u })),
        {},
        { $$type: "ais.rangeSlider", $$widgetType: "ais.rangeSlider" },
      );
    };
  function mr(e) {
    "@babel/helpers - typeof";
    return (
      (mr =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      mr(e)
    );
  }
  var gm = ["name", "escapedValue"],
    vm = ["escapedValue", "value"];
  function tu(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function se(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? tu(Object(n), !0).forEach(function (r) {
            gr(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : tu(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function gr(e, t, n) {
    return (
      (t = ym(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function ym(e) {
    var t = bm(e, "string");
    return mr(t) == "symbol" ? t : String(t);
  }
  function bm(e, t) {
    if (mr(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (mr(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function ru(e, t) {
    if (e == null) return {};
    var n = Sm(e, t),
      r,
      i;
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        ((r = a[i]),
          !(t.indexOf(r) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(e, r) &&
            (n[r] = e[r]));
    }
    return n;
  }
  function Sm(e, t) {
    if (e == null) return {};
    var n = {},
      r = Object.keys(e),
      i,
      a;
    for (a = 0; a < r.length; a++)
      ((i = r[a]), !(t.indexOf(i) >= 0) && (n[i] = e[i]));
    return n;
  }
  var Vr = Oe({ name: "refinement-list", connector: !0 }),
    nu = ["isRefined", "count:desc", "name:asc"],
    Pm = function (t) {
      var n =
        arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : he;
      return (
        jt(t, Vr()),
        function (r) {
          var i = r || {},
            a = i.attribute,
            o = i.operator,
            s = o === void 0 ? "or" : o,
            l = i.limit,
            f = l === void 0 ? 10 : l,
            m = i.showMore,
            d = m === void 0 ? !1 : m,
            p = i.showMoreLimit,
            u = p === void 0 ? 20 : p,
            c = i.sortBy,
            g = c === void 0 ? nu : c,
            v = i.escapeFacetValues,
            h = v === void 0 ? !0 : v,
            b = i.transformItems,
            S =
              b === void 0
                ? function (B) {
                    return B;
                  }
                : b;
          if (!a) throw new Error(Vr("The `attribute` option is required."));
          if (!/^(and|or)$/.test(s))
            throw new Error(
              Vr(
                'The `operator` must one of: `"and"`, `"or"` (got "'.concat(
                  s,
                  '").',
                ),
              ),
            );
          if (d === !0 && u <= f)
            throw new Error(
              Vr("`showMoreLimit` should be greater than `limit`."),
            );
          var O = function (A) {
              var C = A.name,
                q = A.escapedValue,
                M = ru(A, gm);
              return se(se({}, M), {}, { value: q, label: C, highlighted: C });
            },
            _,
            R = [],
            $ = !0,
            y,
            P,
            w = !1,
            j = function () {};
          function T() {
            j();
          }
          function N(B, A) {
            return function () {
              ((w = !w), A.render(B));
            };
          }
          function Q() {
            return w ? u : f;
          }
          var W = function () {
              return function () {};
            },
            G = function (A, C) {
              return function (q) {
                return function (M) {
                  var K = q.instantSearchInstance,
                    Y = q.results;
                  if (M === "" && R)
                    t(
                      se(
                        se(
                          {},
                          C.getWidgetRenderState(
                            se(se({}, q), {}, { results: _ }),
                          ),
                        ),
                        {},
                        { instantSearchInstance: K },
                      ),
                      !1,
                    );
                  else {
                    var Z = {
                      highlightPreTag: h
                        ? at.highlightPreTag
                        : ve.highlightPreTag,
                      highlightPostTag: h
                        ? at.highlightPostTag
                        : ve.highlightPostTag,
                    };
                    A.searchForFacetValues(a, M, Math.min(Q(), 100), Z).then(
                      function (k) {
                        var z = h ? $u(k.facetHits) : k.facetHits,
                          ee = S(
                            z.map(function (x) {
                              var F = x.escapedValue,
                                E = x.value,
                                I = ru(x, vm);
                              return se(se({}, I), {}, { value: F, label: E });
                            }),
                            { results: Y },
                          );
                        t(
                          se(
                            se(
                              {},
                              C.getWidgetRenderState(
                                se(se({}, q), {}, { results: _ }),
                              ),
                            ),
                            {},
                            {
                              items: ee,
                              canToggleShowMore: !1,
                              canRefine: !0,
                              isFromSearch: !0,
                              instantSearchInstance: K,
                            },
                          ),
                          !1,
                        );
                      },
                    );
                  }
                };
              };
            };
          return {
            $$type: "ais.refinementList",
            init: function (A) {
              t(
                se(
                  se({}, this.getWidgetRenderState(A)),
                  {},
                  { instantSearchInstance: A.instantSearchInstance },
                ),
                !0,
              );
            },
            render: function (A) {
              t(
                se(
                  se({}, this.getWidgetRenderState(A)),
                  {},
                  { instantSearchInstance: A.instantSearchInstance },
                ),
                !1,
              );
            },
            getRenderState: function (A, C) {
              return se(
                se({}, A),
                {},
                {
                  refinementList: se(
                    se({}, A.refinementList),
                    {},
                    gr({}, a, this.getWidgetRenderState(C)),
                  ),
                },
              );
            },
            getWidgetRenderState: function (A) {
              var C = this,
                q = A.results,
                M = A.state,
                K = A.createURL,
                Y = A.instantSearchInstance,
                Z = A.helper,
                k = [],
                z = [];
              if (
                ((!P || !y || !W) &&
                  ((P = Lu({
                    instantSearchInstance: Y,
                    helper: Z,
                    attribute: a,
                    widgetType: this.$$type,
                  })),
                  (y = function (U) {
                    (P("click:internal", U),
                      Z.toggleFacetRefinement(a, U).search());
                  }),
                  (W = G(Z, this))),
                q)
              ) {
                var ee = q.getFacetValues(a, {
                  sortBy: g,
                  facetOrdering: g === nu,
                });
                ((z = ee && Array.isArray(ee) ? ee : []),
                  (k = S(z.slice(0, Q()).map(O), { results: q })));
                var x = M.maxValuesPerFacet,
                  F = Q();
                (($ = x > F ? z.length <= F : z.length < F),
                  (_ = q),
                  (R = k),
                  A.results && (j = N(A, this)));
              }
              var E = W && W(A),
                I = w && R.length > f,
                D = d && !$,
                V = I || D;
              return {
                createURL: function (U) {
                  return K(function (ie) {
                    return C.getWidgetUiState(ie, {
                      searchParameters: M.resetPage().toggleFacetRefinement(
                        a,
                        U,
                      ),
                      helper: Z,
                    });
                  });
                },
                items: k,
                refine: y,
                searchForItems: E,
                isFromSearch: !1,
                canRefine: k.length > 0,
                widgetParams: r,
                isShowingMore: w,
                canToggleShowMore: V,
                toggleShowMore: T,
                sendEvent: P,
                hasExhaustiveItems: $,
              };
            },
            dispose: function (A) {
              var C = A.state;
              n();
              var q = C.setQueryParameter("maxValuesPerFacet", void 0);
              return s === "and"
                ? q.removeFacet(a)
                : q.removeDisjunctiveFacet(a);
            },
            getWidgetUiState: function (A, C) {
              var q = C.searchParameters,
                M =
                  s === "or"
                    ? q.getDisjunctiveRefinements(a)
                    : q.getConjunctiveRefinements(a);
              return _m(
                se(
                  se({}, A),
                  {},
                  {
                    refinementList: se(
                      se({}, A.refinementList),
                      {},
                      gr({}, a, M),
                    ),
                  },
                ),
                a,
              );
            },
            getWidgetSearchParameters: function (A, C) {
              var q = C.uiState,
                M = s === "or";
              if (
                A.isHierarchicalFacet(a) ||
                (M && A.isConjunctiveFacet(a)) ||
                (!M && A.isDisjunctiveFacet(a))
              )
                return A;
              var K = q.refinementList && q.refinementList[a],
                Y = M
                  ? A.addDisjunctiveFacet(a).removeDisjunctiveFacetRefinement(a)
                  : A.addFacet(a).removeFacetRefinement(a),
                Z = Y.maxValuesPerFacet || 0,
                k = Math.max(Z, d ? u : f),
                z = Y.setQueryParameter("maxValuesPerFacet", k);
              if (!K) {
                var ee = M
                  ? "disjunctiveFacetsRefinements"
                  : "facetsRefinements";
                return z.setQueryParameters(
                  gr({}, ee, se(se({}, z[ee]), {}, gr({}, a, []))),
                );
              }
              return K.reduce(function (x, F) {
                return M
                  ? x.addDisjunctiveFacetRefinement(a, F)
                  : x.addFacetRefinement(a, F);
              }, z);
            },
          };
        }
      );
    };
  function _m(e, t) {
    return (
      e.refinementList &&
        ((!e.refinementList[t] || e.refinementList[t].length === 0) &&
          delete e.refinementList[t],
        Object.keys(e.refinementList).length === 0 && delete e.refinementList),
      e
    );
  }
  var Om = H("path", {
      d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z",
    }),
    wm = H("path", {
      d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z",
    }),
    Rm = H(
      "g",
      { fill: "none", "fill-rule": "evenodd" },
      H(
        "g",
        { transform: "translate(1 1)", "stroke-width": "2" },
        H("circle", { "stroke-opacity": ".5", cx: "18", cy: "18", r: "18" }),
        H(
          "path",
          { d: "M36 18c0-9.94-8.06-18-18-18" },
          H("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 18 18",
            to: "360 18 18",
            dur: "1s",
            repeatCount: "indefinite",
          }),
        ),
      ),
    ),
    jm = {
      reset: function (t) {
        var n = t.cssClasses;
        return H(
          "svg",
          {
            className: n.resetIcon,
            viewBox: "0 0 20 20",
            width: "10",
            height: "10",
            "aria-hidden": "true",
          },
          Om,
        );
      },
      submit: function (t) {
        var n = t.cssClasses;
        return H(
          "svg",
          {
            className: n.submitIcon,
            width: "10",
            height: "10",
            viewBox: "0 0 40 40",
            "aria-hidden": "true",
          },
          wm,
        );
      },
      loadingIndicator: function (t) {
        var n = t.cssClasses;
        return H(
          "svg",
          {
            "aria-label": "Results are loading",
            className: n.loadingIcon,
            width: "16",
            height: "16",
            viewBox: "0 0 38 38",
            stroke: "#444",
            "aria-hidden": "true",
          },
          Rm,
        );
      },
    },
    $m = {
      item: function (t) {
        var n = t.cssClasses,
          r = t.count,
          i = t.value,
          a = t.highlighted,
          o = t.isRefined,
          s = t.isFromSearch;
        return H(
          "label",
          { className: L(n.label) },
          H("input", {
            type: "checkbox",
            className: L(n.checkbox),
            value: i,
            defaultChecked: o,
          }),
          H(
            "span",
            {
              className: L(n.labelText),
              dangerouslySetInnerHTML: s ? { __html: a } : void 0,
            },
            !s && a,
          ),
          H("span", { className: L(n.count) }, Fs(r)),
        );
      },
      showMoreText: function (t) {
        var n = t.isShowingMore;
        return n ? "Show less" : "Show more";
      },
      searchableNoResults: function () {
        return "No results";
      },
    };
  function vr(e) {
    "@babel/helpers - typeof";
    return (
      (vr =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      vr(e)
    );
  }
  function iu(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function au(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? iu(Object(n), !0).forEach(function (r) {
            xm(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : iu(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function xm(e, t, n) {
    return (
      (t = Fm(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Fm(e) {
    var t = Em(e, "string");
    return vr(t) == "symbol" ? t : String(t);
  }
  function Em(e, t) {
    if (vr(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (vr(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Tm = Oe({ name: "refinement-list" }),
    we = Qe("RefinementList"),
    Ue = Qe("SearchBox"),
    Im = function (t) {
      var n = t.containerNode,
        r = t.cssClasses,
        i = t.templates,
        a = t.searchBoxTemplates,
        o = t.renderState,
        s = t.showMore,
        l = t.searchable,
        f = t.searchablePlaceholder,
        m = t.searchableIsAlwaysActive;
      return function (d, p) {
        var u = d.refine,
          c = d.items,
          g = d.createURL,
          v = d.searchForItems,
          h = d.isFromSearch,
          b = d.instantSearchInstance,
          S = d.toggleShowMore,
          O = d.isShowingMore,
          _ = d.hasExhaustiveItems,
          R = d.canToggleShowMore;
        if (p) {
          ((o.templateProps = ai({
            defaultTemplates: $m,
            templatesConfig: b.templatesConfig,
            templates: i,
          })),
            (o.searchBoxTemplateProps = ai({
              defaultTemplates: jm,
              templatesConfig: b.templatesConfig,
              templates: a,
            })));
          return;
        }
        Ve(
          H(Fo, {
            createURL: g,
            cssClasses: r,
            facetValues: c,
            templateProps: o.templateProps,
            searchBoxTemplateProps: o.searchBoxTemplateProps,
            toggleRefinement: u,
            searchFacetValues: l ? v : void 0,
            searchPlaceholder: f,
            searchIsAlwaysActive: m,
            isFromSearch: h,
            showMore: s && !h && c.length > 0,
            toggleShowMore: S,
            isShowingMore: O,
            hasExhaustiveItems: _,
            canToggleShowMore: R,
          }),
          n,
        );
      };
    },
    su = function (t) {
      var n = t || {},
        r = n.container,
        i = n.attribute,
        a = n.operator,
        o = n.sortBy,
        s = n.limit,
        l = n.showMore,
        f = n.showMoreLimit,
        m = n.searchable,
        d = m === void 0 ? !1 : m,
        p = n.searchablePlaceholder,
        u = p === void 0 ? "Search..." : p,
        c = n.searchableEscapeFacetValues,
        g = c === void 0 ? !0 : c,
        v = n.searchableIsAlwaysActive,
        h = v === void 0 ? !0 : v,
        b = n.cssClasses,
        S = b === void 0 ? {} : b,
        O = n.templates,
        _ = O === void 0 ? {} : O,
        R = n.transformItems;
      if (!r) throw new Error(Tm("The `container` option is required."));
      var $ = d ? !!g : !1,
        y = Et(r),
        P = {
          root: L(we(), S.root),
          noRefinementRoot: L(
            we({ modifierName: "noRefinement" }),
            S.noRefinementRoot,
          ),
          list: L(we({ descendantName: "list" }), S.list),
          item: L(we({ descendantName: "item" }), S.item),
          selectedItem: L(
            we({ descendantName: "item", modifierName: "selected" }),
            S.selectedItem,
          ),
          searchBox: L(we({ descendantName: "searchBox" }), S.searchBox),
          label: L(we({ descendantName: "label" }), S.label),
          checkbox: L(we({ descendantName: "checkbox" }), S.checkbox),
          labelText: L(we({ descendantName: "labelText" }), S.labelText),
          count: L(we({ descendantName: "count" }), S.count),
          noResults: L(we({ descendantName: "noResults" }), S.noResults),
          showMore: L(we({ descendantName: "showMore" }), S.showMore),
          disabledShowMore: L(
            we({ descendantName: "showMore", modifierName: "disabled" }),
            S.disabledShowMore,
          ),
          searchable: {
            root: L(Ue(), S.searchableRoot),
            form: L(Ue({ descendantName: "form" }), S.searchableForm),
            input: L(Ue({ descendantName: "input" }), S.searchableInput),
            submit: L(Ue({ descendantName: "submit" }), S.searchableSubmit),
            submitIcon: L(
              Ue({ descendantName: "submitIcon" }),
              S.searchableSubmitIcon,
            ),
            reset: L(Ue({ descendantName: "reset" }), S.searchableReset),
            resetIcon: L(
              Ue({ descendantName: "resetIcon" }),
              S.searchableResetIcon,
            ),
            loadingIndicator: L(
              Ue({ descendantName: "loadingIndicator" }),
              S.searchableLoadingIndicator,
            ),
            loadingIcon: L(
              Ue({ descendantName: "loadingIcon" }),
              S.searchableLoadingIcon,
            ),
          },
        },
        w = Im({
          containerNode: y,
          cssClasses: P,
          templates: _,
          searchBoxTemplates: {
            submit: _.searchableSubmit,
            reset: _.searchableReset,
            loadingIndicator: _.searchableLoadingIndicator,
          },
          renderState: {},
          searchable: d,
          searchablePlaceholder: u,
          searchableIsAlwaysActive: h,
          showMore: l,
        }),
        j = Pm(w, function () {
          return Ve(null, y);
        });
      return au(
        au(
          {},
          j({
            attribute: i,
            operator: a,
            limit: s,
            showMore: l,
            showMoreLimit: f,
            sortBy: o,
            escapeFacetValues: $,
            transformItems: R,
          }),
        ),
        {},
        { $$widgetType: "ais.refinementList" },
      );
    };
  function yr(e) {
    "@babel/helpers - typeof";
    return (
      (yr =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                typeof Symbol == "function" &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      yr(e)
    );
  }
  function ou(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      (t &&
        (r = r.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })),
        n.push.apply(n, r));
    }
    return n;
  }
  function Ge(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2
        ? ou(Object(n), !0).forEach(function (r) {
            Nm(e, r, n[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : ou(Object(n)).forEach(function (r) {
              Object.defineProperty(
                e,
                r,
                Object.getOwnPropertyDescriptor(n, r),
              );
            });
    }
    return e;
  }
  function Nm(e, t, n) {
    return (
      (t = Cm(t)),
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function Cm(e) {
    var t = Am(e, "string");
    return yr(t) == "symbol" ? t : String(t);
  }
  function Am(e, t) {
    if (yr(e) != "object" || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (n !== void 0) {
      var r = n.call(e, t);
      if (yr(r) != "object") return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Dm = Oe({ name: "search-box", connector: !0 }),
    Hm = function (t, n) {
      return n(t);
    },
    Lm = function (t) {
      var n =
        arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : he;
      return (
        jt(t, Dm()),
        function (r) {
          var i = r || {},
            a = i.queryHook,
            o = a === void 0 ? Hm : a,
            s,
            l;
          return {
            $$type: "ais.searchBox",
            init: function (m) {
              var d = m.instantSearchInstance;
              t(
                Ge(
                  Ge({}, this.getWidgetRenderState(m)),
                  {},
                  { instantSearchInstance: d },
                ),
                !0,
              );
            },
            render: function (m) {
              var d = m.instantSearchInstance;
              t(
                Ge(
                  Ge({}, this.getWidgetRenderState(m)),
                  {},
                  { instantSearchInstance: d },
                ),
                !1,
              );
            },
            dispose: function (m) {
              var d = m.state;
              return (n(), d.setQueryParameter("query", void 0));
            },
            getRenderState: function (m, d) {
              return Ge(
                Ge({}, m),
                {},
                { searchBox: this.getWidgetRenderState(d) },
              );
            },
            getWidgetRenderState: function (m) {
              var d = m.helper,
                p = m.instantSearchInstance,
                u = m.state;
              return (
                s ||
                  ((s = function (g) {
                    o(g, function (v) {
                      return d.setQuery(v).search();
                    });
                  }),
                  (l = function () {
                    d.setQuery("").search();
                  })),
                {
                  query: u.query || "",
                  refine: s,
                  clear: l,
                  widgetParams: r,
                  isSearchStalled: p.status === "stalled",
                }
              );
            },
            getWidgetUiState: function (m, d) {
              var p = d.searchParameters,
                u = p.query || "";
              return u === "" || (m && m.query === u)
                ? m
                : Ge(Ge({}, m), {}, { query: u });
            },
            getWidgetSearchParameters: function (m, d) {
              var p = d.uiState;
              return m.setQueryParameter("query", p.query || "");
            },
          };
        }
      );
    };
  function Mm(e) {
    var t;
    if (e.product_image) return e.product_image;
    if (e.image) return e.image;
    if (Array.isArray(e.images_info) && e.images_info.length) {
      const n = [...e.images_info].sort((r, i) => {
        const a = typeof r.position == "number" ? r.position : 9999,
          o = typeof i.position == "number" ? i.position : 9999;
        return a - o;
      })[0];
      if (n != null && n.src) return n.src;
    }
    return Array.isArray(e.images) && e.images.length
      ? e.images[0]
      : Array.isArray(e.variants) && (t = e.variants[0]) != null && t.image
        ? e.variants[0].image
        : (window == null ? void 0 : window.HUNA_PLACEHOLDER_IMAGE) ||
          "/files/placeholder.png";
  }
  function Wm(e) {
    return !e || !Array.isArray(e.color)
      ? ""
      : `
    <div class="t4s-variant-swatches" style="margin-top: 8px;">
      ${e.color
        .map(
          (t) => `
        <div class="t4s-variant-swatch" style="display:inline-block; margin-right: 6px;">
          <img src="${t.image}" alt="${t.name}" title="${t.name}"
               style="width: 20px; height: 20px; border-radius: 50%; border: 1px solid #ccc;" />
        </div>
      `,
        )
        .join("")}
    </div>
  `;
  }
  function qm({ refine: e }, t) {
    t &&
      requestAnimationFrame(() => {
        const r = document.querySelector("#instantsearch-price-input");
        if (r && t) {
          r.innerHTML = `
        <div class="mobile-price-filter">
          <input type="number" id="price-min" placeholder="Min" />
          <input type="number" id="price-max" placeholder="Max" />
          <button id="clear-price-filter">Clear</button>
        </div>
      `;
          const i = r.querySelector("#price-min"),
            a = r.querySelector("#price-max"),
            o = r.querySelector("#clear-price-filter"),
            s = () => {
              const l = parseFloat(i.value),
                f = parseFloat(a.value);
              e([isNaN(l) ? void 0 : l, isNaN(f) ? void 0 : f]);
            };
          (i.addEventListener("input", s),
            a.addEventListener("input", s),
            o.addEventListener("click", () => {
              ((i.value = ""), (a.value = ""), e([void 0, void 0]));
            }));
        }
      });
  }
  const Um = fu("L478JNSB2X", "c8d6508997a20211587a1547642deba1"),
    _t = je({
      indexName: "shopify_products",
      searchClient: Um,
      routing: {
        router: vs(),
        stateMapping: {
          stateToRoute(e) {
            var t;
            return {
              q: ((t = e.shopify_products) == null ? void 0 : t.query) || "",
            };
          },
          routeToState(e) {
            return { shopify_products: { query: e.q || "" } };
          },
        },
      },
    }),
    km = Lm(() => {}),
    Qm = qo(qm);
  (_t.addWidgets([
    km({}),
    fd({ hitsPerPage: 48, clickAnalytics: !0, analytics: !0 }),
    sp({
      container: "#instantsearch-hits",
      templates: {
        item(e) {
          var f, m;
          const t = Mm(e),
            n = e.vendor || "",
            r = e.price,
            i = e.compare_at_price,
            a =
              ((m = (f = e.meta) == null ? void 0 : f.custom) == null
                ? void 0
                : m.variant_display_data) || {},
            o = Wm(a),
            s = e.__queryID || "",
            l = e.objectID;
          // Start Vendor collection link
          const vendorName = e.vendor;
          const vendorHandle = vendorName.toLowerCase().replace(/\s+/g, "-");
          const vendorCollectionUrl = `/collections/${vendorHandle}`;
          const vendorDefaultUrl = `/collections/vendors?q=${encodeURIComponent(vendorName)}`;
          const collections = e.collections;
          /* To replace the default price with it. I add ${variantsMinPrice} instead of ${r}
              & Change the Price format */
          const variantsMinPrice = e.variants_min_price.toFixed(3);
          let vendorURL = vendorDefaultUrl;
          if (collections.includes(vendorHandle)) {
            vendorURL = vendorCollectionUrl;
          }
          // end
          // For the brand name object handling
          const brandName = e.meta.wk_brand_name ?? "";
          // End
          // Sale and discount badge
          const sale = ((e.price_ratio * 100)-100).toFixed(0);
          // Get the product and the default variant availability state from algolia APIs
          const inventoryIsAvailable = e.inventory_available;
          // Check if the product has In Stock variants or not
          const variantsIsAvailable = e.variants_inventory_count > 0 ? true: false;
                    // console.log(e);
          // End
          return ` 
<div
  class="bls__product-item scroll-trigger animate--slide-in label-rounded-2 square show__action-mobile"
  data-product-handle="${e.handle}"
  data-cascade=""
  style="--animation-order: "
>
  <div class="bls__product-img overflow-hidden relative pre-order-off">
    <div class="bls__product-label fs-12 pointer-events-none absolute">
    ${sale && sale != 0 ? `<div class="bls__sale-label">${sale}%</div>` : ""}
    ${!variantsIsAvailable? `<div class="bls__sold-out-label">Sold out</div>` : ""}
    </div>
    <a
      class="bls__img-url"
      href="/products/${e.handle}"
    >
      <div class="bls__product-main-img">
        <div
          class="bls__responsive-image bls-image-js bls__product-grid bls__product-img-sw"
          style="--aspect-ratio: 1/1"
        >
          <img
            srcset=""
            src="${t}"
            sizes="190px"
            alt="${e.title}"
            class="motion-reduce bls-loaded-image"
            loading="lazy"
            width="190"
            height="190"
            style="--point: 50% 50%"
          />
        </div></div
    ></a>
    <div class="bls__product-action d-flex">
      <div class="bls__product-action-inner flex">
        <button
          type="button"
          name="add"
          role="button"
          aria-label="button"
          class="btn-reset bls__product-wishlist bls__product-wishlist-js bls__product-action-btn-js bls_tooltip"
          data-pro-add-wishlist="Add to wishlist"
          data-pro-remove-wishlist="Browse wishlist"
          data-remove-wishlist="Remove from wishlist"
          data-custom-product-variant-id="${e.objectID}"
          data-product-handle="${e.handle}"
          data-action="remove"
        >
          <span class="bls__product-icon">
            <svg
              class="add-to-wishlist-icon"
              width="14"
              height="13"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.7441 2.26562C11.9993 2.52083 12.1908 2.8125 12.3184 3.14062C12.446 3.45964 12.5098 3.78776 12.5098 4.125C12.5098 4.46224 12.446 4.79492 12.3184 5.12305C12.1908 5.44206 11.9993 5.72917 11.7441 5.98438L7 10.7285L2.25586 5.98438C2.00065 5.72917 1.80924 5.44206 1.68164 5.12305C1.55404 4.79492 1.49023 4.46224 1.49023 4.125C1.49023 3.78776 1.55404 3.45964 1.68164 3.14062C1.80924 2.8125 2.00065 2.52083 2.25586 2.26562C2.51107 2.01042 2.79818 1.81901 3.11719 1.69141C3.44531 1.5638 3.77799 1.5 4.11523 1.5C4.45247 1.5 4.7806 1.5638 5.09961 1.69141C5.41862 1.81901 5.71029 2.01042 5.97461 2.26562L6.58984 2.88086C6.69922 2.99935 6.83594 3.05859 7 3.05859C7.16406 3.05859 7.30078 2.99935 7.41016 2.88086L8.02539 2.26562C8.28971 2.01042 8.58138 1.81901 8.90039 1.69141C9.2194 1.5638 9.54753 1.5 9.88477 1.5C10.222 1.5 10.5501 1.5638 10.8691 1.69141C11.1973 1.81901 11.4889 2.01042 11.7441 2.26562ZM12.5645 1.44531C12.1999 1.07161 11.7806 0.79362 11.3066 0.611328C10.8418 0.429036 10.3678 0.337891 9.88477 0.337891C9.40169 0.337891 8.92773 0.429036 8.46289 0.611328C7.99805 0.79362 7.57878 1.07161 7.20508 1.44531L7 1.65039L6.79492 1.44531C6.42122 1.07161 6.00195 0.79362 5.53711 0.611328C5.07227 0.429036 4.59831 0.337891 4.11523 0.337891C3.63216 0.337891 3.15365 0.429036 2.67969 0.611328C2.21484 0.79362 1.80013 1.07161 1.43555 1.44531C1.06185 1.8099 0.779297 2.22917 0.587891 2.70312C0.405599 3.16797 0.314453 3.64193 0.314453 4.125C0.314453 4.60807 0.405599 5.08659 0.587891 5.56055C0.779297 6.02539 1.06185 6.4401 1.43555 6.80469L6.58984 11.959C6.69922 12.0775 6.83594 12.1367 7 12.1367C7.16406 12.1367 7.30078 12.0775 7.41016 11.959L12.5645 6.80469C12.9382 6.4401 13.2161 6.02539 13.3984 5.56055C13.5898 5.08659 13.6855 4.60807 13.6855 4.125C13.6855 3.64193 13.5898 3.16797 13.3984 2.70312C13.2161 2.23828 12.9382 1.81901 12.5645 1.44531Z"
                fill="#111111"
              ></path>
            </svg>

            <svg
              class="remove-from-wishlist-icon"
              width="16"
              height="15"
              viewBox="0 0 16 15"
              fill="red"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 14.1562C7.8125 14.1562 7.65625 14.0885 7.53125 13.9531L1.64062 8.0625C1.21354 7.64583 0.890625 7.17188 0.671875 6.64062C0.463542 6.09896 0.359375 5.55208 0.359375 5C0.359375 4.44792 0.463542 3.90625 0.671875 3.375C0.890625 2.83333 1.21354 2.35417 1.64062 1.9375C2.05729 1.51042 2.53125 1.19271 3.0625 0.984375C3.60417 0.776042 4.15104 0.671875 4.70312 0.671875C5.25521 0.671875 5.79688 0.776042 6.32812 0.984375C6.85938 1.19271 7.33854 1.51042 7.76562 1.9375L8 2.17188L8.23438 1.9375C8.66146 1.51042 9.14062 1.19271 9.67188 0.984375C10.2031 0.776042 10.7448 0.671875 11.2969 0.671875C11.849 0.671875 12.3906 0.776042 12.9219 0.984375C13.4635 1.19271 13.9427 1.51042 14.3594 1.9375C14.7865 2.36458 15.1042 2.84375 15.3125 3.375C15.5312 3.90625 15.6406 4.44792 15.6406 5C15.6406 5.55208 15.5312 6.09896 15.3125 6.64062C15.1042 7.17188 14.7865 7.64583 14.3594 8.0625L8.46875 13.9531C8.34375 14.0885 8.1875 14.1562 8 14.1562Z"
              ></path>
            </svg>
          </span>
          <span class="bls_tooltip-content">Add to wishlist</span></button
        ><button
          type="button"
          name="add"
          role="button"
          aria-label="button"
          class="btn-reset bls__product-quickview bls_tooltip"
        >
          <span class="bls__product-icon">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.0683594 5.90234C0.0227865 5.98438 0 6.07096 0 6.16211C0 6.25326 0.0227865 6.33984 0.0683594 6.42188C0.0683594 6.42188 0.123047 6.52669 0.232422 6.73633C0.341797 6.93685 0.501302 7.19206 0.710938 7.50195C0.847656 7.69336 0.998047 7.90299 1.16211 8.13086C1.33529 8.34961 1.52669 8.57292 1.73633 8.80078C2.00065 9.08333 2.29232 9.36589 2.61133 9.64844C2.93945 9.93099 3.29492 10.1908 3.67773 10.4277C4.14258 10.7194 4.65299 10.9564 5.20898 11.1387C5.76497 11.321 6.36198 11.4121 7 11.4121C7.63802 11.4121 8.23503 11.321 8.79102 11.1387C9.34701 10.9564 9.85742 10.7194 10.3223 10.4277C10.7051 10.1908 11.056 9.93099 11.375 9.64844C11.7031 9.36589 11.9993 9.08333 12.2637 8.80078C12.4733 8.57292 12.6602 8.34961 12.8242 8.13086C12.9974 7.90299 13.1523 7.69336 13.2891 7.50195C13.4987 7.19206 13.6582 6.93685 13.7676 6.73633C13.877 6.52669 13.9316 6.42188 13.9316 6.42188C13.9772 6.34896 14 6.26693 14 6.17578C14 6.08464 13.9772 5.99349 13.9316 5.90234C13.9316 5.90234 13.877 5.80208 13.7676 5.60156C13.6582 5.39193 13.4987 5.13672 13.2891 4.83594C13.1523 4.64453 12.9974 4.43945 12.8242 4.2207C12.6602 3.99284 12.4733 3.76497 12.2637 3.53711C11.9993 3.25456 11.7031 2.97201 11.375 2.68945C11.056 2.4069 10.7051 2.14714 10.3223 1.91016C9.85742 1.61849 9.34701 1.38151 8.79102 1.19922C8.23503 1.00781 7.63802 0.912109 7 0.912109C6.36198 0.912109 5.76497 1.00781 5.20898 1.19922C4.65299 1.38151 4.14258 1.61849 3.67773 1.91016C3.29492 2.14714 2.93945 2.4069 2.61133 2.68945C2.29232 2.97201 2.00065 3.25456 1.73633 3.53711C1.52669 3.76497 1.33529 3.99284 1.16211 4.2207C0.998047 4.43945 0.847656 4.64453 0.710938 4.83594C0.501302 5.13672 0.341797 5.39193 0.232422 5.60156C0.123047 5.80208 0.0683594 5.90234 0.0683594 5.90234ZM1.24414 6.16211C1.29883 6.08008 1.35807 5.98438 1.42188 5.875C1.49479 5.75651 1.58138 5.62891 1.68164 5.49219C1.80013 5.31901 1.93685 5.13216 2.0918 4.93164C2.24674 4.73112 2.41536 4.5306 2.59766 4.33008C2.83464 4.06576 3.0944 3.81055 3.37695 3.56445C3.65951 3.31836 3.96484 3.09505 4.29297 2.89453C4.6849 2.64844 5.10417 2.45247 5.55078 2.30664C6.00651 2.16081 6.48958 2.08789 7 2.08789C7.51042 2.08789 7.98893 2.16081 8.43555 2.30664C8.89128 2.45247 9.3151 2.64844 9.70703 2.89453C10.0352 3.09505 10.3405 3.31836 10.623 3.56445C10.9056 3.81055 11.1654 4.06576 11.4023 4.33008C11.5846 4.5306 11.7533 4.73112 11.9082 4.93164C12.0632 5.13216 12.1999 5.31901 12.3184 5.49219C12.4186 5.62891 12.5007 5.75651 12.5645 5.875C12.6374 5.98438 12.7012 6.08008 12.7559 6.16211C12.7012 6.24414 12.6374 6.3444 12.5645 6.46289C12.5007 6.57227 12.4186 6.69987 12.3184 6.8457C12.1999 7.01888 12.0632 7.20573 11.9082 7.40625C11.7533 7.60677 11.5846 7.80729 11.4023 8.00781C11.1654 8.26302 10.9056 8.51367 10.623 8.75977C10.3405 9.00586 10.0352 9.23372 9.70703 9.44336C9.3151 9.68034 8.89128 9.8763 8.43555 10.0312C7.98893 10.1771 7.51042 10.25 7 10.25C6.48958 10.25 6.00651 10.1771 5.55078 10.0312C5.10417 9.8763 4.6849 9.68034 4.29297 9.44336C3.96484 9.23372 3.65951 9.00586 3.37695 8.75977C3.0944 8.51367 2.83464 8.26302 2.59766 8.00781C2.41536 7.80729 2.24674 7.60677 2.0918 7.40625C1.93685 7.20573 1.80013 7.01888 1.68164 6.8457C1.58138 6.69987 1.49479 6.57227 1.42188 6.46289C1.35807 6.3444 1.29883 6.24414 1.24414 6.16211ZM9.33789 6.16211C9.33789 5.8431 9.27409 5.54232 9.14648 5.25977C9.02799 4.97721 8.86393 4.73112 8.6543 4.52148C8.44466 4.31185 8.19401 4.14779 7.90234 4.0293C7.61979 3.90169 7.31901 3.83789 7 3.83789C6.68099 3.83789 6.37565 3.90169 6.08398 4.0293C5.80143 4.14779 5.55534 4.31185 5.3457 4.52148C5.13607 4.73112 4.96745 4.97721 4.83984 5.25977C4.72135 5.54232 4.66211 5.8431 4.66211 6.16211C4.66211 6.49023 4.72135 6.79557 4.83984 7.07812C4.96745 7.36068 5.13607 7.60677 5.3457 7.81641C5.55534 8.02604 5.80143 8.19466 6.08398 8.32227C6.37565 8.44076 6.68099 8.5 7 8.5C7.31901 8.5 7.61979 8.44076 7.90234 8.32227C8.19401 8.19466 8.44466 8.02604 8.6543 7.81641C8.86393 7.60677 9.02799 7.36068 9.14648 7.07812C9.27409 6.79557 9.33789 6.49023 9.33789 6.16211ZM8.16211 6.16211C8.16211 6.32617 8.13021 6.48112 8.06641 6.62695C8.01172 6.76367 7.92969 6.88672 7.82031 6.99609C7.72005 7.09635 7.59701 7.17839 7.45117 7.24219C7.31445 7.30599 7.16406 7.33789 7 7.33789C6.83594 7.33789 6.68099 7.30599 6.53516 7.24219C6.39844 7.17839 6.27995 7.09635 6.17969 6.99609C6.07031 6.88672 5.98372 6.76367 5.91992 6.62695C5.86523 6.48112 5.83789 6.32617 5.83789 6.16211C5.83789 6.00716 5.86523 5.86133 5.91992 5.72461C5.98372 5.57878 6.07031 5.45117 6.17969 5.3418C6.27995 5.23242 6.39844 5.15039 6.53516 5.0957C6.68099 5.0319 6.83594 5 7 5C7.16406 5 7.31445 5.0319 7.45117 5.0957C7.59701 5.15039 7.72005 5.23242 7.82031 5.3418C7.92969 5.45117 8.01172 5.57878 8.06641 5.72461C8.13021 5.86133 8.16211 6.00716 8.16211 6.16211Z"
                fill="#111111"
              ></path>
            </svg>
          </span>
          <span class="bls_tooltip-content">Quick view</span>
        </button>
      </div>
      ${inventoryIsAvailable ? `
      <quick-buy
        class="bls__product-addtocart bls__product-addtocart-js"
        data-product-variant-id="${e.objectID}"
       >
        <button
          class="bls__js-addtocart btn-secondary border-none button bls_tooltip button--full-width"
          type="button"
          name="add"
          role="button"
          aria-label="Add to Cart"
        >
          <span class="bls__product-icon">
            <svg
              width="15"
              height="13"
              viewBox="0 0 15 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.5454 11.3287C10.3922 11.3287 10.2452 11.2672 10.1369 11.1576C10.0285 11.048 9.96763 10.8994 9.96763 10.7444H8.81201C8.81201 11.2093 8.99464 11.6552 9.31972 11.984C9.6448 12.3128 10.0857 12.4975 10.5454 12.4975C11.0052 12.4975 11.4461 12.3128 11.7711 11.984C12.0962 11.6552 12.2789 11.2093 12.2789 10.7444H11.1232C11.1232 10.8994 11.0624 11.048 10.954 11.1576C10.8456 11.2672 10.6987 11.3287 10.5454 11.3287Z"
                fill="#111"
              ></path>
              <path
                d="M6.47907 11.3287C6.32583 11.3287 6.17886 11.2672 6.0705 11.1576C5.96214 11.048 5.90127 10.8994 5.90127 10.7444H4.74023C4.74023 10.9749 4.78514 11.2032 4.87238 11.4162C4.95962 11.6292 5.08748 11.8228 5.24868 11.9858C5.40988 12.1488 5.60125 12.2782 5.81186 12.3664C6.02248 12.4546 6.24822 12.5 6.47618 12.5C6.70415 12.5 6.92989 12.4546 7.1405 12.3664C7.35112 12.2782 7.54249 12.1488 7.70368 11.9858C7.86488 11.8228 7.99275 11.6292 8.07999 11.4162C8.16723 11.2032 8.21213 10.9749 8.21213 10.7444H7.05652C7.05652 10.8993 6.99569 11.0479 6.88741 11.1575C6.77913 11.267 6.63225 11.3286 6.47907 11.3287Z"
                fill="#111"
              ></path>
              <path
                d="M14.0173 1.66048C13.9858 1.65506 13.9539 1.65237 13.9219 1.65244H4.67702C4.52377 1.65244 4.37681 1.71401 4.26845 1.8236C4.16009 1.93319 4.09921 2.08182 4.09921 2.23681C4.09921 2.39179 4.16009 2.54042 4.26845 2.65001C4.37681 2.7596 4.52377 2.82117 4.67702 2.82117H13.2398L13.087 3.74811L12.277 8.66477H4.73949L2.77495 3.74811L1.60308 0.840914C1.54111 0.70415 1.42937 0.596826 1.29113 0.541284C1.15289 0.485742 0.998786 0.486261 0.860911 0.542733C0.723035 0.599206 0.612007 0.70728 0.550938 0.844458C0.489868 0.981637 0.483464 1.13735 0.533058 1.27918L2.40407 5.9223L3.68102 9.34519C3.77528 9.63335 3.96993 9.83349 4.25088 9.83349H12.7663C12.9031 9.83356 13.0355 9.78452 13.14 9.6951C13.2444 9.60568 13.314 9.48168 13.3365 9.34519L14.2589 3.74811L14.4921 2.33286C14.5173 2.18001 14.4814 2.02331 14.3924 1.89722C14.3033 1.77113 14.1684 1.68598 14.0173 1.66048Z"
                fill="#111"
              ></path>
            </svg> </span
          ><span class="bls_tooltip-content">Add to Cart</span>
          <span class="add-cart bls__button-content hidden-loading">
            Add to Cart
          </span>
        </button>
      </quick-buy>
      `: ""}
    </div>
  </div>
  <div class="bls__product-details pt-15">
    <div class="bls__product-vendor fs-small mt-5 mb-5"><a href="${vendorURL}">${brandName.mvm_brand_name??""}</a></div>
    <h3 class="bls__product-name regular mb-0">
      <a
        class="limited-line capitalize"
        style="--line-clamp: 2"
        href="/products/${e.handle}"
      >
        ${e.title}
      </a>
    </h3>

    <div class="bls__product-price mb-4">
      <div class="bls__price price--on-sale">
        <div class="bls__product-price flex flex-wrap align-items-center mt-3">
          <div class="price__regular">
            <span class="visually-hidden visually-hidden--inline"
              >Regular price</span
            >
            <span class="price special-price"> ${variantsMinPrice} JOD </span>
          </div>

          <div class="price__sale grey-color">
            <span class="visually-hidden visually-hidden--inline"
              >Sale price</span
            >
            <span>
              <s class="price-item compare-price">${i && i > r ? `${e.variants_compare_at_price_min.toFixed(3)} JOD` : ""}</s>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      style="text-transform: none; color: #505050; font-weight: bold"
      class="bls__product-vendor fs-small mt-5 mb-5"></div>

          <div id="instantsearch-color-list"></div>
  </div>
</div>
        `;
        },
      },
    }),
    wp({
      container: "#instantsearch-pagination",
      totalPages: 200,
      scrollTo: "#instantsearch-hits",
    }),
  ]),
    document.addEventListener("DOMContentLoaded", () => {
      (document.querySelector("#instantsearch-price-slider") &&
        _t.addWidgets([
          mm({
            container: "#instantsearch-price-slider",
            attribute: "price",
            tooltips: { format: (e) => `${e} JOD` },
          }),
        ]),
        document.querySelector("#instantsearch-price-input") &&
          _t.addWidgets([
            Qm({ container: "#instantsearch-price-input", attribute: "price" }),
          ]),
        document.querySelector("#instantsearch-vendor-list") &&
          _t.addWidgets([
            su({
              container: "#instantsearch-vendor-list",
              attribute: "vendor",
              limit: 10,
              showMore: !0,
              showMoreLimit: 50,
              sortBy: ["name:asc"],
              templates: {
                showMoreText(data) {
                  return data.isShowingMore ? "Show less" : "Show more";
                },
              },
            }),
          ]),
        document.querySelector("#instantsearch-color-list") &&
          _t.addWidgets([
            su({
              container: "#instantsearch-color-list",
              attribute: "meta.custom.color",
              limit: 10,
              showMore: !0,
              showMoreLimit: 50,
              sortBy: ["name:asc"],
              templates: {
                showMoreText(data) {
                  return data.isShowingMore ? "Show less" : "Show more";
                },
                item(e) {
                  const [t, n] = e.label.split("||");
                  return `
              <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;">
                <input type="checkbox" id="${(n || t)
                  .replace(/\s+/g, "-")
                  .toLowerCase()}" ${
                  e.isRefined ? "checked" : ""
                } style="margin: 0;" />
                <label for="${(n || t)
                  .replace(/\s+/g, "-")
                  .toLowerCase()}" style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                  <span class="color-swatch" style="background-color: ${t}; width: 14px; height: 14px; border-radius: 50%; display: inline-block; border: 1px solid #ccc;"></span>
                  <span>${n || t}</span>
                </label>
              </div>
            `;
                },
              },
            }),
          ]),
        _t.start());
    }));
  console.log("[HUNA] InstantSearch started ✅");
  setTimeout(() => {
    function filterHeading({ element, text, elementClass, divClass }) {
      const vendorListContainer = document.querySelector(`${element}`);
      vendorListContainer.insertAdjacentHTML(
        "beforebegin",
        `<div id="price-filter-header" class="filter-header ${divClass}">
        <i class="toggle-arrow fas fa-chevron-down"></i>
         <span class="${elementClass}">${text}</span>
         </div>`,
      );
    }
    // price
    filterHeading({
      element: "#instantsearch-pirce-container",
      elementClass: "price-filter-heading algolia-filter-heading",
      text: "Price",
    });
    // Vendor
    filterHeading({
      element: "#instantsearch-vendor-list",
      elementClass: "vendor-filter-heading algolia-filter-heading",
      divClass: "vendor-heading-filter",
      text: "Vendor",
    });
    // Colors
    filterHeading({
      element: "#instantsearch-color-list",
      elementClass: "color-filter-heading algolia-filter-heading",
      divClass: "color-filter-heading",
      text: "Colors",
    });
    // Filter Heading Toggles
    const filterHeaders = document.querySelectorAll(".filter-header");

    filterHeaders.forEach((header) => {
      // Initialize all filters as expanded by default
      const content = header.nextElementSibling;
      const arrow = header.querySelector(".toggle-arrow");

      header.addEventListener("click", function () {
        console.log("Toggling filter:", header.textContent.trim());

        // Toggle classes
        content.classList.toggle("collapsed");
        arrow.classList.toggle("collapsed");

        // For debugging - check classes after toggle
        console.log("Content classes:", content.className);
        console.log("Arrow classes:", arrow.className);
      });
    });
  }, 300);
  setTimeout(() => {
    // for hide the show more button & Filter Heading
    const vendorList = document.querySelector("#instantsearch-vendor-list");
    if (vendorList) {
      const vendorItems = vendorList.querySelectorAll(
        ".ais-RefinementList-item",
      );
      if (vendorItems.length < 10) {
        vendorList.setAttribute("data-hide-showmore", "true");
      }
      if (vendorItems.length === 0) {
        document.querySelector(".vendor-heading-filter").style.display = "none";
      }
    }
    const colorList = document.querySelector("#instantsearch-color-list");
    if (colorList) {
      const colorItems = colorList.querySelectorAll(".ais-RefinementList-item");
      if (colorItems.length < 10) {
        colorList.setAttribute("data-hide-showmore", "true");
      }
      if (colorItems.length === 0) {
        document.querySelector(".color-filter-heading").style.display = "none";
      }
    }
  }, 1000);
})();
//# sourceMappingURL=instantsearch-huna.js.map

// Fix Add to Cart for Algolia
document.addEventListener("click", function (e) {
  const btn = e.target.closest(
    '[data-atc-selector][data-stockButton="action-atc"]',
  );
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.variantId;
  const productId = btn.dataset.id;
  const productHandle = btn
    .closest("[data-vendor]")
    .querySelector('a[href*="/products/"]');

  if (!variantId) {
    if (productHandle) window.location.href = productHandle.href;
    return;
  }

  // Add loading
  btn.classList.add("loading");
  btn.disabled = true;
  const originalText = btn.textContent;

  // Add to cart
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
    .then((res) => {
      if (!res.ok) throw new Error("Failed");
      return res.json();
    })
    .then((data) => {
      console.log("Added:", data);

      btn.classList.remove("loading");
      btn.disabled = false;

      // Update cart
      fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) => {
          document
            .querySelectorAll("[data-cart-count], .cart-count")
            .forEach((el) => {
              el.textContent = cart.item_count;
            });

          // Open drawer
          const drawer = document.querySelector(
            "[data-cart-drawer], .t4s-cart-drawer, #t4s-mini_cart_js",
          );
          if (drawer) {
            drawer.classList.add("is-open", "active", "t4s-cart-open");
            document.body.classList.add("t4s-overflow-hidden", "open-cc");
          }

          document.dispatchEvent(new CustomEvent("cart:refresh"));
        });

      btn.textContent = "✓ Added";
      setTimeout(() => {
        btn.textContent = originalText;
      }, 2000);
    })
    .catch((error) => {
      console.error("Error:", error);
      btn.classList.remove("loading");
      btn.disabled = false;
      if (productHandle) window.location.href = productHandle.href;
    });
});
